"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: feature/feature.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ffeature%2Ffeature.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.TiersVariantTierUpsell = exports.TiersVariant = exports.WelcomeOfferVariant = exports.DynamicReferralCampaignsVariant = exports.PayOverTimeBorrowCashVariant = exports.SoloVsParentDecisionAgeVariant = exports.SuggestedTransferAmountVariantTransferFlowConfig = exports.SuggestedTransferAmountVariant = exports.StepBlackWaitlistVariant = exports.RequiredMinFundingAmountVariant = exports.HideSuggestedReferralsVariant = exports.QuizShareMessageVariant = exports.OnboardingQuizVariantFeedback = exports.OnboardingQuizVariantAnswer = exports.OnboardingQuizVariantQuestion = exports.OnboardingQuizVariant = exports.FeatureAssignment = exports.FeatureChangelog = exports.FeatureInfo = exports.AssignmentCounts = exports.FeatureRollout = exports.RequiredVersions = exports.LevelSetVariant = exports.Request3DSVariant = exports.VariantWebSponsorshipFundingSkipVariant = exports.VariantStocksTradingVariant = exports.VariantRefereeReminderRefereeReminderAttempt = exports.VariantRefereeReminder = exports.VariantTipping = exports.VariantInstantCashout = exports.VariantCancelMerchantInfoMerchantLinksEntry = exports.VariantCancelMerchantInfoMerchantHelpCenterArticleIdsEntry = exports.VariantCancelMerchantInfo = exports.VariantSubscriptionManagementMerchantHelpCenterArticleIdsEntry = exports.VariantSubscriptionManagement = exports.VariantMinFundingAmountFee = exports.VariantSponsorshipSmsCopy = exports.VariantSuggestedFriendInvites = exports.VariantTestVariant = exports.VariantEmptyVariant = exports.Variant = exports.FeatureDefinition = exports.CopyVariantCopyVariantGroup = exports.Birthday18OfferVariantEnrollmentType = exports.OnboardingStepBlackVariantOnboardingStepBlackMode = exports.ServerSideFullScreenModalVariantFullScreenModalType = exports.Request3DSVariantFrequency = exports.VariantWebSponsorshipFundingSkipVariantBehavior = exports.FeatureApplicability = exports.Feature = void 0;
exports.copyVariantCopyVariantGroupToJSON = exports.copyVariantCopyVariantGroupFromJSON = exports.birthday18OfferVariantEnrollmentTypeToJSON = exports.birthday18OfferVariantEnrollmentTypeFromJSON = exports.onboardingStepBlackVariantOnboardingStepBlackModeToJSON = exports.onboardingStepBlackVariantOnboardingStepBlackModeFromJSON = exports.serverSideFullScreenModalVariantFullScreenModalTypeToJSON = exports.serverSideFullScreenModalVariantFullScreenModalTypeFromJSON = exports.request3DSVariantFrequencyToJSON = exports.request3DSVariantFrequencyFromJSON = exports.variantWebSponsorshipFundingSkipVariantBehaviorToJSON = exports.variantWebSponsorshipFundingSkipVariantBehaviorFromJSON = exports.featureApplicabilityToJSON = exports.featureApplicabilityFromJSON = exports.featureToJSON = exports.featureFromJSON = exports.CopyVariant = exports.GigsMobileVariant = exports.EarnWithStepVariant = exports.DirectDepositUpdatesM1V2Variant = exports.SpinTheWheelVariant = exports.FriendsTriviaLeaderboardVariantInviteMessage = exports.FriendsTriviaLeaderboardVariant = exports.MoveMoneyV2Variant = exports.PotLateFeeVariant = exports.PotConfigurableAprVariant = exports.Birthday18OfferVariant = exports.TopMerchantsOnCardsScreenVariant = exports.DirectDepositUpdatesM1Variant = exports.AlloyJourneyVersionVariant = exports.OnboardingStepBlackVariant = exports.DirectDepositFundingRecommendationVariant = exports.MilestoneCtaOverrideVariantOverride = exports.MilestoneCtaOverrideVariant = exports.UnlockAppVariant = exports.DelayedReferralVariant = exports.RecurringPaymentVariant = exports.ServerSideFullScreenModalVariant = exports.AutoReloadVariant = exports.DirectDepositInOnboardingVariant = exports.SignupInterestSurveyVariant = exports.GiftCardVariant = exports.UserTierReferralCampaignVariantInviteMessage = exports.UserTierReferralCampaignVariantCampaignId = exports.UserTierReferralCampaignVariant = exports.EmancipationVariantEmancipationIntroEmancipationMessage = exports.EmancipationVariantEmancipationIntro = exports.EmancipationVariant = void 0;
const amount_1 = require("../common/amount");
const referral_invite_status_1 = require("../common/referral-invite-status");
const cancel_merchant_link_1 = require("./cancel-merchant-link");
const feature_extensions_1 = require("./feature-extensions");
const protobufPackage = 'com.step.feature.proto';
var Feature;
(function (Feature) {
    Feature["INVALID_FEATURE"] = "INVALID_FEATURE";
    /**
     * GET_A_CARD - User is able to get a card (no longer on the waitlist)
     *
     * @deprecated
     */
    Feature["GET_A_CARD"] = "GET_A_CARD";
    /**
     * REPORT_MERCHANT_LOCATION - User will be asked to share a location and if allowed, then report merchant location
     * on in-person purchases.
     */
    Feature["REPORT_MERCHANT_LOCATION"] = "REPORT_MERCHANT_LOCATION";
    /**
     * ACCOUNT_STATEMENTS - User Account Statements
     *
     * @deprecated
     */
    Feature["ACCOUNT_STATEMENTS"] = "ACCOUNT_STATEMENTS";
    /**
     * COACHING_MODALS - User can see coaching modals
     *
     * @deprecated
     */
    Feature["COACHING_MODALS"] = "COACHING_MODALS";
    /**
     * PERSONALIZED_COLOR - Settings: Personalized Color
     *
     * @deprecated
     */
    Feature["PERSONALIZED_COLOR"] = "PERSONALIZED_COLOR";
    /**
     * DARK_MODE - Settings: Enable Dark Mode
     *
     * @deprecated
     */
    Feature["DARK_MODE"] = "DARK_MODE";
    /**
     * ACH_ACCOUNT - User can see ACH account details if assigned.
     */
    Feature["ACH_ACCOUNT"] = "ACH_ACCOUNT";
    /**
     * CARD_DESIGN - Users can design their cards.
     *
     * @deprecated
     */
    Feature["CARD_DESIGN"] = "CARD_DESIGN";
    /**
     * TEEN_LINK_DEBIT_CARD - Sponsored teens can link a debit card.
     *
     * @deprecated
     */
    Feature["TEEN_LINK_DEBIT_CARD"] = "TEEN_LINK_DEBIT_CARD";
    /**
     * SPONSORSHIP_REQUEST_INCENTIVE - Incentives for teens to request sponsorship.
     *
     * @deprecated
     */
    Feature["SPONSORSHIP_REQUEST_INCENTIVE"] = "SPONSORSHIP_REQUEST_INCENTIVE";
    /**
     * REFERRALS - Referrals.
     */
    Feature["REFERRALS"] = "REFERRALS";
    /**
     * PERSONA_DOCUMENT_VERIFICATION - User is able to go through persona document verification flow kyc requires it.
     */
    Feature["PERSONA_DOCUMENT_VERIFICATION"] = "PERSONA_DOCUMENT_VERIFICATION";
    /**
     * RECURRING_TRANSFERS - Recurring transfers.
     *
     * @deprecated
     */
    Feature["RECURRING_TRANSFERS"] = "RECURRING_TRANSFERS";
    /**
     * LINK_ACH_ACCOUNT - Link external ACH accounts and initiate ACH transactions.
     *
     * @deprecated
     */
    Feature["LINK_ACH_ACCOUNT"] = "LINK_ACH_ACCOUNT";
    /**
     * DEVELOPER_UX - Show developer-only UX, like the dev menu.
     */
    Feature["DEVELOPER_UX"] = "DEVELOPER_UX";
    /**
     * STEP_SQUAD - Show in-app Step Squad application flow
     *
     * @deprecated
     */
    Feature["STEP_SQUAD"] = "STEP_SQUAD";
    /**
     * STEP_SQUAD_MEMBER - User is a member of Step Squad
     *
     * @deprecated
     */
    Feature["STEP_SQUAD_MEMBER"] = "STEP_SQUAD_MEMBER";
    /**
     * APP_RATING - User is eligible to be prompted to rate the app
     */
    Feature["APP_RATING"] = "APP_RATING";
    /**
     * CUSTOM_PROFILE_PICTURE - User can upload custom profile picture
     *
     * @deprecated
     */
    Feature["CUSTOM_PROFILE_PICTURE"] = "CUSTOM_PROFILE_PICTURE";
    /**
     * SHOW_DECLINES - Users can see declined transactions
     *
     * @deprecated
     */
    Feature["SHOW_DECLINES"] = "SHOW_DECLINES";
    /**
     * ATM - Users can see ATM functionality
     *
     * @deprecated
     */
    Feature["ATM"] = "ATM";
    /**
     * SHOW_RECURRING_PAYMENTS_MORE_OFTEN - Show the recurring payments prompt more often
     *
     * @deprecated
     */
    Feature["SHOW_RECURRING_PAYMENTS_MORE_OFTEN"] = "SHOW_RECURRING_PAYMENTS_MORE_OFTEN";
    /**
     * SSN_LAST_4_DIGITS - User enters the last 4 digits of SSN only
     *
     * @deprecated
     */
    Feature["SSN_LAST_4_DIGITS"] = "SSN_LAST_4_DIGITS";
    /**
     * DELAYED_REFERRAL_REDEMPTION - Delay referral code redemption until the user is KYC'ed or sponsored
     *
     * @deprecated
     */
    Feature["DELAYED_REFERRAL_REDEMPTION"] = "DELAYED_REFERRAL_REDEMPTION";
    /**
     * REVERSE_CARD_COLORS - Reverse the card colours from (blue, pink, yellow) to (yellow, pink, blue)
     *
     * @deprecated
     */
    Feature["REVERSE_CARD_COLORS"] = "REVERSE_CARD_COLORS";
    /**
     * VALIDATE_SHIPPING_ADDRESS - Validate whether the shipping address is a valid USPS address
     *
     * @deprecated
     */
    Feature["VALIDATE_SHIPPING_ADDRESS"] = "VALIDATE_SHIPPING_ADDRESS";
    /**
     * EMAIL_BASED_RECOVERY - User can use email for account recovery
     *
     * @deprecated
     */
    Feature["EMAIL_BASED_RECOVERY"] = "EMAIL_BASED_RECOVERY";
    /**
     * VIRTUAL_CARD - Enable users to get a card number they can use online as soon as card is issued
     *
     * @deprecated
     */
    Feature["VIRTUAL_CARD"] = "VIRTUAL_CARD";
    /**
     * RETRYABLE_KYC - Allow users to fix errors during KYC
     */
    Feature["RETRYABLE_KYC"] = "RETRYABLE_KYC";
    /**
     * SSO - Allow users to use Google sign in or Apple sign in instead of verifying their email
     *
     * @deprecated
     */
    Feature["SSO"] = "SSO";
    /**
     * SSO_V2 - SSO feature with fixes to send email to Alloy
     */
    Feature["SSO_V2"] = "SSO_V2";
    /**
     * EXPERIMENTAL - Features that are experimental/unstable and need to be turned off on dev
     */
    Feature["EXPERIMENTAL"] = "EXPERIMENTAL";
    /**
     * POST_SIGNUP_SSO - Allow users to sign in with Google/Apple and verify email after signing up
     *
     * @deprecated
     */
    Feature["POST_SIGNUP_SSO"] = "POST_SIGNUP_SSO";
    /**
     * EDITABLE_PROFILE - User can edit phone, date of birth, and shipping address
     */
    Feature["EDITABLE_PROFILE"] = "EDITABLE_PROFILE";
    /**
     * REPLACE_CARD_NAME_CHANGE - More options to replace a card: "never received", "change the name", "other"
     *
     * @deprecated
     */
    Feature["REPLACE_CARD_NAME_CHANGE"] = "REPLACE_CARD_NAME_CHANGE";
    /**
     * WARNING_SMS_OTP_MESSAGE - User receives strong warning to not share SMS OTPs.
     *
     * @deprecated
     */
    Feature["WARNING_SMS_OTP_MESSAGE"] = "WARNING_SMS_OTP_MESSAGE";
    /**
     * DEBIT_CARD_SCANNER - Allow user to scan debit cards for linking
     */
    Feature["DEBIT_CARD_SCANNER"] = "DEBIT_CARD_SCANNER";
    /**
     * CONTENT_CARDS_ONBOARDING - Show content cards for onboarding
     *
     * @deprecated
     */
    Feature["CONTENT_CARDS_ONBOARDING"] = "CONTENT_CARDS_ONBOARDING";
    /**
     * SYNC_CONTACTS - Sync device's contacts to Step
     */
    Feature["SYNC_CONTACTS"] = "SYNC_CONTACTS";
    /**
     * PARENT_HOMESCREEN - Allow user to see a parent homescreen
     *
     * @deprecated
     */
    Feature["PARENT_HOMESCREEN"] = "PARENT_HOMESCREEN";
    /**
     * AUTOMATED_TRANSACTION_DISPUTES - Allow users to dispute transactions via in app
     *
     * @deprecated
     */
    Feature["AUTOMATED_TRANSACTION_DISPUTES"] = "AUTOMATED_TRANSACTION_DISPUTES";
    /**
     * PLAID_LINK_OAUTH - Allow OAuth flow for Plaid ACH accounts linking
     */
    Feature["PLAID_LINK_OAUTH"] = "PLAID_LINK_OAUTH";
    /**
     * GET_STARTED_COPY - Change Onboarding start button text to "Sign Up or Log In"
     *
     * @deprecated
     */
    Feature["GET_STARTED_COPY"] = "GET_STARTED_COPY";
    /**
     * CASH_DEPOSIT - Allow user to deposit cash at POS
     *
     * @deprecated
     */
    Feature["CASH_DEPOSIT"] = "CASH_DEPOSIT";
    /**
     * IOS_APP_TRACKING - Show iOS users App Tracking opt-in
     *
     * @deprecated
     */
    Feature["IOS_APP_TRACKING"] = "IOS_APP_TRACKING";
    /**
     * REFERRAL_CODE_MANUAL_ENTRY - Allow manual referral code entry
     *
     * @deprecated
     */
    Feature["REFERRAL_CODE_MANUAL_ENTRY"] = "REFERRAL_CODE_MANUAL_ENTRY";
    /**
     * MONITOR_APP_NOT_RESPONDING - Monitor and report when app is not responding.
     *
     * @deprecated
     */
    Feature["MONITOR_APP_NOT_RESPONDING"] = "MONITOR_APP_NOT_RESPONDING";
    /**
     * ATM_PIN_WITHOUT_OTP - Set ATM PIN without OTP.
     *
     * @deprecated
     */
    Feature["ATM_PIN_WITHOUT_OTP"] = "ATM_PIN_WITHOUT_OTP";
    /**
     * VOICE_OTP - Allow user to get a phone call with their OTP
     *
     * @deprecated
     */
    Feature["VOICE_OTP"] = "VOICE_OTP";
    /**
     * DYNAMIC_REFERRAL_CAMPAIGNS - Allow user to see dynamic referral campaigns.
     * DS: Disabled but do not delete.
     */
    Feature["DYNAMIC_REFERRAL_CAMPAIGNS"] = "DYNAMIC_REFERRAL_CAMPAIGNS";
    /**
     * REIMBURSING_TRANSACTIONS - User can request or send money from tx detail view.
     *
     * @deprecated
     */
    Feature["REIMBURSING_TRANSACTIONS"] = "REIMBURSING_TRANSACTIONS";
    /**
     * FAMILY_MANAGEMENT - User can see family management functionality (e.g. add admins).
     *
     * @deprecated
     */
    Feature["FAMILY_MANAGEMENT"] = "FAMILY_MANAGEMENT";
    /**
     * REFERRAL_CONTACT_PICKER - Allow user to pick from contacts for referring friends
     *
     * @deprecated
     */
    Feature["REFERRAL_CONTACT_PICKER"] = "REFERRAL_CONTACT_PICKER";
    /**
     * RECURRING_PAYMENTS_V2 - V2 redesign of the recurring payments feature.
     *
     * @deprecated
     */
    Feature["RECURRING_PAYMENTS_V2"] = "RECURRING_PAYMENTS_V2";
    /**
     * APP_DIAGNOSTICS_BUG_REPORT - Use Shake silent reporting for diagnostics: https://www.shakebugs.com/docs/ios/silent-reports/
     */
    Feature["APP_DIAGNOSTICS_BUG_REPORT"] = "APP_DIAGNOSTICS_BUG_REPORT";
    /**
     * DATASTORE_LOAD_RANDOM_ERROR - Throw errors randomly when loading DataStores. Only for internal use.
     */
    Feature["DATASTORE_LOAD_RANDOM_ERROR"] = "DATASTORE_LOAD_RANDOM_ERROR";
    /**
     * REFERRAL_TRACKING - Allow user to track referrals
     *
     * @deprecated
     */
    Feature["REFERRAL_TRACKING"] = "REFERRAL_TRACKING";
    /**
     * REFERRAL_CELL_TOP - Show Earn Money above transactions on account screen
     *
     * @deprecated
     */
    Feature["REFERRAL_CELL_TOP"] = "REFERRAL_CELL_TOP";
    /**
     * REFERRAL_FAMILY_CELL - Show referral family cell
     *
     * @deprecated
     */
    Feature["REFERRAL_FAMILY_CELL"] = "REFERRAL_FAMILY_CELL";
    /**
     * WEB_SPONSOR_APPROVAL - Allow users to send web approval referral links, where KYC will be performed on the website
     *
     * @deprecated
     */
    Feature["WEB_SPONSOR_APPROVAL"] = "WEB_SPONSOR_APPROVAL";
    /**
     * SPONSOR_FREE_FUNDING - Teen can fund without a sponsor.
     */
    Feature["SPONSOR_FREE_FUNDING"] = "SPONSOR_FREE_FUNDING";
    /**
     * ATM_MAP_NATIVE - Show native ATM map instead of the Webview
     *
     * @deprecated
     */
    Feature["ATM_MAP_NATIVE"] = "ATM_MAP_NATIVE";
    /**
     * DIRECT_DEPOSIT_IMPROVED_SURFACING - Improved surfacing of the direct deposit account details screen
     */
    Feature["DIRECT_DEPOSIT_IMPROVED_SURFACING"] = "DIRECT_DEPOSIT_IMPROVED_SURFACING";
    /**
     * INVITES_WHEN_P2P - Allow users to invite people who are not on Step when sending / requesting money
     */
    Feature["INVITES_WHEN_P2P"] = "INVITES_WHEN_P2P";
    /**
     * TRANSFERS_V2 - Transfer money v2.
     *
     * @deprecated
     */
    Feature["TRANSFERS_V2"] = "TRANSFERS_V2";
    /**
     * GESTURE_BUG_REPORTING - Bug reporting form is opened when shaking device.
     */
    Feature["GESTURE_BUG_REPORTING"] = "GESTURE_BUG_REPORTING";
    /**
     * SILENT_BUG_REPORTING - Bug reports are created silently when needed.
     */
    Feature["SILENT_BUG_REPORTING"] = "SILENT_BUG_REPORTING";
    /**
     * P2P_FOR_NON_STEP_USERS_REQUEST - Allow users to request money from other users who are not on Step
     */
    Feature["P2P_FOR_NON_STEP_USERS_REQUEST"] = "P2P_FOR_NON_STEP_USERS_REQUEST";
    /**
     * P2P_FOR_NON_STEP_USERS_SEND - Allow users to send money to other users who are not on Step
     */
    Feature["P2P_FOR_NON_STEP_USERS_SEND"] = "P2P_FOR_NON_STEP_USERS_SEND";
    /**
     * ADVANCED_REFERRAL_CODE_SHARING - Allow users to use advanced referral code sharing options (eg Snapchat)
     *
     * @deprecated
     */
    Feature["ADVANCED_REFERRAL_CODE_SHARING"] = "ADVANCED_REFERRAL_CODE_SHARING";
    /**
     * LIGHT_MODE_HEADERS - Light mode headers: light mode no longer uses dark headers, except
     * during onboarding.
     *
     * @deprecated
     */
    Feature["LIGHT_MODE_HEADERS"] = "LIGHT_MODE_HEADERS";
    /**
     * NATIVE_HELP_CENTER - Native intercom help center instead of the webview.
     *
     * @deprecated
     */
    Feature["NATIVE_HELP_CENTER"] = "NATIVE_HELP_CENTER";
    /**
     * PAY_ME_PAGE - Show Pay Me page in the drawer
     *
     * @deprecated
     */
    Feature["PAY_ME_PAGE"] = "PAY_ME_PAGE";
    /**
     * EARLY_DIRECT_DEPOSIT - Allow users to receive future dated direct deposits right away
     */
    Feature["EARLY_DIRECT_DEPOSIT"] = "EARLY_DIRECT_DEPOSIT";
    /**
     * USER_RISK_EVALUATION - [server] In house risk model evaluation
     *
     * @deprecated
     */
    Feature["USER_RISK_EVALUATION"] = "USER_RISK_EVALUATION";
    /**
     * CASH_DEPOSIT_MAP - Show map with cash deposit locations.
     *
     * @deprecated
     */
    Feature["CASH_DEPOSIT_MAP"] = "CASH_DEPOSIT_MAP";
    /**
     * SAVINGS - Show savings tab and functionality
     */
    Feature["SAVINGS"] = "SAVINGS";
    /**
     * MULTIPLE_SPONSOR_INVITES - Teen can send multiple sponsor invites from one screen.
     *
     * @deprecated
     */
    Feature["MULTIPLE_SPONSOR_INVITES"] = "MULTIPLE_SPONSOR_INVITES";
    /**
     * IN_APP_LIMITS - Show account limits under Account Information.
     */
    Feature["IN_APP_LIMITS"] = "IN_APP_LIMITS";
    /**
     * ALLOW_MULTIPLE_COSPONSOR_INVITES - Allow migrating invites to be cosponsor invite after one of them accepts
     * invite.
     */
    Feature["ALLOW_MULTIPLE_COSPONSOR_INVITES"] = "ALLOW_MULTIPLE_COSPONSOR_INVITES";
    /**
     * SPLIT_SIGN_UP_AND_LOG_IN_FLOWS - Split Sign Up and Log In flows for user
     *
     * @deprecated
     */
    Feature["SPLIT_SIGN_UP_AND_LOG_IN_FLOWS"] = "SPLIT_SIGN_UP_AND_LOG_IN_FLOWS";
    /**
     * ACCOUNT_DELETION_PAGE - Show Account Deletion instructions
     */
    Feature["ACCOUNT_DELETION_PAGE"] = "ACCOUNT_DELETION_PAGE";
    /**
     * P2P_FOR_NON_STEP_PERSONALIZED_UI - Send personalized links, using pay-me-page design
     */
    Feature["P2P_FOR_NON_STEP_PERSONALIZED_UI"] = "P2P_FOR_NON_STEP_PERSONALIZED_UI";
    /**
     * P2P_FOR_NON_STEP_WEB_PAYMENT - Pay directly from the web page
     */
    Feature["P2P_FOR_NON_STEP_WEB_PAYMENT"] = "P2P_FOR_NON_STEP_WEB_PAYMENT";
    /**
     * CASH_DEPOSIT_FEE - Cash deposit with merchant collected fee
     *
     * @deprecated
     */
    Feature["CASH_DEPOSIT_FEE"] = "CASH_DEPOSIT_FEE";
    /**
     * BACKGROUND_TASK_MANAGER - Use the background task manager for processing contacts
     */
    Feature["BACKGROUND_TASK_MANAGER"] = "BACKGROUND_TASK_MANAGER";
    /**
     * FOOTER_DIVIDERS - Show footer dividers
     */
    Feature["FOOTER_DIVIDERS"] = "FOOTER_DIVIDERS";
    /**
     * STRIPE_ELEMENTS - Use Stripe React Native Elements for capturing debit card details
     */
    Feature["STRIPE_ELEMENTS"] = "STRIPE_ELEMENTS";
    /**
     * SPONSOR_MANAGED_ACCOUNTS - Sponsor-managed accounts available for parents.
     *
     * @deprecated
     */
    Feature["SPONSOR_MANAGED_ACCOUNTS"] = "SPONSOR_MANAGED_ACCOUNTS";
    /**
     * PERSONALIZE_GEN_LINK_WITH_APPSFLYER - Use AppsFlyer over Branch for personalized link generation.
     *
     * @deprecated
     */
    Feature["PERSONALIZE_GEN_LINK_WITH_APPSFLYER"] = "PERSONALIZE_GEN_LINK_WITH_APPSFLYER";
    /**
     * PERSONALIZE_PARAMS_WITH_APPSFLYER - Use AppsFlyer conversion params over Branch for personalization.
     *
     * @deprecated
     */
    Feature["PERSONALIZE_PARAMS_WITH_APPSFLYER"] = "PERSONALIZE_PARAMS_WITH_APPSFLYER";
    /**
     * SCHOOL_SELECTION - Add school selection to teen signup and account info.
     *
     * @deprecated
     */
    Feature["SCHOOL_SELECTION"] = "SCHOOL_SELECTION";
    /**
     * SKIP_SPONSOR_REQUEST - Skip sponsor request for sponsor free users.
     *
     * @deprecated
     */
    Feature["SKIP_SPONSOR_REQUEST"] = "SKIP_SPONSOR_REQUEST";
    /**
     * REFERRAL_PROMPT - Automatically display referral invite screen after certain actions.
     * This is the old version of SIGNUP_REFERRAL_PROMPT.
     *
     * @deprecated
     */
    Feature["REFERRAL_PROMPT"] = "REFERRAL_PROMPT";
    /**
     * REFERRAL_RECOMMENDATIONS - Add "Recommended Friends" section for referrals.
     *
     * @deprecated
     */
    Feature["REFERRAL_RECOMMENDATIONS"] = "REFERRAL_RECOMMENDATIONS";
    /**
     * P2P_PERSONALIZED_UI - Personalized send/request money landing pages.
     *
     * @deprecated
     */
    Feature["P2P_PERSONALIZED_UI"] = "P2P_PERSONALIZED_UI";
    /**
     * ATM_FEE_REIMBURSEMENT_QUOTA - Out-of-network ATM fee reimbursement quota.
     *
     * @deprecated
     */
    Feature["ATM_FEE_REIMBURSEMENT_QUOTA"] = "ATM_FEE_REIMBURSEMENT_QUOTA";
    /**
     * FUNDING_SHORTCUT_40 - Add new add money shortcuts to the sponsor’s family screen for each sponsee: $40.
     *
     * @deprecated
     */
    Feature["FUNDING_SHORTCUT_40"] = "FUNDING_SHORTCUT_40";
    /**
     * CARD_FUNDING_MIN_5 - Reject amounts below $5 for funding.
     */
    Feature["CARD_FUNDING_MIN_5"] = "CARD_FUNDING_MIN_5";
    /**
     * CARD_FUNDING_MIN_10 - Reject amounts below $10 for funding.
     */
    Feature["CARD_FUNDING_MIN_10"] = "CARD_FUNDING_MIN_10";
    /**
     * THIN_FILE_SUPPORT - Request full SSN number from thin file customers.
     */
    Feature["THIN_FILE_SUPPORT"] = "THIN_FILE_SUPPORT";
    /**
     * LIMIT_LEVEL_2_POST_KYC_CONTROL - Limit Level 2 Post KYC - Control
     */
    Feature["LIMIT_LEVEL_2_POST_KYC_CONTROL"] = "LIMIT_LEVEL_2_POST_KYC_CONTROL";
    /**
     * LIMIT_LEVEL_2_POST_KYC_TREATMENT - Limit Level 2 Post KYC - Treatment
     */
    Feature["LIMIT_LEVEL_2_POST_KYC_TREATMENT"] = "LIMIT_LEVEL_2_POST_KYC_TREATMENT";
    /**
     * SKIP_PAYFONE_VERIFICATION - Skip Payfone verification experiment
     *
     * @deprecated
     */
    Feature["SKIP_PAYFONE_VERIFICATION"] = "SKIP_PAYFONE_VERIFICATION";
    /**
     * POST_SPONSORSHIP_RECURRING_FUNDING_CTA - Post sponsorship coaching modal cta is recurring funding
     */
    Feature["POST_SPONSORSHIP_RECURRING_FUNDING_CTA"] = "POST_SPONSORSHIP_RECURRING_FUNDING_CTA";
    /**
     * ROUND_UP_TO_SAVINGS - Round-up purchases to savings
     *
     * @deprecated
     */
    Feature["ROUND_UP_TO_SAVINGS"] = "ROUND_UP_TO_SAVINGS";
    /**
     * SIGNUP_REFERRAL_PROMPT - Show a referral prompt after signup
     */
    Feature["SIGNUP_REFERRAL_PROMPT"] = "SIGNUP_REFERRAL_PROMPT";
    /**
     * POSITIVE_REFERRAL_PROMPT - Show a referral prompt after certain positive moments
     */
    Feature["POSITIVE_REFERRAL_PROMPT"] = "POSITIVE_REFERRAL_PROMPT";
    /**
     * PRE_SPONSORSHIP_PROFILE_PICTURE - Allow the user to set a profile picture before they request sponsorship
     */
    Feature["PRE_SPONSORSHIP_PROFILE_PICTURE"] = "PRE_SPONSORSHIP_PROFILE_PICTURE";
    /**
     * SAVINGS_ROUND_UP - Enable Savings Round Up
     */
    Feature["SAVINGS_ROUND_UP"] = "SAVINGS_ROUND_UP";
    /**
     * PENDING_REFERRAL_BONUS - Show the pending bonus a user will receive for a referral.
     */
    Feature["PENDING_REFERRAL_BONUS"] = "PENDING_REFERRAL_BONUS";
    /**
     * CREDIT_REPORTING_ADULT - Allow adults to enroll in and view their credit reporting.
     *
     * @deprecated
     */
    Feature["CREDIT_REPORTING_ADULT"] = "CREDIT_REPORTING_ADULT";
    /**
     * RECOMMENDED_REFERRAL_INVITES - Invite recommended referrals from the family and account screens.
     *
     * @deprecated
     */
    Feature["RECOMMENDED_REFERRAL_INVITES"] = "RECOMMENDED_REFERRAL_INVITES";
    /**
     * POSITIVE_REFERRAL_PROMPT_V2 - Show a referral prompt after additional positive moments.
     *
     * @deprecated
     */
    Feature["POSITIVE_REFERRAL_PROMPT_V2"] = "POSITIVE_REFERRAL_PROMPT_V2";
    /**
     * SKIP_GET_CARD - Skip designing and ordering a card during teen onboarding.
     *
     * @deprecated
     */
    Feature["SKIP_GET_CARD"] = "SKIP_GET_CARD";
    /**
     * SPONSORSHIP_SMS_COPY - Use different copy for the sponsorship request SMS.
     *
     * @deprecated
     */
    Feature["SPONSORSHIP_SMS_COPY"] = "SPONSORSHIP_SMS_COPY";
    /**
     * SKIP_PHONE_CONFIRMATION_MODAL - Skip the phone confirmation modal after entering a phone number.
     *
     * @deprecated
     */
    Feature["SKIP_PHONE_CONFIRMATION_MODAL"] = "SKIP_PHONE_CONFIRMATION_MODAL";
    /**
     * SPONSORSHIP_PRIMER_COPY - See updated copy for the sponsorship primer.
     * No impact. Turning off.
     *
     * @deprecated
     */
    Feature["SPONSORSHIP_PRIMER_COPY"] = "SPONSORSHIP_PRIMER_COPY";
    /**
     * ROLLING_BILLING - Run a billing job on a daily cadence.
     *
     * @deprecated
     */
    Feature["ROLLING_BILLING"] = "ROLLING_BILLING";
    /**
     * OVERDRAFT_PROTECTION - Enable Overdraft Protection
     *
     * @deprecated
     */
    Feature["OVERDRAFT_PROTECTION"] = "OVERDRAFT_PROTECTION";
    /**
     * SPONSOR_MANAGED_ACCOUNTS_GRADUATION - Enable Graduation flow for sponsor-managed accounts.
     *
     * @deprecated
     */
    Feature["SPONSOR_MANAGED_ACCOUNTS_GRADUATION"] = "SPONSOR_MANAGED_ACCOUNTS_GRADUATION";
    /**
     * LIMIT_LEVEL_2_RISK_SCORE - Limit Level 2 assigned due to the user's risk score.
     */
    Feature["LIMIT_LEVEL_2_RISK_SCORE"] = "LIMIT_LEVEL_2_RISK_SCORE";
    /**
     * EMANCIPATION - Enable Graduation flow for 18+ to leave their sponsor's family and become self KYCed
     */
    Feature["EMANCIPATION"] = "EMANCIPATION";
    /**
     * BUY_NOW_PAY_LATER - BNPL.
     */
    Feature["BUY_NOW_PAY_LATER"] = "BUY_NOW_PAY_LATER";
    /**
     * CRYPTO_REWARDS - Adult user can see/get crypto rewards.
     *
     * @deprecated
     */
    Feature["CRYPTO_REWARDS"] = "CRYPTO_REWARDS";
    /**
     * OFFERS_VIEW - View and enroll offers in the app.
     */
    Feature["OFFERS_VIEW"] = "OFFERS_VIEW";
    /**
     * SERVER_SIDE_SPONSORSHIP_INVITE - Send SMS for sponsorship invite from the server.
     * Also checked by the client.
     */
    Feature["SERVER_SIDE_SPONSORSHIP_INVITE"] = "SERVER_SIDE_SPONSORSHIP_INVITE";
    /**
     * SUGGESTED_FRIEND_INVITES - Experiments for suggested friend invites.
     */
    Feature["SUGGESTED_FRIEND_INVITES"] = "SUGGESTED_FRIEND_INVITES";
    /**
     * SKIP_SHIPPING_ADDRESS_FOR_CARD - Skip shipping address selection during onboarding.
     *
     * @deprecated
     */
    Feature["SKIP_SHIPPING_ADDRESS_FOR_CARD"] = "SKIP_SHIPPING_ADDRESS_FOR_CARD";
    /**
     * CRYPTO_REWARDS_FOR_TEENS - Teen can see/get crypto rewards.
     *
     * @deprecated
     */
    Feature["CRYPTO_REWARDS_FOR_TEENS"] = "CRYPTO_REWARDS_FOR_TEENS";
    /**
     * ECBSV - Push user to consent based identity verification with SSA
     */
    Feature["ECBSV"] = "ECBSV";
    /**
     * SERVER_SIDE_REFERRAL_INVITE - Send SMS for referral invite from the server.
     * Also checked on the client.
     */
    Feature["SERVER_SIDE_REFERRAL_INVITE"] = "SERVER_SIDE_REFERRAL_INVITE";
    /**
     * ADDITIONAL_CREDIT_REPORTING_REQUIREMENTS - Enforce Additional Credit Reporting Requirements
     *
     * @deprecated
     */
    Feature["ADDITIONAL_CREDIT_REPORTING_REQUIREMENTS"] = "ADDITIONAL_CREDIT_REPORTING_REQUIREMENTS";
    /**
     * CRYPTO_TRADING - User can buy crypto assets
     *
     * @deprecated
     */
    Feature["CRYPTO_TRADING"] = "CRYPTO_TRADING";
    /**
     * REPLACE_DECISION_WITH_DOB - Replaces the "I'm a Teen / Adult" decision screen with a DOB input.
     *
     * @deprecated
     */
    Feature["REPLACE_DECISION_WITH_DOB"] = "REPLACE_DECISION_WITH_DOB";
    /**
     * HIDE_LINK_ACCOUNT_ITEM_SUBTITLE - Hides the second line (subtitle) on the Link Account list items.
     * DS: done with it; rolled back to 0.
     */
    Feature["HIDE_LINK_ACCOUNT_ITEM_SUBTITLE"] = "HIDE_LINK_ACCOUNT_ITEM_SUBTITLE";
    /**
     * REFERRAL_RECOMMENDATIONS_SERVER_RANK - Recommended referral list is calculated by server's ranking computation
     *
     * @deprecated
     */
    Feature["REFERRAL_RECOMMENDATIONS_SERVER_RANK"] = "REFERRAL_RECOMMENDATIONS_SERVER_RANK";
    /**
     * CARD_REPLACEMENT_FEE - User must pay fee to replace card after reaching quota.
     */
    Feature["CARD_REPLACEMENT_FEE"] = "CARD_REPLACEMENT_FEE";
    /**
     * CHECK_DEPOSIT - User can deposit checks
     */
    Feature["CHECK_DEPOSIT"] = "CHECK_DEPOSIT";
    /**
     * CRYPTO_PARENTAL_CONTROLS - Parental controls are available for crypto.
     *
     * @deprecated
     */
    Feature["CRYPTO_PARENTAL_CONTROLS"] = "CRYPTO_PARENTAL_CONTROLS";
    /**
     * HELPER_CARD_CAROUSEL - User can see helper card carousels
     *
     * @deprecated
     */
    Feature["HELPER_CARD_CAROUSEL"] = "HELPER_CARD_CAROUSEL";
    /**
     * APP_START_PERFORMANCE_LOGGING - User's device shall instrument app start logging on subsequent starts.
     */
    Feature["APP_START_PERFORMANCE_LOGGING"] = "APP_START_PERFORMANCE_LOGGING";
    /**
     * CREDIT_MONITORING - User can enroll to see their credit score
     */
    Feature["CREDIT_MONITORING"] = "CREDIT_MONITORING";
    /**
     * STOCKS_TRADING - User can buy and sell stocks
     */
    Feature["STOCKS_TRADING"] = "STOCKS_TRADING";
    /**
     * OFFER_CRYPTOGIVEAWAY100OCT12 - Feature to control CRYPTOGIVEAWAY100OCT12 offer availability.
     *
     * @deprecated
     */
    Feature["OFFER_CRYPTOGIVEAWAY100OCT12"] = "OFFER_CRYPTOGIVEAWAY100OCT12";
    /**
     * SUBSCRIPTION_MANAGEMENT - See active subscriptions and block merchants.
     *
     * @deprecated
     */
    Feature["SUBSCRIPTION_MANAGEMENT"] = "SUBSCRIPTION_MANAGEMENT";
    /**
     * INSTANT_CASHOUT - Instant funds withdrawal to debit cards.
     */
    Feature["INSTANT_CASHOUT"] = "INSTANT_CASHOUT";
    /**
     * BNPL_PARTIAL_PAYMENT - Allow users to make partial payment for BNPL loans.
     */
    Feature["BNPL_PARTIAL_PAYMENT"] = "BNPL_PARTIAL_PAYMENT";
    /**
     * MILESTONE_REPORTING - Milestone reporting and CTA support
     */
    Feature["MILESTONE_REPORTING"] = "MILESTONE_REPORTING";
    /**
     * FRACTIONAL_LIMITS - Fractional limits
     *
     * @deprecated
     */
    Feature["FRACTIONAL_LIMITS"] = "FRACTIONAL_LIMITS";
    /**
     * ACCOUNT_SCREEN_WITH_SUGGESTED_FRIENDS - Show account screen with suggested friends
     *
     * @deprecated
     */
    Feature["ACCOUNT_SCREEN_WITH_SUGGESTED_FRIENDS"] = "ACCOUNT_SCREEN_WITH_SUGGESTED_FRIENDS";
    /**
     * SUGGESTED_FRIENDS_WITH_REFRESH - Allow users to refresh friend suggestions
     *
     * @deprecated
     */
    Feature["SUGGESTED_FRIENDS_WITH_REFRESH"] = "SUGGESTED_FRIENDS_WITH_REFRESH";
    /**
     * SUGGESTED_FRIENDS_WITH_DISMISS - Allow users to dismiss friend suggestions
     *
     * @deprecated
     */
    Feature["SUGGESTED_FRIENDS_WITH_DISMISS"] = "SUGGESTED_FRIENDS_WITH_DISMISS";
    /**
     * STREAMLINED_TRANSFERS - Use "streamlined transfer flow" when making a transfer.
     */
    Feature["STREAMLINED_TRANSFERS"] = "STREAMLINED_TRANSFERS";
    /**
     * CANCEL_MERCHANT_INFO - See cancellation instructions for certain merchant purchases.
     */
    Feature["CANCEL_MERCHANT_INFO"] = "CANCEL_MERCHANT_INFO";
    /**
     * UNSECURED_CARD - Allow users to create unsecured credit card account
     */
    Feature["UNSECURED_CARD"] = "UNSECURED_CARD";
    /**
     * USE_STRIPE_PAYMENT_INTENT - Use Stripe's PaymentIntent API instead of Charge
     */
    Feature["USE_STRIPE_PAYMENT_INTENT"] = "USE_STRIPE_PAYMENT_INTENT";
    /**
     * REQUEST_3DS - Request 3DS/SCA for card funding
     */
    Feature["REQUEST_3DS"] = "REQUEST_3DS";
    /**
     * MERCHANT_BLOCKING - Allow users to block merchants for blockable transactions.
     */
    Feature["MERCHANT_BLOCKING"] = "MERCHANT_BLOCKING";
    /**
     * CREDIT_MONITORING_GRAPH - Allow users to see credit monitoring graph.
     */
    Feature["CREDIT_MONITORING_GRAPH"] = "CREDIT_MONITORING_GRAPH";
    /**
     * TIPPING - Allow users to tip
     */
    Feature["TIPPING"] = "TIPPING";
    /**
     * PAY_OVER_TIME - Pay over time: BNPL V2 flag.
     *
     * @deprecated
     */
    Feature["PAY_OVER_TIME"] = "PAY_OVER_TIME";
    /**
     * STEP_EMPLOYEE - Indicates if a user is a Step employee
     */
    Feature["STEP_EMPLOYEE"] = "STEP_EMPLOYEE";
    /**
     * BLOCK_FOREIGN_CHARGES - Enable blocking of foreign/international charges by default.
     */
    Feature["BLOCK_FOREIGN_CHARGES"] = "BLOCK_FOREIGN_CHARGES";
    /**
     * ONBOARDING_FLOW_REFACTOR - Onboarding flow refactor flag.
     *
     * @deprecated
     */
    Feature["ONBOARDING_FLOW_REFACTOR"] = "ONBOARDING_FLOW_REFACTOR";
    /**
     * WEB_SPONSORSHIP_PERSONALIZATION - Enable personalization (name) on web sponsor request page
     *
     * @deprecated
     */
    Feature["WEB_SPONSORSHIP_PERSONALIZATION"] = "WEB_SPONSORSHIP_PERSONALIZATION";
    /**
     * WEB_SPONSORSHIP_FUNDING - Enable funding in the web sponsorship flow
     */
    Feature["WEB_SPONSORSHIP_FUNDING"] = "WEB_SPONSORSHIP_FUNDING";
    /**
     * CREDIT_MONITORING_ADVERSE_ACTION_CODES - Allow users to see credit monitoring adverse action codes.
     */
    Feature["CREDIT_MONITORING_ADVERSE_ACTION_CODES"] = "CREDIT_MONITORING_ADVERSE_ACTION_CODES";
    /**
     * STEP_BACK_ANNUAL - Enable step back annual report
     */
    Feature["STEP_BACK_ANNUAL"] = "STEP_BACK_ANNUAL";
    /**
     * REFEREE_REMINDER - [server] Enable referee reminder
     * TODO: Deprecate and move variant to config
     */
    Feature["REFEREE_REMINDER"] = "REFEREE_REMINDER";
    /**
     * WEB_SPONSORSHIP_VALUE_PROPS - Display reviews and value props during login steps instead of images
     *
     * @deprecated
     */
    Feature["WEB_SPONSORSHIP_VALUE_PROPS"] = "WEB_SPONSORSHIP_VALUE_PROPS";
    /**
     * WRONG_LOGIN_FLOW_SIGNUP - Client feature to allow users to sign up from the login flow.
     *
     * @deprecated
     */
    Feature["WRONG_LOGIN_FLOW_SIGNUP"] = "WRONG_LOGIN_FLOW_SIGNUP";
    /**
     * AA_FAMILY - A/A Experiments (https://www.optimizely.com/optimization-glossary/aa-testing/)
     */
    Feature["AA_FAMILY"] = "AA_FAMILY";
    Feature["AA_FAMILY_VARIANTS"] = "AA_FAMILY_VARIANTS";
    Feature["AA_USER"] = "AA_USER";
    Feature["AA_USER_VARIANTS"] = "AA_USER_VARIANTS";
    /**
     * OFFER_BUNDLES - Use new offer bundle structure for offers.
     */
    Feature["OFFER_BUNDLES"] = "OFFER_BUNDLES";
    /**
     * STOCKS_TRADING_M2 - M2 UI for buy and sell stocks.
     */
    Feature["STOCKS_TRADING_M2"] = "STOCKS_TRADING_M2";
    /**
     * HIDE_REFERRALS - Hide referrals on the family, account and onboarding screens.
     */
    Feature["HIDE_REFERRALS"] = "HIDE_REFERRALS";
    /**
     * WEB_SPONSORSHIP_FUNDING_SKIP - Show, hide, or warn on click for web sponsorship funding skip button
     */
    Feature["WEB_SPONSORSHIP_FUNDING_SKIP"] = "WEB_SPONSORSHIP_FUNDING_SKIP";
    /**
     * STOCKS_SEARCH_WITHOUT_ENROLLMENT - User can search assets without enrollment
     */
    Feature["STOCKS_SEARCH_WITHOUT_ENROLLMENT"] = "STOCKS_SEARCH_WITHOUT_ENROLLMENT";
    /**
     * POINTS - User can earn and redeem points
     */
    Feature["POINTS"] = "POINTS";
    /**
     * CARD_FUNDING_ACTION_ORDER - Put debit card funding in the first place in the list of funding sources link options.
     */
    Feature["CARD_FUNDING_ACTION_ORDER"] = "CARD_FUNDING_ACTION_ORDER";
    /**
     * SAVINGS_APY - User can see their savings APY and their last interest payment
     */
    Feature["SAVINGS_APY"] = "SAVINGS_APY";
    /**
     * TIERS - User can subscribe and manage their tier
     */
    Feature["TIERS"] = "TIERS";
    /**
     * SHOW_VIRTUAL_CARD_INTRO_VIDEO - Show virtual card intro video
     *
     * @deprecated
     */
    Feature["SHOW_VIRTUAL_CARD_INTRO_VIDEO"] = "SHOW_VIRTUAL_CARD_INTRO_VIDEO";
    /**
     * ONBOARDING_QUIZ - Show onboarding quiz
     */
    Feature["ONBOARDING_QUIZ"] = "ONBOARDING_QUIZ";
    /**
     * INVESTING_ACTIONS_IN_HELPER_CARDS - Investing actions in helper cards instead of banners
     */
    Feature["INVESTING_ACTIONS_IN_HELPER_CARDS"] = "INVESTING_ACTIONS_IN_HELPER_CARDS";
    /**
     * CUSTOM_CHECK_SCANNING - Custom scanning solution for Check Deposit
     */
    Feature["CUSTOM_CHECK_SCANNING"] = "CUSTOM_CHECK_SCANNING";
    /**
     * DIRECT_DEPOSIT_SWITCH - Allow users to enroll for direct deposit using the payroll service
     */
    Feature["DIRECT_DEPOSIT_SWITCH"] = "DIRECT_DEPOSIT_SWITCH";
    /**
     * ACCOUNT_PROGRESS - Display account progress list to user
     *
     * @deprecated
     */
    Feature["ACCOUNT_PROGRESS"] = "ACCOUNT_PROGRESS";
    /**
     * LESS_STRICT_PAYME - Less strict payme messaging
     */
    Feature["LESS_STRICT_PAYME"] = "LESS_STRICT_PAYME";
    /**
     * SUGGESTED_FRIENDS_NO_PREVIEW_DISMISS - Do not preview dismiss button on suggested friends module
     *
     * @deprecated
     */
    Feature["SUGGESTED_FRIENDS_NO_PREVIEW_DISMISS"] = "SUGGESTED_FRIENDS_NO_PREVIEW_DISMISS";
    /**
     * QUIZ_SHARE_MESSAGE - The message to share with a sponsor when a teen completes the onboarding quiz.
     */
    Feature["QUIZ_SHARE_MESSAGE"] = "QUIZ_SHARE_MESSAGE";
    /**
     * WEB_HOME_TEEN_BANKING - Copy changes on the step.com home page to include "Teen"
     */
    Feature["WEB_HOME_TEEN_BANKING"] = "WEB_HOME_TEEN_BANKING";
    /**
     * WEB_SPONSORSHIP_PREVIEW_IMAGE - Show a personalized open graph image for web sponsorship
     */
    Feature["WEB_SPONSORSHIP_PREVIEW_IMAGE"] = "WEB_SPONSORSHIP_PREVIEW_IMAGE";
    /**
     * CRYPTO_TAX_DOCUMENTS - User can see crypto tax documents.
     *
     * @deprecated
     */
    Feature["CRYPTO_TAX_DOCUMENTS"] = "CRYPTO_TAX_DOCUMENTS";
    /**
     * STEP_BLACK_WAITLIST - Allow users to join Step Black waitlist
     * Not used in the client
     *
     * @deprecated
     */
    Feature["STEP_BLACK_WAITLIST"] = "STEP_BLACK_WAITLIST";
    /**
     * STEP_BLACK_TIER - Allow users to purchase the Step Black tier
     * Not used in the client
     *
     * @deprecated
     */
    Feature["STEP_BLACK_TIER"] = "STEP_BLACK_TIER";
    /**
     * CARD_MANAGEMENT_V2 - Allow users to see the new Card Management UX
     */
    Feature["CARD_MANAGEMENT_V2"] = "CARD_MANAGEMENT_V2";
    /**
     * POINTS_OFFERS - User can enroll into points offers
     */
    Feature["POINTS_OFFERS"] = "POINTS_OFFERS";
    /**
     * NEW_APP_THEMES - Allow users to see the new app themes
     */
    Feature["NEW_APP_THEMES"] = "NEW_APP_THEMES";
    /**
     * STOCKS_GRADUATION - Sponsee enrolled in stock can graduate
     */
    Feature["STOCKS_GRADUATION"] = "STOCKS_GRADUATION";
    /**
     * SERVER_SIDE_ACCOUNT_PROGRESS - Use lifecycle service to fetch account progress cards
     *
     * @deprecated
     */
    Feature["SERVER_SIDE_ACCOUNT_PROGRESS"] = "SERVER_SIDE_ACCOUNT_PROGRESS";
    /**
     * CASH_BUNDLES - User can redeem cash bundles with their points.
     */
    Feature["CASH_BUNDLES"] = "CASH_BUNDLES";
    /**
     * STOCKS_DISCOVER - Allow users to see the stocks discover section
     */
    Feature["STOCKS_DISCOVER"] = "STOCKS_DISCOVER";
    /**
     * PUBLIC_PAY_ME_LINK - User will have a public pay-me link as a way to request money from non-step users.
     */
    Feature["PUBLIC_PAY_ME_LINK"] = "PUBLIC_PAY_ME_LINK";
    /**
     * POT_FIXED_APR - Use fixed APR for Pay Over Time
     *
     * @deprecated
     */
    Feature["POT_FIXED_APR"] = "POT_FIXED_APR";
    /**
     * AUTOCANCEL_STUCK_INSTANT_PAYOUTS - Auto cancel stuck instant payouts.
     */
    Feature["AUTOCANCEL_STUCK_INSTANT_PAYOUTS"] = "AUTOCANCEL_STUCK_INSTANT_PAYOUTS";
    /**
     * HIDE_SUGGESTED_REFERRALS - Hide the suggested referrals module after some time.
     * DS: With the release of the new tab navigation, we lost entry points
     * so we can't disable referrals anymore since it's the only place remaining.
     */
    Feature["HIDE_SUGGESTED_REFERRALS"] = "HIDE_SUGGESTED_REFERRALS";
    /**
     * CARD_FUNDING_RECEIPT_EMAIL - Email a card funding receipt to the user
     */
    Feature["CARD_FUNDING_RECEIPT_EMAIL"] = "CARD_FUNDING_RECEIPT_EMAIL";
    /**
     * REQUIRED_MIN_FUNDING_AMOUNT - Require some minimum amount to fund Step account.
     */
    Feature["REQUIRED_MIN_FUNDING_AMOUNT"] = "REQUIRED_MIN_FUNDING_AMOUNT";
    /**
     * POT_ESTIMATE_DATES - Use estimated due dates for Pay Over Time
     *
     * @deprecated
     */
    Feature["POT_ESTIMATE_DATES"] = "POT_ESTIMATE_DATES";
    /**
     * APP_TAB_NAVIGATION - Enable tab navigation.
     */
    Feature["APP_TAB_NAVIGATION"] = "APP_TAB_NAVIGATION";
    /**
     * PLATFORM_PAY_FUNDING - Enables Apple/Google Pay funding.
     */
    Feature["PLATFORM_PAY_FUNDING"] = "PLATFORM_PAY_FUNDING";
    /**
     * SUGGESTED_TRANSFER_AMOUNT - Suggested transfer amounts step for funding and transfers.
     */
    Feature["SUGGESTED_TRANSFER_AMOUNT"] = "SUGGESTED_TRANSFER_AMOUNT";
    /**
     * PHONE_NUMBER_TAKEOVER - Self-service to take ownership of the phone number.
     */
    Feature["PHONE_NUMBER_TAKEOVER"] = "PHONE_NUMBER_TAKEOVER";
    /**
     * SOLO_VS_PARENT_DECISION_AGE - The age to present the solo/parent decision screen to 18+ users.
     */
    Feature["SOLO_VS_PARENT_DECISION_AGE"] = "SOLO_VS_PARENT_DECISION_AGE";
    /**
     * NO_DESIGN_CARD_ONBOARDING - The onboarding flow without the card design.
     *
     * @deprecated
     */
    Feature["NO_DESIGN_CARD_ONBOARDING"] = "NO_DESIGN_CARD_ONBOARDING";
    /**
     * LOGIN_SIGNUP_IMPROVEMENTS - Login/signup changes to drive duplicate accounts creation rate down.
     *
     * @deprecated
     */
    Feature["LOGIN_SIGNUP_IMPROVEMENTS"] = "LOGIN_SIGNUP_IMPROVEMENTS";
    /**
     * PRIORITY_SHIPPING - Enable priority shipping for cards.
     */
    Feature["PRIORITY_SHIPPING"] = "PRIORITY_SHIPPING";
    /**
     * STEP_BLACK_LANDING_PAGE_OPTIMIZED_LAYOUT - Enable optimized layout for Step Black
     */
    Feature["STEP_BLACK_LANDING_PAGE_OPTIMIZED_LAYOUT"] = "STEP_BLACK_LANDING_PAGE_OPTIMIZED_LAYOUT";
    /**
     * CREDIT_PULL_CONSENT - Display a consent request for credit pull.
     *
     * @deprecated
     */
    Feature["CREDIT_PULL_CONSENT"] = "CREDIT_PULL_CONSENT";
    /**
     * POT_BORROW_CASH - Borrow cash using Pay Over Time.
     */
    Feature["POT_BORROW_CASH"] = "POT_BORROW_CASH";
    /**
     * WEB_SPONSORSHIP_ALLOWANCE - Enables sponsors to setup allowance in web sponsorship flow.
     */
    Feature["WEB_SPONSORSHIP_ALLOWANCE"] = "WEB_SPONSORSHIP_ALLOWANCE";
    /**
     * WEB_SPONSORSHIP_FUNDING_WALLET_PAYMENTS - Enable users to use Apple / Google Pay in Web Sponsorship Funding Flow
     */
    Feature["WEB_SPONSORSHIP_FUNDING_WALLET_PAYMENTS"] = "WEB_SPONSORSHIP_FUNDING_WALLET_PAYMENTS";
    /**
     * WEB_SPONSORSHIP_FUNDING_RECOMMENDED_AMOUNT - Displays a recommended amount for funding in web sponsorship flow.
     */
    Feature["WEB_SPONSORSHIP_FUNDING_RECOMMENDED_AMOUNT"] = "WEB_SPONSORSHIP_FUNDING_RECOMMENDED_AMOUNT";
    /**
     * INVESTING_PORTFOLIO_PERFORMANCE - Display stocks investing portfolio performance in the app.
     */
    Feature["INVESTING_PORTFOLIO_PERFORMANCE"] = "INVESTING_PORTFOLIO_PERFORMANCE";
    /**
     * TRANSFER_DIRECTLY_FROM_BANK - Enable UI to encourage funding directly from their bank to Step
     */
    Feature["TRANSFER_DIRECTLY_FROM_BANK"] = "TRANSFER_DIRECTLY_FROM_BANK";
    /**
     * WEB_UNAUTHED_WALLET_PAYMENTS - Enable users to use Apple / Google Pay in Unauthenticated Web flows.
     */
    Feature["WEB_UNAUTHED_WALLET_PAYMENTS"] = "WEB_UNAUTHED_WALLET_PAYMENTS";
    /**
     * CLOSED_CRYPTO_ACCOUNTS - Show closed crypto accounts.
     *
     * @deprecated
     */
    Feature["CLOSED_CRYPTO_ACCOUNTS"] = "CLOSED_CRYPTO_ACCOUNTS";
    /**
     * CLOSED_STOCK_ACCOUNTS - Show closed stock accounts.
     */
    Feature["CLOSED_STOCK_ACCOUNTS"] = "CLOSED_STOCK_ACCOUNTS";
    /**
     * CRYPTO_CHARTS - Show charts and new flow for crypto.
     *
     * @deprecated
     */
    Feature["CRYPTO_CHARTS"] = "CRYPTO_CHARTS";
    /**
     * ENHANCED_PARENT_SAVINGS - Enable enhanced parent savings.
     */
    Feature["ENHANCED_PARENT_SAVINGS"] = "ENHANCED_PARENT_SAVINGS";
    /**
     * WEB_SPONSORSHIP_FIXED_APPROVE_BUTTON - Displays a fixed approve button on sponsor request page
     */
    Feature["WEB_SPONSORSHIP_FIXED_APPROVE_BUTTON"] = "WEB_SPONSORSHIP_FIXED_APPROVE_BUTTON";
    /**
     * CHECK_SCANNING_V2 - UrbanFT Contours Check Scanner
     */
    Feature["CHECK_SCANNING_V2"] = "CHECK_SCANNING_V2";
    /**
     * VISA_SIGNATURE - Support issuing Visa Signature cards for step black
     */
    Feature["VISA_SIGNATURE"] = "VISA_SIGNATURE";
    /**
     * INVESTING_ROUND_UPS - Enable round ups for investing
     */
    Feature["INVESTING_ROUND_UPS"] = "INVESTING_ROUND_UPS";
    /**
     * IOS_ONLY_OFFER - iOS only offer
     */
    Feature["IOS_ONLY_OFFER"] = "IOS_ONLY_OFFER";
    /**
     * DAILY_TRIVIA_LEADERBOARD - User can see and participate in the daily trivia leaderboard
     *
     * @deprecated
     */
    Feature["DAILY_TRIVIA_LEADERBOARD"] = "DAILY_TRIVIA_LEADERBOARD";
    /**
     * CRYPTO_ROUND_UPS - Round ups for crypto
     *
     * @deprecated
     */
    Feature["CRYPTO_ROUND_UPS"] = "CRYPTO_ROUND_UPS";
    /**
     * BORROW_APPLICATION_FLOW - Real time application flow for BNPL.
     *
     * @deprecated
     */
    Feature["BORROW_APPLICATION_FLOW"] = "BORROW_APPLICATION_FLOW";
    /**
     * USER_TIER_REFERRAL_CAMPAIGN - Enable referral campaigns per the user tier. A variant overrides default campaign IDs.
     */
    Feature["USER_TIER_REFERRAL_CAMPAIGN"] = "USER_TIER_REFERRAL_CAMPAIGN";
    /**
     * AUTO_PERFORMANCE_LOGGING - Automatic performance logging for all client pressables.
     */
    Feature["AUTO_PERFORMANCE_LOGGING"] = "AUTO_PERFORMANCE_LOGGING";
    /**
     * LEGAL_ADDRESS_PO_BOX_VALIDATION - Legal address PO Box validation
     */
    Feature["LEGAL_ADDRESS_PO_BOX_VALIDATION"] = "LEGAL_ADDRESS_PO_BOX_VALIDATION";
    /**
     * FAIL_KYC_ON_IDV_REQUIRED - Fail KYC instead of asking for identity verification for SSN validation.
     */
    Feature["FAIL_KYC_ON_IDV_REQUIRED"] = "FAIL_KYC_ON_IDV_REQUIRED";
    /**
     * UNLIMITED_REFERRALS - Allow a user to have unlimited referrals. Applicable to Step Employees, influencers, and affiliates.
     */
    Feature["UNLIMITED_REFERRALS"] = "UNLIMITED_REFERRALS";
    /**
     * POINTS_AS_DOLLARS_REFERRALS - Show dollar rewards for points referral campaigns.
     */
    Feature["POINTS_AS_DOLLARS_REFERRALS"] = "POINTS_AS_DOLLARS_REFERRALS";
    /**
     * GIFT_CARDS - Allow users to purchase gift cards
     */
    Feature["GIFT_CARDS"] = "GIFT_CARDS";
    /**
     * DATASTORE_CACHE_FAMILY_MEMBERS - FamilyMemberListStore.members cached.
     */
    Feature["DATASTORE_CACHE_FAMILY_MEMBERS"] = "DATASTORE_CACHE_FAMILY_MEMBERS";
    /**
     * ASYNC_PHYSICAL_CARD_ISSUING - Issue physical cards asynchronously with Stripe
     */
    Feature["ASYNC_PHYSICAL_CARD_ISSUING"] = "ASYNC_PHYSICAL_CARD_ISSUING";
    /**
     * SIGNUP_INTEREST_SURVEY - Show the interest survey during signup
     */
    Feature["SIGNUP_INTEREST_SURVEY"] = "SIGNUP_INTEREST_SURVEY";
    /**
     * DAILY_TRIVIA_REWARDS - User can see and participate in the daily trivia with rewards
     */
    Feature["DAILY_TRIVIA_REWARDS"] = "DAILY_TRIVIA_REWARDS";
    /**
     * SIGNUP_NEW_INTRO_SCREENS - Show the new intro screens during signup
     *
     * @deprecated
     */
    Feature["SIGNUP_NEW_INTRO_SCREENS"] = "SIGNUP_NEW_INTRO_SCREENS";
    /**
     * SOLO_ADULT_PRE_KYC_PREMIER - Show the pre-KYC premier for solo adults during signup
     *
     * @deprecated
     */
    Feature["SOLO_ADULT_PRE_KYC_PREMIER"] = "SOLO_ADULT_PRE_KYC_PREMIER";
    /**
     * HIGH_DPI_CARD_SIGNATURE - High-DPI card signature.
     */
    Feature["HIGH_DPI_CARD_SIGNATURE"] = "HIGH_DPI_CARD_SIGNATURE";
    /**
     * BNPL_CHECK_MLA - Enables MLA status check for PoT/BNPL.
     */
    Feature["BNPL_CHECK_MLA"] = "BNPL_CHECK_MLA";
    /**
     * NEW_NAVIGATION_HELPER_CARD - Show "New navigation" helper card.
     */
    Feature["NEW_NAVIGATION_HELPER_CARD"] = "NEW_NAVIGATION_HELPER_CARD";
    /**
     * ACCOUNT_PROGRESS_WITH_INCENTIVES - Account progress with incentives.
     *
     * @deprecated
     */
    Feature["ACCOUNT_PROGRESS_WITH_INCENTIVES"] = "ACCOUNT_PROGRESS_WITH_INCENTIVES";
    /**
     * RECURRING_PAYMENTS - Recurring payments are available for user.
     */
    Feature["RECURRING_PAYMENTS"] = "RECURRING_PAYMENTS";
    /**
     * PLATFORM_PAY_REQUIRE_ADDRESS - Require billing address for Apple/Google Pay funding.
     */
    Feature["PLATFORM_PAY_REQUIRE_ADDRESS"] = "PLATFORM_PAY_REQUIRE_ADDRESS";
    /**
     * DIRECT_DEPOSIT_IN_ONBOARDING - Add direct deposit to onboarding flow.
     *
     * @deprecated
     */
    Feature["DIRECT_DEPOSIT_IN_ONBOARDING"] = "DIRECT_DEPOSIT_IN_ONBOARDING";
    /**
     * NO_REFERRALS_ONBOARDING - Remove referrals from onboarding
     *
     * @deprecated
     */
    Feature["NO_REFERRALS_ONBOARDING"] = "NO_REFERRALS_ONBOARDING";
    /**
     * AUTO_RELOAD - Auto-reload is available for user.
     */
    Feature["AUTO_RELOAD"] = "AUTO_RELOAD";
    /**
     * PLOTLINE - Plotline (https://plotline.so) integration.
     */
    Feature["PLOTLINE"] = "PLOTLINE";
    /**
     * CRYPTO_ENROLL_AND_BUY - Enable crypto enrollment and purchase.
     *
     * @deprecated
     */
    Feature["CRYPTO_ENROLL_AND_BUY"] = "CRYPTO_ENROLL_AND_BUY";
    /**
     * CREDIT_REPORTING_BY_DEFAULT - Enroll in credit reporting by default.
     */
    Feature["CREDIT_REPORTING_BY_DEFAULT"] = "CREDIT_REPORTING_BY_DEFAULT";
    /**
     * APP_TAB_NAVIGATION_M2 - Navigation without drawer.
     */
    Feature["APP_TAB_NAVIGATION_M2"] = "APP_TAB_NAVIGATION_M2";
    /**
     * STEP_BLACK_V2 - Step Black Monthly Subscriptions
     */
    Feature["STEP_BLACK_V2"] = "STEP_BLACK_V2";
    /**
     * PREMIUM_V2_FEES - Fees associated with Premium V2 launch.
     */
    Feature["PREMIUM_V2_FEES"] = "PREMIUM_V2_FEES";
    /**
     * SOLO_ADULT_CONDITIONAL_PHYSICAL_CARD - Allow solo adult to order physical card until met certain conditions.
     *
     * @deprecated
     */
    Feature["SOLO_ADULT_CONDITIONAL_PHYSICAL_CARD"] = "SOLO_ADULT_CONDITIONAL_PHYSICAL_CARD";
    /**
     * COMBINED_BORROW_APPLICATION_FLOW - User is presented with a combined application flow for BNPL/Flex.
     *
     * @deprecated
     */
    Feature["COMBINED_BORROW_APPLICATION_FLOW"] = "COMBINED_BORROW_APPLICATION_FLOW";
    /**
     * NEW_LIMIT_LEVELS - For testing new limit levels
     */
    Feature["NEW_LIMIT_LEVELS"] = "NEW_LIMIT_LEVELS";
    /**
     * LLM_CHAT - LLM support chat powered by OpTech
     */
    Feature["LLM_CHAT"] = "LLM_CHAT";
    /**
     * BILL_PAY - Allow users to see the Bill pay feature
     */
    Feature["BILL_PAY"] = "BILL_PAY";
    /**
     * ACTIVITY_FEED_V2 - Client will render activity feed V2 instead of txactivity.
     */
    Feature["ACTIVITY_FEED_V2"] = "ACTIVITY_FEED_V2";
    /**
     * UNLOCK_APP - Client will require user to unlock app with biometrics or PIN.
     */
    Feature["UNLOCK_APP"] = "UNLOCK_APP";
    /**
     * MILESTONE_CTA_OVERRIDE - Milestone CTA override.
     */
    Feature["MILESTONE_CTA_OVERRIDE"] = "MILESTONE_CTA_OVERRIDE";
    /**
     * EMAIL_MAGIC_LINK - Opening mailbox by clicking on magic link button
     */
    Feature["EMAIL_MAGIC_LINK"] = "EMAIL_MAGIC_LINK";
    /**
     * BILL_PAY_M2 - Bill Pay Milestone 2.
     */
    Feature["BILL_PAY_M2"] = "BILL_PAY_M2";
    /**
     * NEW_NAV_M2_REFERRAL_ENTRY_POINTS - M2 Navigation new referral entry points
     *
     * @deprecated
     */
    Feature["NEW_NAV_M2_REFERRAL_ENTRY_POINTS"] = "NEW_NAV_M2_REFERRAL_ENTRY_POINTS";
    /**
     * SUSPICIOUS_TXN_SMS_CHALLENGE - Whether to send SMS fraud challenges for suspicious txns.
     */
    Feature["SUSPICIOUS_TXN_SMS_CHALLENGE"] = "SUSPICIOUS_TXN_SMS_CHALLENGE";
    /**
     * ONBOARDING_SERVICE_ONBOARD_API - Whether to use the new onboarding service for onboarding instead of user service.
     */
    Feature["ONBOARDING_SERVICE_ONBOARD_API"] = "ONBOARDING_SERVICE_ONBOARD_API";
    /**
     * UNLOCK_APP_DEFAULT_ON - Client will require user to unlock app with biometrics or PIN, with the setting applied on signup/recovery.
     */
    Feature["UNLOCK_APP_DEFAULT_ON"] = "UNLOCK_APP_DEFAULT_ON";
    /**
     * ML_FOR_ACH_REVIEW - Use an ML model to determine whether an ACH transaction needs review.
     *
     * @deprecated
     */
    Feature["ML_FOR_ACH_REVIEW"] = "ML_FOR_ACH_REVIEW";
    /**
     * FORCE_SMS_CHALLENGE - Force SMS fraud challenge.
     */
    Feature["FORCE_SMS_CHALLENGE"] = "FORCE_SMS_CHALLENGE";
    /**
     * NEW_DEVICE_LOGIN_NOTIFICATION - New device login notification.
     */
    Feature["NEW_DEVICE_LOGIN_NOTIFICATION"] = "NEW_DEVICE_LOGIN_NOTIFICATION";
    /**
     * ONBOARDING_JOURNEY_FLOW - Use the new Alloy Journey onboarding flow
     */
    Feature["ONBOARDING_JOURNEY_FLOW"] = "ONBOARDING_JOURNEY_FLOW";
    /**
     * ONBOARDING_FUNDING - Show funding during onboarding.
     */
    Feature["ONBOARDING_FUNDING"] = "ONBOARDING_FUNDING";
    /**
     * SIGNUP_INTEREST_BASED_KYC_PRIMER - Interest base KYC primer.
     */
    Feature["SIGNUP_INTEREST_BASED_KYC_PRIMER"] = "SIGNUP_INTEREST_BASED_KYC_PRIMER";
    Feature["PASSKEY_LOGIN"] = "PASSKEY_LOGIN";
    /**
     * ACCOUNT_PROGRESS_LANDING - Show account progress after onboarding.
     *
     * @deprecated
     */
    Feature["ACCOUNT_PROGRESS_LANDING"] = "ACCOUNT_PROGRESS_LANDING";
    /**
     * CRITICAL_ONLY_MAIN_SCREEN - Render critical only main screen while lazy loading everything else
     */
    Feature["CRITICAL_ONLY_MAIN_SCREEN"] = "CRITICAL_ONLY_MAIN_SCREEN";
    /**
     * ACCOUNT_PROGRESS_SERIES - Show account progress in series.
     */
    Feature["ACCOUNT_PROGRESS_SERIES"] = "ACCOUNT_PROGRESS_SERIES";
    /**
     * ACCOUNT_PROGRESS_INTEREST_BASED - Show account progress based on user onboarding interest survey choice.
     */
    Feature["ACCOUNT_PROGRESS_INTEREST_BASED"] = "ACCOUNT_PROGRESS_INTEREST_BASED";
    Feature["DIRECT_DEPOSIT_FUNDING_RECOMMENDATION"] = "DIRECT_DEPOSIT_FUNDING_RECOMMENDATION";
    Feature["FLEX_DUE_DATE"] = "FLEX_DUE_DATE";
    Feature["DISPUTES_INTAKE_REVAMP"] = "DISPUTES_INTAKE_REVAMP";
    Feature["STEP_BLACK_AS_DEFAULT_IN_AP"] = "STEP_BLACK_AS_DEFAULT_IN_AP";
    Feature["ACCOUNT_PROGRESS_STATUS_ICON"] = "ACCOUNT_PROGRESS_STATUS_ICON";
    Feature["PASSKEY_UPSELL_ON_LOGIN"] = "PASSKEY_UPSELL_ON_LOGIN";
    /**
     * @deprecated
     */
    Feature["LIFECYCLE_STORE_REFRESH_ON_LEDGER_UPDATE"] = "LIFECYCLE_STORE_REFRESH_ON_LEDGER_UPDATE";
    Feature["CREDIT_MONITORING_V2"] = "CREDIT_MONITORING_V2";
    Feature["CTA_STATUS_UPDATED_PN"] = "CTA_STATUS_UPDATED_PN";
    /**
     * BILL_PAY_M1_1 - Bill Pay Milestone 1.1: deduplicated online merchants.
     */
    Feature["BILL_PAY_M1_1"] = "BILL_PAY_M1_1";
    Feature["SERVER_SIDE_LEARN_MORE"] = "SERVER_SIDE_LEARN_MORE";
    Feature["CREDIT_HEALTH_BUILD_CREDIT_PROGRESS"] = "CREDIT_HEALTH_BUILD_CREDIT_PROGRESS";
    /**
     * @deprecated
     */
    Feature["BORROW_APPLICATION_DD"] = "BORROW_APPLICATION_DD";
    Feature["DIRECT_DEPOSIT_UPDATES_M1"] = "DIRECT_DEPOSIT_UPDATES_M1";
    Feature["MY_DIRECT_DEPOSIT"] = "MY_DIRECT_DEPOSIT";
    Feature["HIDE_BASIC_INTRO_IN_SB_FLOW"] = "HIDE_BASIC_INTRO_IN_SB_FLOW";
    /**
     * ONBOARDING_STEP_BLACK - Show Step Black during onboarding.
     */
    Feature["ONBOARDING_STEP_BLACK"] = "ONBOARDING_STEP_BLACK";
    /**
     * EMPLOYMENT_SURVEY - Show employment survey in account progress.
     */
    Feature["EMPLOYMENT_SURVEY"] = "EMPLOYMENT_SURVEY";
    /**
     * SARDINE_FRAUD_CHECK - Run Sardine Fraud check in Post KYC
     */
    Feature["SARDINE_FRAUD_CHECK"] = "SARDINE_FRAUD_CHECK";
    /**
     * CHECK_DEPOSIT_V2 - User can deposit checks with qualified direct deposit.
     */
    Feature["CHECK_DEPOSIT_V2"] = "CHECK_DEPOSIT_V2";
    Feature["MARKETPLACE_HELPER_CARD"] = "MARKETPLACE_HELPER_CARD";
    Feature["TOP_MERCHANTS_ON_CARDS_SCREEN"] = "TOP_MERCHANTS_ON_CARDS_SCREEN";
    Feature["MOVE_MONEY_V2"] = "MOVE_MONEY_V2";
    Feature["BORROW_APPLICATION_DD_BYPASS"] = "BORROW_APPLICATION_DD_BYPASS";
    Feature["SHARE_SCREENSHOT_BUTTON"] = "SHARE_SCREENSHOT_BUTTON";
    Feature["DIRECT_DEPOSIT_IN_PROGRESS_LIST"] = "DIRECT_DEPOSIT_IN_PROGRESS_LIST";
    Feature["BILL_PAY_IN_PROGRESS_LIST"] = "BILL_PAY_IN_PROGRESS_LIST";
    Feature["BIRTHDAY_18_OFFER"] = "BIRTHDAY_18_OFFER";
    Feature["POT_PAY_IN_ONE"] = "POT_PAY_IN_ONE";
    Feature["POT_CONFIGURABLE_APR"] = "POT_CONFIGURABLE_APR";
    Feature["POT_LATE_FEE"] = "POT_LATE_FEE";
    Feature["ACHIEVEMENTS"] = "ACHIEVEMENTS";
    Feature["CREDIT_LEADERBOARD"] = "CREDIT_LEADERBOARD";
    Feature["SOLO_ADULT_DIRECT_DEPOSIT_TO_ORDER_CARD"] = "SOLO_ADULT_DIRECT_DEPOSIT_TO_ORDER_CARD";
    Feature["DESIGN_SYSTEM_TEXT_STYLES"] = "DESIGN_SYSTEM_TEXT_STYLES";
    Feature["DESIGN_SYSTEM_COLORS"] = "DESIGN_SYSTEM_COLORS";
    Feature["DESIGN_SYSTEM_SPACING"] = "DESIGN_SYSTEM_SPACING";
    Feature["BRAZE_CREDIT_SCORE_CHANGED"] = "BRAZE_CREDIT_SCORE_CHANGED";
    Feature["BORROW_REGION_BYPASS"] = "BORROW_REGION_BYPASS";
    /**
     * @deprecated
     */
    Feature["BORROW_APPLICATION_QUESTIONS"] = "BORROW_APPLICATION_QUESTIONS";
    Feature["DD_TRACKER_ON_STEP_BLACK_SCREEN"] = "DD_TRACKER_ON_STEP_BLACK_SCREEN";
    Feature["FRIENDS_TRIVIA_LEADERBOARD"] = "FRIENDS_TRIVIA_LEADERBOARD";
    Feature["CLOSE_ACCOUNT_FLOW"] = "CLOSE_ACCOUNT_FLOW";
    Feature["SPIN_THE_WHEEL"] = "SPIN_THE_WHEEL";
    Feature["BORROW_APPLICATION_DD_CTAS"] = "BORROW_APPLICATION_DD_CTAS";
    /**
     * @deprecated
     */
    Feature["GIGS_MOBILE"] = "GIGS_MOBILE";
    Feature["MOBILE_PLANS"] = "MOBILE_PLANS";
    Feature["DIRECT_DEPOSIT_UPDATES_M1_V2"] = "DIRECT_DEPOSIT_UPDATES_M1_V2";
    Feature["ACH_AUTO_DECLINE"] = "ACH_AUTO_DECLINE";
    Feature["BRIDGE_MONEY"] = "BRIDGE_MONEY";
    Feature["RANDOMIZED_INTEREST_SURVEY"] = "RANDOMIZED_INTEREST_SURVEY";
    Feature["INTEREST_BASED_AP_M3"] = "INTEREST_BASED_AP_M3";
    Feature["TAX_FILING"] = "TAX_FILING";
    Feature["APP_START_NATIVE_LOGGING"] = "APP_START_NATIVE_LOGGING";
    Feature["VIRTUAL_DEBIT_CARDS_M1"] = "VIRTUAL_DEBIT_CARDS_M1";
    Feature["EXTERNAL_ACCOUNT_NICKNAME"] = "EXTERNAL_ACCOUNT_NICKNAME";
    Feature["SCAN_EXTERNAL_ACCOUNT"] = "SCAN_EXTERNAL_ACCOUNT";
    Feature["ONBOARDING_INTENT_TRIVIA_LEADERBOARD"] = "ONBOARDING_INTENT_TRIVIA_LEADERBOARD";
    Feature["ONBOARDING_INTENT_CREDIT_LEADERBOARD"] = "ONBOARDING_INTENT_CREDIT_LEADERBOARD";
    Feature["BUDGETING"] = "BUDGETING";
    Feature["SOLO_ADULT_UNCONDITIONAL_PHYSICAL_CARD_ORDER"] = "SOLO_ADULT_UNCONDITIONAL_PHYSICAL_CARD_ORDER";
    Feature["POT_PAY_IN_ONE_V2"] = "POT_PAY_IN_ONE_V2";
    Feature["EARN_WITH_STEP"] = "EARN_WITH_STEP";
    Feature["POT_PAY_IN_ONE_CREDIT_REPORTING"] = "POT_PAY_IN_ONE_CREDIT_REPORTING";
    Feature["ADD_CARD_POPUP"] = "ADD_CARD_POPUP";
    Feature["AP_POPUP_CONTINUOUS"] = "AP_POPUP_CONTINUOUS";
    Feature["STEP_BLACK_UPSELL_MODAL"] = "STEP_BLACK_UPSELL_MODAL";
    Feature["DISABLE_KYC_PREFILL"] = "DISABLE_KYC_PREFILL";
    Feature["DISPUTE_VROL_FLOW"] = "DISPUTE_VROL_FLOW";
    Feature["STEP_BLACK_AUTO_ENROLL"] = "STEP_BLACK_AUTO_ENROLL";
    Feature["LIMIT_LEVEL_SET"] = "LIMIT_LEVEL_SET";
    Feature["BRAZE_SB_FAILED_COMMS"] = "BRAZE_SB_FAILED_COMMS";
    /**
     * _TEST_USER - For testing features enabled at the user or user group level
     */
    Feature["_TEST_USER"] = "_TEST_USER";
    /**
     * _TEST_FAMILY - For testing features that have family cascade enabled
     */
    Feature["_TEST_FAMILY"] = "_TEST_FAMILY";
    /**
     * _TEST_FAMILY_INVITE - For testing features that have family invite cascade enabled
     */
    Feature["_TEST_FAMILY_INVITE"] = "_TEST_FAMILY_INVITE";
    /**
     * _TEST_PERCENTAGE - For testing features based on percentage rollout
     * Expected percent: 50
     */
    Feature["_TEST_PERCENTAGE"] = "_TEST_PERCENTAGE";
    /**
     * _TEST_REQUIRED_APP_VERSION - For testing features based on required app version
     * Expected required app versions:
     *  - android: 2.1.500-100
     *  - ios: 2.1.600-200
     */
    Feature["_TEST_REQUIRED_APP_VERSION"] = "_TEST_REQUIRED_APP_VERSION";
    /**
     * _TEST_REFERRAL - For testing features that have referral cascade enabled
     */
    Feature["_TEST_REFERRAL"] = "_TEST_REFERRAL";
    /**
     * _TEST_VARIANT - For testing variants
     */
    Feature["_TEST_VARIANT"] = "_TEST_VARIANT";
    /**
     * _TEST_ANOTHER_VARIANT - For testing variants
     */
    Feature["_TEST_ANOTHER_VARIANT"] = "_TEST_ANOTHER_VARIANT";
    /**
     * _TEST_USER_CREATED_AFTER_DATE - For testing user creation date filter
     */
    Feature["_TEST_USER_CREATED_AFTER_DATE"] = "_TEST_USER_CREATED_AFTER_DATE";
    /**
     * _TEST_ROLLED_OUT_FEATURE - For testing features that are fully rolled out
     */
    Feature["_TEST_ROLLED_OUT_FEATURE"] = "_TEST_ROLLED_OUT_FEATURE";
    /**
     * _TEST_VARIANT_WITH_REQUIRED_VERSION - For testing variants in combination with a required version
     * Expected required app versions:
     *  - android: 2.1.500-100
     *  - ios: 2.1.600-200
     */
    Feature["_TEST_VARIANT_WITH_REQUIRED_VERSION"] = "_TEST_VARIANT_WITH_REQUIRED_VERSION";
    /**
     * _TEST_UNAUTHENTICATED_FEATURE - For testing unauthenticated features
     * Expected percent: 100
     */
    Feature["_TEST_UNAUTHENTICATED_FEATURE"] = "_TEST_UNAUTHENTICATED_FEATURE";
    /**
     * _TEST_ALWAYS_APPLICABLE_FEATURE - For testing features applicable to unauthenticated and authenticated APIs
     * Expected percent: 100
     */
    Feature["_TEST_ALWAYS_APPLICABLE_FEATURE"] = "_TEST_ALWAYS_APPLICABLE_FEATURE";
    /**
     * _TEST_UNAUTHENTICATED_WITH_PERCENTAGE - For testing unauthenticated features based on percentage rollout
     * Expected percent: 50
     */
    Feature["_TEST_UNAUTHENTICATED_WITH_PERCENTAGE"] = "_TEST_UNAUTHENTICATED_WITH_PERCENTAGE";
    /**
     * _TEST_UNAUTHENTICATED_WITH_VARIANT - For testing unauthenticated features with variants
     * Expected percent: 50
     */
    Feature["_TEST_UNAUTHENTICATED_WITH_VARIANT"] = "_TEST_UNAUTHENTICATED_WITH_VARIANT";
    /**
     * _TEST_UNAUTHENTICATED_WITH_REQUIRED_APP_VERSION - For testing unauthenticated features based on required app version
     * Expected required app versions:
     *  - android: 2.1.500-100
     *  - ios: 2.1.600-200
     * Expected percent: 100
     */
    Feature["_TEST_UNAUTHENTICATED_WITH_REQUIRED_APP_VERSION"] = "_TEST_UNAUTHENTICATED_WITH_REQUIRED_APP_VERSION";
    /**
     * _TEST_SERVER_FEATURE - For testing server only features
     */
    Feature["_TEST_SERVER_FEATURE"] = "_TEST_SERVER_FEATURE";
    /**
     * _TEST_ROLLED_OUT_SERVER_FEATURE - For testing server only features that are fully rolled out
     * Expected percent: 100
     */
    Feature["_TEST_ROLLED_OUT_SERVER_FEATURE"] = "_TEST_ROLLED_OUT_SERVER_FEATURE";
    /**
     * _TEST_SERVER_WITH_PERCENTAGE - For testing server only features based on percentage rollout
     * Expected percent: 50
     */
    Feature["_TEST_SERVER_WITH_PERCENTAGE"] = "_TEST_SERVER_WITH_PERCENTAGE";
    /**
     * _TEST_SERVER_WITH_VARIANT - For testing server only features with a variant
     * Expected percent: 50
     */
    Feature["_TEST_SERVER_WITH_VARIANT"] = "_TEST_SERVER_WITH_VARIANT";
    Feature["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Feature || (exports.Feature = Feature = {}));
var FeatureApplicability;
(function (FeatureApplicability) {
    FeatureApplicability["INVALID_FEATURE_APPLICABILITY"] = "INVALID_FEATURE_APPLICABILITY";
    FeatureApplicability["UNAUTHENTICATED_ONLY"] = "UNAUTHENTICATED_ONLY";
    FeatureApplicability["ALWAYS"] = "ALWAYS";
    FeatureApplicability["AUTHENTICATED_ONLY"] = "AUTHENTICATED_ONLY";
    FeatureApplicability["SERVER_ONLY"] = "SERVER_ONLY";
    FeatureApplicability["UNRECOGNIZED"] = "UNRECOGNIZED";
})(FeatureApplicability || (exports.FeatureApplicability = FeatureApplicability = {}));
var VariantWebSponsorshipFundingSkipVariantBehavior;
(function (VariantWebSponsorshipFundingSkipVariantBehavior) {
    VariantWebSponsorshipFundingSkipVariantBehavior["INVALID_WEB_FUNDING_BEHAVIOR"] = "INVALID_WEB_FUNDING_BEHAVIOR";
    VariantWebSponsorshipFundingSkipVariantBehavior["WEB_FUNDING_ALLOW"] = "WEB_FUNDING_ALLOW";
    VariantWebSponsorshipFundingSkipVariantBehavior["WEB_FUNDING_WARN"] = "WEB_FUNDING_WARN";
    VariantWebSponsorshipFundingSkipVariantBehavior["WEB_FUNDING_DISALLOW"] = "WEB_FUNDING_DISALLOW";
    VariantWebSponsorshipFundingSkipVariantBehavior["UNRECOGNIZED"] = "UNRECOGNIZED";
})(VariantWebSponsorshipFundingSkipVariantBehavior || (exports.VariantWebSponsorshipFundingSkipVariantBehavior = VariantWebSponsorshipFundingSkipVariantBehavior = {}));
var Request3DSVariantFrequency;
(function (Request3DSVariantFrequency) {
    Request3DSVariantFrequency["REQUEST_3DS_INVALID"] = "REQUEST_3DS_INVALID";
    Request3DSVariantFrequency["REQUEST_3DS_NEVER"] = "REQUEST_3DS_NEVER";
    Request3DSVariantFrequency["REQUEST_3DS_ALWAYS"] = "REQUEST_3DS_ALWAYS";
    Request3DSVariantFrequency["REQUEST_3DS_RULE"] = "REQUEST_3DS_RULE";
    Request3DSVariantFrequency["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Request3DSVariantFrequency || (exports.Request3DSVariantFrequency = Request3DSVariantFrequency = {}));
var ServerSideFullScreenModalVariantFullScreenModalType;
(function (ServerSideFullScreenModalVariantFullScreenModalType) {
    ServerSideFullScreenModalVariantFullScreenModalType["INVALID_MODAL_TYPE"] = "INVALID_MODAL_TYPE";
    ServerSideFullScreenModalVariantFullScreenModalType["ADD_FUNDS"] = "ADD_FUNDS";
    ServerSideFullScreenModalVariantFullScreenModalType["ADD_FUNDS_SPONSORED_ACCOUNT"] = "ADD_FUNDS_SPONSORED_ACCOUNT";
    ServerSideFullScreenModalVariantFullScreenModalType["LINK_ACCOUNT"] = "LINK_ACCOUNT";
    ServerSideFullScreenModalVariantFullScreenModalType["FLEX_ALMOST_DUE_3"] = "FLEX_ALMOST_DUE_3";
    ServerSideFullScreenModalVariantFullScreenModalType["FLEX_DUE"] = "FLEX_DUE";
    ServerSideFullScreenModalVariantFullScreenModalType["FLEX_DUE_AUTO_PAY_FAILED"] = "FLEX_DUE_AUTO_PAY_FAILED";
    ServerSideFullScreenModalVariantFullScreenModalType["FLEX_AUTO_PAY_FAILED"] = "FLEX_AUTO_PAY_FAILED";
    ServerSideFullScreenModalVariantFullScreenModalType["FLEX_PAST_DUE"] = "FLEX_PAST_DUE";
    ServerSideFullScreenModalVariantFullScreenModalType["FLEX_PAST_DUE_60"] = "FLEX_PAST_DUE_60";
    ServerSideFullScreenModalVariantFullScreenModalType["ACCOUNT_PROGRESS_COMPLETED"] = "ACCOUNT_PROGRESS_COMPLETED";
    ServerSideFullScreenModalVariantFullScreenModalType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ServerSideFullScreenModalVariantFullScreenModalType || (exports.ServerSideFullScreenModalVariantFullScreenModalType = ServerSideFullScreenModalVariantFullScreenModalType = {}));
var OnboardingStepBlackVariantOnboardingStepBlackMode;
(function (OnboardingStepBlackVariantOnboardingStepBlackMode) {
    OnboardingStepBlackVariantOnboardingStepBlackMode["INVALID_ONBOARDING_STEP_BLACK_MODE"] = "INVALID_ONBOARDING_STEP_BLACK_MODE";
    OnboardingStepBlackVariantOnboardingStepBlackMode["ONBOARDING_STEP_BLACK_MODE_CONTROL"] = "ONBOARDING_STEP_BLACK_MODE_CONTROL";
    OnboardingStepBlackVariantOnboardingStepBlackMode["ONBOARDING_STEP_BLACK_MODE_VIRTUAL_CARD"] = "ONBOARDING_STEP_BLACK_MODE_VIRTUAL_CARD";
    OnboardingStepBlackVariantOnboardingStepBlackMode["ONBOARDING_STEP_BLACK_MODE_BILL_PAY"] = "ONBOARDING_STEP_BLACK_MODE_BILL_PAY";
    OnboardingStepBlackVariantOnboardingStepBlackMode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(OnboardingStepBlackVariantOnboardingStepBlackMode || (exports.OnboardingStepBlackVariantOnboardingStepBlackMode = OnboardingStepBlackVariantOnboardingStepBlackMode = {}));
var Birthday18OfferVariantEnrollmentType;
(function (Birthday18OfferVariantEnrollmentType) {
    Birthday18OfferVariantEnrollmentType["INVALID_ENROLLMENT_TYPE"] = "INVALID_ENROLLMENT_TYPE";
    Birthday18OfferVariantEnrollmentType["ENROLLMENT_TYPE_CONTROL"] = "ENROLLMENT_TYPE_CONTROL";
    Birthday18OfferVariantEnrollmentType["ENROLLMENT_TYPE_ACTIVE"] = "ENROLLMENT_TYPE_ACTIVE";
    Birthday18OfferVariantEnrollmentType["ENROLLMENT_TYPE_PASSIVE"] = "ENROLLMENT_TYPE_PASSIVE";
    Birthday18OfferVariantEnrollmentType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Birthday18OfferVariantEnrollmentType || (exports.Birthday18OfferVariantEnrollmentType = Birthday18OfferVariantEnrollmentType = {}));
var CopyVariantCopyVariantGroup;
(function (CopyVariantCopyVariantGroup) {
    CopyVariantCopyVariantGroup["INVALID_COPY_VARIANT_GROUP"] = "INVALID_COPY_VARIANT_GROUP";
    /**
     * ALPHA - Variant A
     */
    CopyVariantCopyVariantGroup["ALPHA"] = "ALPHA";
    /**
     * BETA - Variant B
     */
    CopyVariantCopyVariantGroup["BETA"] = "BETA";
    /**
     * CONTROL - Control group (default)
     */
    CopyVariantCopyVariantGroup["CONTROL"] = "CONTROL";
    CopyVariantCopyVariantGroup["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CopyVariantCopyVariantGroup || (exports.CopyVariantCopyVariantGroup = CopyVariantCopyVariantGroup = {}));
function createBaseFeatureDefinition() {
    return {
        number: 0,
        name: '',
        title: '',
        applicable: FeatureApplicability.INVALID_FEATURE_APPLICABILITY,
        cascade: feature_extensions_1.FeatureCascade.INVALID_FEATURE_CASCADE,
        isHiddenFromAdmin: false,
        isDeprecated: false,
        seed: '',
        variantSeed: '',
        removedInSdkVersion: '',
    };
}
exports.FeatureDefinition = {
    fromJSON(object) {
        const message = {
            number: isSet(object.number) ? globalThis.Number(object.number) : 0,
            name: isSet(object.name) ? globalThis.String(object.name) : '',
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            applicable: isSet(object.applicable)
                ? featureApplicabilityFromJSON(object.applicable)
                : FeatureApplicability.INVALID_FEATURE_APPLICABILITY,
            cascade: isSet(object.cascade)
                ? (0, feature_extensions_1.featureCascadeFromJSON)(object.cascade)
                : feature_extensions_1.FeatureCascade.INVALID_FEATURE_CASCADE,
            isHiddenFromAdmin: isSet(object.isHiddenFromAdmin)
                ? globalThis.Boolean(object.isHiddenFromAdmin)
                : false,
            isDeprecated: isSet(object.isDeprecated) ? globalThis.Boolean(object.isDeprecated) : false,
        };
        if (isSet(object.seed)) {
            message.seed = globalThis.String(object.seed);
        }
        if (isSet(object.variantSeed)) {
            message.variantSeed = globalThis.String(object.variantSeed);
        }
        if (isSet(object.removedInSdkVersion)) {
            message.removedInSdkVersion = globalThis.String(object.removedInSdkVersion);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.number !== 0) {
            obj.number = Math.round(message.number);
        }
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.applicable !== FeatureApplicability.INVALID_FEATURE_APPLICABILITY) {
            obj.applicable = featureApplicabilityToJSON(message.applicable);
        }
        if (message.cascade !== feature_extensions_1.FeatureCascade.INVALID_FEATURE_CASCADE) {
            obj.cascade = (0, feature_extensions_1.featureCascadeToJSON)(message.cascade);
        }
        if (message.isHiddenFromAdmin !== false) {
            obj.isHiddenFromAdmin = message.isHiddenFromAdmin;
        }
        if (message.isDeprecated !== false) {
            obj.isDeprecated = message.isDeprecated;
        }
        if (message.seed !== undefined && message.seed !== '') {
            obj.seed = message.seed;
        }
        if (message.variantSeed !== undefined && message.variantSeed !== '') {
            obj.variantSeed = message.variantSeed;
        }
        if (message.removedInSdkVersion !== undefined && message.removedInSdkVersion !== '') {
            obj.removedInSdkVersion = message.removedInSdkVersion;
        }
        return obj;
    },
    create(base) {
        return exports.FeatureDefinition.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeatureDefinition();
        message.number = object.number ?? 0;
        message.name = object.name ?? '';
        message.title = object.title ?? '';
        message.applicable = object.applicable ?? FeatureApplicability.INVALID_FEATURE_APPLICABILITY;
        message.cascade = object.cascade ?? feature_extensions_1.FeatureCascade.INVALID_FEATURE_CASCADE;
        message.isHiddenFromAdmin = object.isHiddenFromAdmin ?? false;
        message.isDeprecated = object.isDeprecated ?? false;
        message.seed = object.seed ?? '';
        message.variantSeed = object.variantSeed ?? '';
        message.removedInSdkVersion = object.removedInSdkVersion ?? '';
        return message;
    },
};
function createBaseVariant() {
    return {
        name: '',
        percent: 0,
        suggestedFriendInvites: undefined,
        sponsorshipSmsCopy: undefined,
        subscriptionManagement: undefined,
        cancelMerchantInfo: undefined,
        instantCashout: undefined,
        tipping: undefined,
        refereeReminder: undefined,
        aaFamilyVariants: undefined,
        aaUserVariants: undefined,
        request3ds: undefined,
        stocksTrading: undefined,
        webSponsorshipFundingSkip: undefined,
        onboardingQuiz: undefined,
        quizShareMessage: undefined,
        hideSuggestedReferrals: undefined,
        requiredMinFundingAmount: undefined,
        stepBlackWaitlist: undefined,
        suggestedTransferAmount: undefined,
        soloVsParentDecisionAge: undefined,
        potBorrowCash: undefined,
        dynamicReferralCampaigns: undefined,
        welcomeOffer: undefined,
        tiers: undefined,
        userTierReferralCampaign: undefined,
        emancipation: undefined,
        giftCards: undefined,
        signupInterestSurvey: undefined,
        minFundingAmountFeeV2: undefined,
        directDepositInOnboarding: undefined,
        autoReload: undefined,
        serverSideFullScreenModal: undefined,
        recurringPayments: undefined,
        delayedReferral: undefined,
        unlockApp: undefined,
        milestoneCtaOverride: undefined,
        directDepositFundingRecommendation: undefined,
        onboardingStepBlack: undefined,
        onboardingJourneyFlow: undefined,
        directDepositUpdatesM1: undefined,
        topMerchantsOnCardsScreen: undefined,
        birthday18Offer: undefined,
        potConfigurableApr: undefined,
        potLateFee: undefined,
        moveMoneyV2: undefined,
        friendsTriviaLeaderboard: undefined,
        spinTheWheel: undefined,
        directDepositUpdatesM1V2: undefined,
        earnWithStep: undefined,
        gigsMobile: undefined,
        mobilePlans: undefined,
        limitLevelSet: undefined,
        testVariant: undefined,
        testUnauthenticatedWithVariant: undefined,
        testAnotherVariant: undefined,
        testVariantWithRequiredVersion: undefined,
        testServerWithVariant: undefined,
    };
}
exports.Variant = {
    fromJSON(object) {
        const message = {
            name: isSet(object.name) ? globalThis.String(object.name) : '',
            percent: isSet(object.percent) ? globalThis.Number(object.percent) : 0,
        };
        if (isSet(object.suggestedFriendInvites)) {
            message.suggestedFriendInvites = exports.VariantSuggestedFriendInvites.fromJSON(object.suggestedFriendInvites);
        }
        if (isSet(object.sponsorshipSmsCopy)) {
            message.sponsorshipSmsCopy = exports.VariantSponsorshipSmsCopy.fromJSON(object.sponsorshipSmsCopy);
        }
        if (isSet(object.subscriptionManagement)) {
            message.subscriptionManagement = exports.VariantSubscriptionManagement.fromJSON(object.subscriptionManagement);
        }
        if (isSet(object.cancelMerchantInfo)) {
            message.cancelMerchantInfo = exports.VariantCancelMerchantInfo.fromJSON(object.cancelMerchantInfo);
        }
        if (isSet(object.instantCashout)) {
            message.instantCashout = exports.VariantInstantCashout.fromJSON(object.instantCashout);
        }
        if (isSet(object.tipping)) {
            message.tipping = exports.VariantTipping.fromJSON(object.tipping);
        }
        if (isSet(object.refereeReminder)) {
            message.refereeReminder = exports.VariantRefereeReminder.fromJSON(object.refereeReminder);
        }
        if (isSet(object.aaFamilyVariants)) {
            message.aaFamilyVariants = exports.VariantEmptyVariant.fromJSON(object.aaFamilyVariants);
        }
        if (isSet(object.aaUserVariants)) {
            message.aaUserVariants = exports.VariantEmptyVariant.fromJSON(object.aaUserVariants);
        }
        if (isSet(object.request3ds)) {
            message.request3ds = exports.Request3DSVariant.fromJSON(object.request3ds);
        }
        if (isSet(object.stocksTrading)) {
            message.stocksTrading = exports.VariantStocksTradingVariant.fromJSON(object.stocksTrading);
        }
        if (isSet(object.webSponsorshipFundingSkip)) {
            message.webSponsorshipFundingSkip = exports.VariantWebSponsorshipFundingSkipVariant.fromJSON(object.webSponsorshipFundingSkip);
        }
        if (isSet(object.onboardingQuiz)) {
            message.onboardingQuiz = exports.OnboardingQuizVariant.fromJSON(object.onboardingQuiz);
        }
        if (isSet(object.quizShareMessage)) {
            message.quizShareMessage = exports.QuizShareMessageVariant.fromJSON(object.quizShareMessage);
        }
        if (isSet(object.hideSuggestedReferrals)) {
            message.hideSuggestedReferrals = exports.HideSuggestedReferralsVariant.fromJSON(object.hideSuggestedReferrals);
        }
        if (isSet(object.requiredMinFundingAmount)) {
            message.requiredMinFundingAmount = exports.RequiredMinFundingAmountVariant.fromJSON(object.requiredMinFundingAmount);
        }
        if (isSet(object.stepBlackWaitlist)) {
            message.stepBlackWaitlist = exports.StepBlackWaitlistVariant.fromJSON(object.stepBlackWaitlist);
        }
        if (isSet(object.suggestedTransferAmount)) {
            message.suggestedTransferAmount = exports.SuggestedTransferAmountVariant.fromJSON(object.suggestedTransferAmount);
        }
        if (isSet(object.soloVsParentDecisionAge)) {
            message.soloVsParentDecisionAge = exports.SoloVsParentDecisionAgeVariant.fromJSON(object.soloVsParentDecisionAge);
        }
        if (isSet(object.potBorrowCash)) {
            message.potBorrowCash = exports.PayOverTimeBorrowCashVariant.fromJSON(object.potBorrowCash);
        }
        if (isSet(object.dynamicReferralCampaigns)) {
            message.dynamicReferralCampaigns = exports.DynamicReferralCampaignsVariant.fromJSON(object.dynamicReferralCampaigns);
        }
        if (isSet(object.welcomeOffer)) {
            message.welcomeOffer = exports.WelcomeOfferVariant.fromJSON(object.welcomeOffer);
        }
        if (isSet(object.tiers)) {
            message.tiers = exports.TiersVariant.fromJSON(object.tiers);
        }
        if (isSet(object.userTierReferralCampaign)) {
            message.userTierReferralCampaign = exports.UserTierReferralCampaignVariant.fromJSON(object.userTierReferralCampaign);
        }
        if (isSet(object.emancipation)) {
            message.emancipation = exports.EmancipationVariant.fromJSON(object.emancipation);
        }
        if (isSet(object.giftCards)) {
            message.giftCards = exports.GiftCardVariant.fromJSON(object.giftCards);
        }
        if (isSet(object.signupInterestSurvey)) {
            message.signupInterestSurvey = exports.SignupInterestSurveyVariant.fromJSON(object.signupInterestSurvey);
        }
        if (isSet(object.minFundingAmountFeeV2)) {
            message.minFundingAmountFeeV2 = exports.VariantMinFundingAmountFee.fromJSON(object.minFundingAmountFeeV2);
        }
        if (isSet(object.directDepositInOnboarding)) {
            message.directDepositInOnboarding = exports.DirectDepositInOnboardingVariant.fromJSON(object.directDepositInOnboarding);
        }
        if (isSet(object.autoReload)) {
            message.autoReload = exports.AutoReloadVariant.fromJSON(object.autoReload);
        }
        if (isSet(object.serverSideFullScreenModal)) {
            message.serverSideFullScreenModal = exports.ServerSideFullScreenModalVariant.fromJSON(object.serverSideFullScreenModal);
        }
        if (isSet(object.recurringPayments)) {
            message.recurringPayments = exports.RecurringPaymentVariant.fromJSON(object.recurringPayments);
        }
        if (isSet(object.delayedReferral)) {
            message.delayedReferral = exports.DelayedReferralVariant.fromJSON(object.delayedReferral);
        }
        if (isSet(object.unlockApp)) {
            message.unlockApp = exports.UnlockAppVariant.fromJSON(object.unlockApp);
        }
        if (isSet(object.milestoneCtaOverride)) {
            message.milestoneCtaOverride = exports.MilestoneCtaOverrideVariant.fromJSON(object.milestoneCtaOverride);
        }
        if (isSet(object.directDepositFundingRecommendation)) {
            message.directDepositFundingRecommendation = exports.DirectDepositFundingRecommendationVariant
                .fromJSON(object.directDepositFundingRecommendation);
        }
        if (isSet(object.onboardingStepBlack)) {
            message.onboardingStepBlack = exports.OnboardingStepBlackVariant.fromJSON(object.onboardingStepBlack);
        }
        if (isSet(object.onboardingJourneyFlow)) {
            message.onboardingJourneyFlow = exports.AlloyJourneyVersionVariant.fromJSON(object.onboardingJourneyFlow);
        }
        if (isSet(object.directDepositUpdatesM1)) {
            message.directDepositUpdatesM1 = exports.DirectDepositUpdatesM1Variant.fromJSON(object.directDepositUpdatesM1);
        }
        if (isSet(object.topMerchantsOnCardsScreen)) {
            message.topMerchantsOnCardsScreen = exports.TopMerchantsOnCardsScreenVariant.fromJSON(object.topMerchantsOnCardsScreen);
        }
        if (isSet(object.birthday18Offer)) {
            message.birthday18Offer = exports.Birthday18OfferVariant.fromJSON(object.birthday18Offer);
        }
        if (isSet(object.potConfigurableApr)) {
            message.potConfigurableApr = exports.PotConfigurableAprVariant.fromJSON(object.potConfigurableApr);
        }
        if (isSet(object.potLateFee)) {
            message.potLateFee = exports.PotLateFeeVariant.fromJSON(object.potLateFee);
        }
        if (isSet(object.moveMoneyV2)) {
            message.moveMoneyV2 = exports.MoveMoneyV2Variant.fromJSON(object.moveMoneyV2);
        }
        if (isSet(object.friendsTriviaLeaderboard)) {
            message.friendsTriviaLeaderboard = exports.FriendsTriviaLeaderboardVariant.fromJSON(object.friendsTriviaLeaderboard);
        }
        if (isSet(object.spinTheWheel)) {
            message.spinTheWheel = exports.SpinTheWheelVariant.fromJSON(object.spinTheWheel);
        }
        if (isSet(object.directDepositUpdatesM1V2)) {
            message.directDepositUpdatesM1V2 = exports.DirectDepositUpdatesM1V2Variant.fromJSON(object.directDepositUpdatesM1V2);
        }
        if (isSet(object.earnWithStep)) {
            message.earnWithStep = exports.EarnWithStepVariant.fromJSON(object.earnWithStep);
        }
        if (isSet(object.gigsMobile)) {
            message.gigsMobile = exports.GigsMobileVariant.fromJSON(object.gigsMobile);
        }
        if (isSet(object.mobilePlans)) {
            message.mobilePlans = exports.CopyVariant.fromJSON(object.mobilePlans);
        }
        if (isSet(object.limitLevelSet)) {
            message.limitLevelSet = exports.LevelSetVariant.fromJSON(object.limitLevelSet);
        }
        if (isSet(object.testVariant)) {
            message.testVariant = exports.VariantTestVariant.fromJSON(object.testVariant);
        }
        if (isSet(object.testUnauthenticatedWithVariant)) {
            message.testUnauthenticatedWithVariant = exports.VariantTestVariant.fromJSON(object.testUnauthenticatedWithVariant);
        }
        if (isSet(object.testAnotherVariant)) {
            message.testAnotherVariant = exports.VariantTestVariant.fromJSON(object.testAnotherVariant);
        }
        if (isSet(object.testVariantWithRequiredVersion)) {
            message.testVariantWithRequiredVersion = exports.VariantTestVariant.fromJSON(object.testVariantWithRequiredVersion);
        }
        if (isSet(object.testServerWithVariant)) {
            message.testServerWithVariant = exports.VariantTestVariant.fromJSON(object.testServerWithVariant);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.percent !== 0) {
            obj.percent = message.percent;
        }
        if (message.suggestedFriendInvites !== undefined) {
            obj.suggestedFriendInvites = exports.VariantSuggestedFriendInvites.toJSON(message.suggestedFriendInvites);
        }
        if (message.sponsorshipSmsCopy !== undefined) {
            obj.sponsorshipSmsCopy = exports.VariantSponsorshipSmsCopy.toJSON(message.sponsorshipSmsCopy);
        }
        if (message.subscriptionManagement !== undefined) {
            obj.subscriptionManagement = exports.VariantSubscriptionManagement.toJSON(message.subscriptionManagement);
        }
        if (message.cancelMerchantInfo !== undefined) {
            obj.cancelMerchantInfo = exports.VariantCancelMerchantInfo.toJSON(message.cancelMerchantInfo);
        }
        if (message.instantCashout !== undefined) {
            obj.instantCashout = exports.VariantInstantCashout.toJSON(message.instantCashout);
        }
        if (message.tipping !== undefined) {
            obj.tipping = exports.VariantTipping.toJSON(message.tipping);
        }
        if (message.refereeReminder !== undefined) {
            obj.refereeReminder = exports.VariantRefereeReminder.toJSON(message.refereeReminder);
        }
        if (message.aaFamilyVariants !== undefined) {
            obj.aaFamilyVariants = exports.VariantEmptyVariant.toJSON(message.aaFamilyVariants);
        }
        if (message.aaUserVariants !== undefined) {
            obj.aaUserVariants = exports.VariantEmptyVariant.toJSON(message.aaUserVariants);
        }
        if (message.request3ds !== undefined) {
            obj.request3ds = exports.Request3DSVariant.toJSON(message.request3ds);
        }
        if (message.stocksTrading !== undefined) {
            obj.stocksTrading = exports.VariantStocksTradingVariant.toJSON(message.stocksTrading);
        }
        if (message.webSponsorshipFundingSkip !== undefined) {
            obj.webSponsorshipFundingSkip = exports.VariantWebSponsorshipFundingSkipVariant.toJSON(message.webSponsorshipFundingSkip);
        }
        if (message.onboardingQuiz !== undefined) {
            obj.onboardingQuiz = exports.OnboardingQuizVariant.toJSON(message.onboardingQuiz);
        }
        if (message.quizShareMessage !== undefined) {
            obj.quizShareMessage = exports.QuizShareMessageVariant.toJSON(message.quizShareMessage);
        }
        if (message.hideSuggestedReferrals !== undefined) {
            obj.hideSuggestedReferrals = exports.HideSuggestedReferralsVariant.toJSON(message.hideSuggestedReferrals);
        }
        if (message.requiredMinFundingAmount !== undefined) {
            obj.requiredMinFundingAmount = exports.RequiredMinFundingAmountVariant.toJSON(message.requiredMinFundingAmount);
        }
        if (message.stepBlackWaitlist !== undefined) {
            obj.stepBlackWaitlist = exports.StepBlackWaitlistVariant.toJSON(message.stepBlackWaitlist);
        }
        if (message.suggestedTransferAmount !== undefined) {
            obj.suggestedTransferAmount = exports.SuggestedTransferAmountVariant.toJSON(message.suggestedTransferAmount);
        }
        if (message.soloVsParentDecisionAge !== undefined) {
            obj.soloVsParentDecisionAge = exports.SoloVsParentDecisionAgeVariant.toJSON(message.soloVsParentDecisionAge);
        }
        if (message.potBorrowCash !== undefined) {
            obj.potBorrowCash = exports.PayOverTimeBorrowCashVariant.toJSON(message.potBorrowCash);
        }
        if (message.dynamicReferralCampaigns !== undefined) {
            obj.dynamicReferralCampaigns = exports.DynamicReferralCampaignsVariant.toJSON(message.dynamicReferralCampaigns);
        }
        if (message.welcomeOffer !== undefined) {
            obj.welcomeOffer = exports.WelcomeOfferVariant.toJSON(message.welcomeOffer);
        }
        if (message.tiers !== undefined) {
            obj.tiers = exports.TiersVariant.toJSON(message.tiers);
        }
        if (message.userTierReferralCampaign !== undefined) {
            obj.userTierReferralCampaign = exports.UserTierReferralCampaignVariant.toJSON(message.userTierReferralCampaign);
        }
        if (message.emancipation !== undefined) {
            obj.emancipation = exports.EmancipationVariant.toJSON(message.emancipation);
        }
        if (message.giftCards !== undefined) {
            obj.giftCards = exports.GiftCardVariant.toJSON(message.giftCards);
        }
        if (message.signupInterestSurvey !== undefined) {
            obj.signupInterestSurvey = exports.SignupInterestSurveyVariant.toJSON(message.signupInterestSurvey);
        }
        if (message.minFundingAmountFeeV2 !== undefined) {
            obj.minFundingAmountFeeV2 = exports.VariantMinFundingAmountFee.toJSON(message.minFundingAmountFeeV2);
        }
        if (message.directDepositInOnboarding !== undefined) {
            obj.directDepositInOnboarding = exports.DirectDepositInOnboardingVariant.toJSON(message.directDepositInOnboarding);
        }
        if (message.autoReload !== undefined) {
            obj.autoReload = exports.AutoReloadVariant.toJSON(message.autoReload);
        }
        if (message.serverSideFullScreenModal !== undefined) {
            obj.serverSideFullScreenModal = exports.ServerSideFullScreenModalVariant.toJSON(message.serverSideFullScreenModal);
        }
        if (message.recurringPayments !== undefined) {
            obj.recurringPayments = exports.RecurringPaymentVariant.toJSON(message.recurringPayments);
        }
        if (message.delayedReferral !== undefined) {
            obj.delayedReferral = exports.DelayedReferralVariant.toJSON(message.delayedReferral);
        }
        if (message.unlockApp !== undefined) {
            obj.unlockApp = exports.UnlockAppVariant.toJSON(message.unlockApp);
        }
        if (message.milestoneCtaOverride !== undefined) {
            obj.milestoneCtaOverride = exports.MilestoneCtaOverrideVariant.toJSON(message.milestoneCtaOverride);
        }
        if (message.directDepositFundingRecommendation !== undefined) {
            obj.directDepositFundingRecommendation = exports.DirectDepositFundingRecommendationVariant.toJSON(message.directDepositFundingRecommendation);
        }
        if (message.onboardingStepBlack !== undefined) {
            obj.onboardingStepBlack = exports.OnboardingStepBlackVariant.toJSON(message.onboardingStepBlack);
        }
        if (message.onboardingJourneyFlow !== undefined) {
            obj.onboardingJourneyFlow = exports.AlloyJourneyVersionVariant.toJSON(message.onboardingJourneyFlow);
        }
        if (message.directDepositUpdatesM1 !== undefined) {
            obj.directDepositUpdatesM1 = exports.DirectDepositUpdatesM1Variant.toJSON(message.directDepositUpdatesM1);
        }
        if (message.topMerchantsOnCardsScreen !== undefined) {
            obj.topMerchantsOnCardsScreen = exports.TopMerchantsOnCardsScreenVariant.toJSON(message.topMerchantsOnCardsScreen);
        }
        if (message.birthday18Offer !== undefined) {
            obj.birthday18Offer = exports.Birthday18OfferVariant.toJSON(message.birthday18Offer);
        }
        if (message.potConfigurableApr !== undefined) {
            obj.potConfigurableApr = exports.PotConfigurableAprVariant.toJSON(message.potConfigurableApr);
        }
        if (message.potLateFee !== undefined) {
            obj.potLateFee = exports.PotLateFeeVariant.toJSON(message.potLateFee);
        }
        if (message.moveMoneyV2 !== undefined) {
            obj.moveMoneyV2 = exports.MoveMoneyV2Variant.toJSON(message.moveMoneyV2);
        }
        if (message.friendsTriviaLeaderboard !== undefined) {
            obj.friendsTriviaLeaderboard = exports.FriendsTriviaLeaderboardVariant.toJSON(message.friendsTriviaLeaderboard);
        }
        if (message.spinTheWheel !== undefined) {
            obj.spinTheWheel = exports.SpinTheWheelVariant.toJSON(message.spinTheWheel);
        }
        if (message.directDepositUpdatesM1V2 !== undefined) {
            obj.directDepositUpdatesM1V2 = exports.DirectDepositUpdatesM1V2Variant.toJSON(message.directDepositUpdatesM1V2);
        }
        if (message.earnWithStep !== undefined) {
            obj.earnWithStep = exports.EarnWithStepVariant.toJSON(message.earnWithStep);
        }
        if (message.gigsMobile !== undefined) {
            obj.gigsMobile = exports.GigsMobileVariant.toJSON(message.gigsMobile);
        }
        if (message.mobilePlans !== undefined) {
            obj.mobilePlans = exports.CopyVariant.toJSON(message.mobilePlans);
        }
        if (message.limitLevelSet !== undefined) {
            obj.limitLevelSet = exports.LevelSetVariant.toJSON(message.limitLevelSet);
        }
        if (message.testVariant !== undefined) {
            obj.testVariant = exports.VariantTestVariant.toJSON(message.testVariant);
        }
        if (message.testUnauthenticatedWithVariant !== undefined) {
            obj.testUnauthenticatedWithVariant = exports.VariantTestVariant.toJSON(message.testUnauthenticatedWithVariant);
        }
        if (message.testAnotherVariant !== undefined) {
            obj.testAnotherVariant = exports.VariantTestVariant.toJSON(message.testAnotherVariant);
        }
        if (message.testVariantWithRequiredVersion !== undefined) {
            obj.testVariantWithRequiredVersion = exports.VariantTestVariant.toJSON(message.testVariantWithRequiredVersion);
        }
        if (message.testServerWithVariant !== undefined) {
            obj.testServerWithVariant = exports.VariantTestVariant.toJSON(message.testServerWithVariant);
        }
        return obj;
    },
    create(base) {
        return exports.Variant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariant();
        message.name = object.name ?? '';
        message.percent = object.percent ?? 0;
        message.suggestedFriendInvites =
            (object.suggestedFriendInvites !== undefined && object.suggestedFriendInvites !== null)
                ? exports.VariantSuggestedFriendInvites.fromPartial(object.suggestedFriendInvites)
                : undefined;
        message.sponsorshipSmsCopy =
            (object.sponsorshipSmsCopy !== undefined && object.sponsorshipSmsCopy !== null)
                ? exports.VariantSponsorshipSmsCopy.fromPartial(object.sponsorshipSmsCopy)
                : undefined;
        message.subscriptionManagement =
            (object.subscriptionManagement !== undefined && object.subscriptionManagement !== null)
                ? exports.VariantSubscriptionManagement.fromPartial(object.subscriptionManagement)
                : undefined;
        message.cancelMerchantInfo =
            (object.cancelMerchantInfo !== undefined && object.cancelMerchantInfo !== null)
                ? exports.VariantCancelMerchantInfo.fromPartial(object.cancelMerchantInfo)
                : undefined;
        message.instantCashout = (object.instantCashout !== undefined && object.instantCashout !== null)
            ? exports.VariantInstantCashout.fromPartial(object.instantCashout)
            : undefined;
        message.tipping = (object.tipping !== undefined && object.tipping !== null)
            ? exports.VariantTipping.fromPartial(object.tipping)
            : undefined;
        message.refereeReminder =
            (object.refereeReminder !== undefined && object.refereeReminder !== null)
                ? exports.VariantRefereeReminder.fromPartial(object.refereeReminder)
                : undefined;
        message.aaFamilyVariants =
            (object.aaFamilyVariants !== undefined && object.aaFamilyVariants !== null)
                ? exports.VariantEmptyVariant.fromPartial(object.aaFamilyVariants)
                : undefined;
        message.aaUserVariants = (object.aaUserVariants !== undefined && object.aaUserVariants !== null)
            ? exports.VariantEmptyVariant.fromPartial(object.aaUserVariants)
            : undefined;
        message.request3ds = (object.request3ds !== undefined && object.request3ds !== null)
            ? exports.Request3DSVariant.fromPartial(object.request3ds)
            : undefined;
        message.stocksTrading = (object.stocksTrading !== undefined && object.stocksTrading !== null)
            ? exports.VariantStocksTradingVariant.fromPartial(object.stocksTrading)
            : undefined;
        message.webSponsorshipFundingSkip =
            (object.webSponsorshipFundingSkip !== undefined && object.webSponsorshipFundingSkip !== null)
                ? exports.VariantWebSponsorshipFundingSkipVariant.fromPartial(object.webSponsorshipFundingSkip)
                : undefined;
        message.onboardingQuiz = (object.onboardingQuiz !== undefined && object.onboardingQuiz !== null)
            ? exports.OnboardingQuizVariant.fromPartial(object.onboardingQuiz)
            : undefined;
        message.quizShareMessage =
            (object.quizShareMessage !== undefined && object.quizShareMessage !== null)
                ? exports.QuizShareMessageVariant.fromPartial(object.quizShareMessage)
                : undefined;
        message.hideSuggestedReferrals =
            (object.hideSuggestedReferrals !== undefined && object.hideSuggestedReferrals !== null)
                ? exports.HideSuggestedReferralsVariant.fromPartial(object.hideSuggestedReferrals)
                : undefined;
        message.requiredMinFundingAmount =
            (object.requiredMinFundingAmount !== undefined && object.requiredMinFundingAmount !== null)
                ? exports.RequiredMinFundingAmountVariant.fromPartial(object.requiredMinFundingAmount)
                : undefined;
        message.stepBlackWaitlist =
            (object.stepBlackWaitlist !== undefined && object.stepBlackWaitlist !== null)
                ? exports.StepBlackWaitlistVariant.fromPartial(object.stepBlackWaitlist)
                : undefined;
        message.suggestedTransferAmount =
            (object.suggestedTransferAmount !== undefined && object.suggestedTransferAmount !== null)
                ? exports.SuggestedTransferAmountVariant.fromPartial(object.suggestedTransferAmount)
                : undefined;
        message.soloVsParentDecisionAge =
            (object.soloVsParentDecisionAge !== undefined && object.soloVsParentDecisionAge !== null)
                ? exports.SoloVsParentDecisionAgeVariant.fromPartial(object.soloVsParentDecisionAge)
                : undefined;
        message.potBorrowCash = (object.potBorrowCash !== undefined && object.potBorrowCash !== null)
            ? exports.PayOverTimeBorrowCashVariant.fromPartial(object.potBorrowCash)
            : undefined;
        message.dynamicReferralCampaigns =
            (object.dynamicReferralCampaigns !== undefined && object.dynamicReferralCampaigns !== null)
                ? exports.DynamicReferralCampaignsVariant.fromPartial(object.dynamicReferralCampaigns)
                : undefined;
        message.welcomeOffer = (object.welcomeOffer !== undefined && object.welcomeOffer !== null)
            ? exports.WelcomeOfferVariant.fromPartial(object.welcomeOffer)
            : undefined;
        message.tiers = (object.tiers !== undefined && object.tiers !== null)
            ? exports.TiersVariant.fromPartial(object.tiers)
            : undefined;
        message.userTierReferralCampaign =
            (object.userTierReferralCampaign !== undefined && object.userTierReferralCampaign !== null)
                ? exports.UserTierReferralCampaignVariant.fromPartial(object.userTierReferralCampaign)
                : undefined;
        message.emancipation = (object.emancipation !== undefined && object.emancipation !== null)
            ? exports.EmancipationVariant.fromPartial(object.emancipation)
            : undefined;
        message.giftCards = (object.giftCards !== undefined && object.giftCards !== null)
            ? exports.GiftCardVariant.fromPartial(object.giftCards)
            : undefined;
        message.signupInterestSurvey =
            (object.signupInterestSurvey !== undefined && object.signupInterestSurvey !== null)
                ? exports.SignupInterestSurveyVariant.fromPartial(object.signupInterestSurvey)
                : undefined;
        message.minFundingAmountFeeV2 =
            (object.minFundingAmountFeeV2 !== undefined && object.minFundingAmountFeeV2 !== null)
                ? exports.VariantMinFundingAmountFee.fromPartial(object.minFundingAmountFeeV2)
                : undefined;
        message.directDepositInOnboarding =
            (object.directDepositInOnboarding !== undefined && object.directDepositInOnboarding !== null)
                ? exports.DirectDepositInOnboardingVariant.fromPartial(object.directDepositInOnboarding)
                : undefined;
        message.autoReload = (object.autoReload !== undefined && object.autoReload !== null)
            ? exports.AutoReloadVariant.fromPartial(object.autoReload)
            : undefined;
        message.serverSideFullScreenModal =
            (object.serverSideFullScreenModal !== undefined && object.serverSideFullScreenModal !== null)
                ? exports.ServerSideFullScreenModalVariant.fromPartial(object.serverSideFullScreenModal)
                : undefined;
        message.recurringPayments =
            (object.recurringPayments !== undefined && object.recurringPayments !== null)
                ? exports.RecurringPaymentVariant.fromPartial(object.recurringPayments)
                : undefined;
        message.delayedReferral =
            (object.delayedReferral !== undefined && object.delayedReferral !== null)
                ? exports.DelayedReferralVariant.fromPartial(object.delayedReferral)
                : undefined;
        message.unlockApp = (object.unlockApp !== undefined && object.unlockApp !== null)
            ? exports.UnlockAppVariant.fromPartial(object.unlockApp)
            : undefined;
        message.milestoneCtaOverride =
            (object.milestoneCtaOverride !== undefined && object.milestoneCtaOverride !== null)
                ? exports.MilestoneCtaOverrideVariant.fromPartial(object.milestoneCtaOverride)
                : undefined;
        message.directDepositFundingRecommendation =
            (object.directDepositFundingRecommendation !== undefined &&
                object.directDepositFundingRecommendation !== null)
                ? exports.DirectDepositFundingRecommendationVariant.fromPartial(object.directDepositFundingRecommendation)
                : undefined;
        message.onboardingStepBlack =
            (object.onboardingStepBlack !== undefined && object.onboardingStepBlack !== null)
                ? exports.OnboardingStepBlackVariant.fromPartial(object.onboardingStepBlack)
                : undefined;
        message.onboardingJourneyFlow =
            (object.onboardingJourneyFlow !== undefined && object.onboardingJourneyFlow !== null)
                ? exports.AlloyJourneyVersionVariant.fromPartial(object.onboardingJourneyFlow)
                : undefined;
        message.directDepositUpdatesM1 =
            (object.directDepositUpdatesM1 !== undefined && object.directDepositUpdatesM1 !== null)
                ? exports.DirectDepositUpdatesM1Variant.fromPartial(object.directDepositUpdatesM1)
                : undefined;
        message.topMerchantsOnCardsScreen =
            (object.topMerchantsOnCardsScreen !== undefined && object.topMerchantsOnCardsScreen !== null)
                ? exports.TopMerchantsOnCardsScreenVariant.fromPartial(object.topMerchantsOnCardsScreen)
                : undefined;
        message.birthday18Offer =
            (object.birthday18Offer !== undefined && object.birthday18Offer !== null)
                ? exports.Birthday18OfferVariant.fromPartial(object.birthday18Offer)
                : undefined;
        message.potConfigurableApr =
            (object.potConfigurableApr !== undefined && object.potConfigurableApr !== null)
                ? exports.PotConfigurableAprVariant.fromPartial(object.potConfigurableApr)
                : undefined;
        message.potLateFee = (object.potLateFee !== undefined && object.potLateFee !== null)
            ? exports.PotLateFeeVariant.fromPartial(object.potLateFee)
            : undefined;
        message.moveMoneyV2 = (object.moveMoneyV2 !== undefined && object.moveMoneyV2 !== null)
            ? exports.MoveMoneyV2Variant.fromPartial(object.moveMoneyV2)
            : undefined;
        message.friendsTriviaLeaderboard =
            (object.friendsTriviaLeaderboard !== undefined && object.friendsTriviaLeaderboard !== null)
                ? exports.FriendsTriviaLeaderboardVariant.fromPartial(object.friendsTriviaLeaderboard)
                : undefined;
        message.spinTheWheel = (object.spinTheWheel !== undefined && object.spinTheWheel !== null)
            ? exports.SpinTheWheelVariant.fromPartial(object.spinTheWheel)
            : undefined;
        message.directDepositUpdatesM1V2 =
            (object.directDepositUpdatesM1V2 !== undefined && object.directDepositUpdatesM1V2 !== null)
                ? exports.DirectDepositUpdatesM1V2Variant.fromPartial(object.directDepositUpdatesM1V2)
                : undefined;
        message.earnWithStep = (object.earnWithStep !== undefined && object.earnWithStep !== null)
            ? exports.EarnWithStepVariant.fromPartial(object.earnWithStep)
            : undefined;
        message.gigsMobile = (object.gigsMobile !== undefined && object.gigsMobile !== null)
            ? exports.GigsMobileVariant.fromPartial(object.gigsMobile)
            : undefined;
        message.mobilePlans = (object.mobilePlans !== undefined && object.mobilePlans !== null)
            ? exports.CopyVariant.fromPartial(object.mobilePlans)
            : undefined;
        message.limitLevelSet = (object.limitLevelSet !== undefined && object.limitLevelSet !== null)
            ? exports.LevelSetVariant.fromPartial(object.limitLevelSet)
            : undefined;
        message.testVariant = (object.testVariant !== undefined && object.testVariant !== null)
            ? exports.VariantTestVariant.fromPartial(object.testVariant)
            : undefined;
        message.testUnauthenticatedWithVariant =
            (object.testUnauthenticatedWithVariant !== undefined &&
                object.testUnauthenticatedWithVariant !== null)
                ? exports.VariantTestVariant.fromPartial(object.testUnauthenticatedWithVariant)
                : undefined;
        message.testAnotherVariant =
            (object.testAnotherVariant !== undefined && object.testAnotherVariant !== null)
                ? exports.VariantTestVariant.fromPartial(object.testAnotherVariant)
                : undefined;
        message.testVariantWithRequiredVersion =
            (object.testVariantWithRequiredVersion !== undefined &&
                object.testVariantWithRequiredVersion !== null)
                ? exports.VariantTestVariant.fromPartial(object.testVariantWithRequiredVersion)
                : undefined;
        message.testServerWithVariant =
            (object.testServerWithVariant !== undefined && object.testServerWithVariant !== null)
                ? exports.VariantTestVariant.fromPartial(object.testServerWithVariant)
                : undefined;
        return message;
    },
};
function createBaseVariantEmptyVariant() {
    return {};
}
exports.VariantEmptyVariant = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.VariantEmptyVariant.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseVariantEmptyVariant();
        return message;
    },
};
function createBaseVariantTestVariant() {
    return { someString: '', someFloat: 0, someInt64: '0', optionalEmptyField: '' };
}
exports.VariantTestVariant = {
    fromJSON(object) {
        const message = {
            someString: isSet(object.someString) ? globalThis.String(object.someString) : '',
            someFloat: isSet(object.someFloat) ? globalThis.Number(object.someFloat) : 0,
            someInt64: isSet(object.someInt64) ? globalThis.String(object.someInt64) : '0',
        };
        if (isSet(object.optionalEmptyField)) {
            message.optionalEmptyField = globalThis.String(object.optionalEmptyField);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.someString !== '') {
            obj.someString = message.someString;
        }
        if (message.someFloat !== 0) {
            obj.someFloat = message.someFloat;
        }
        if (message.someInt64 !== '0') {
            obj.someInt64 = message.someInt64;
        }
        if (message.optionalEmptyField !== undefined && message.optionalEmptyField !== '') {
            obj.optionalEmptyField = message.optionalEmptyField;
        }
        return obj;
    },
    create(base) {
        return exports.VariantTestVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantTestVariant();
        message.someString = object.someString ?? '';
        message.someFloat = object.someFloat ?? 0;
        message.someInt64 = object.someInt64 ?? '0';
        message.optionalEmptyField = object.optionalEmptyField ?? '';
        return message;
    },
};
function createBaseVariantSuggestedFriendInvites() {
    return { buttonTitle: '' };
}
exports.VariantSuggestedFriendInvites = {
    fromJSON(object) {
        const message = {
            buttonTitle: isSet(object.buttonTitle) ? globalThis.String(object.buttonTitle) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.buttonTitle !== '') {
            obj.buttonTitle = message.buttonTitle;
        }
        return obj;
    },
    create(base) {
        return exports.VariantSuggestedFriendInvites.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantSuggestedFriendInvites();
        message.buttonTitle = object.buttonTitle ?? '';
        return message;
    },
};
function createBaseVariantSponsorshipSmsCopy() {
    return { message: '' };
}
exports.VariantSponsorshipSmsCopy = {
    fromJSON(object) {
        const message = {
            message: isSet(object.message) ? globalThis.String(object.message) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== '') {
            obj.message = message.message;
        }
        return obj;
    },
    create(base) {
        return exports.VariantSponsorshipSmsCopy.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantSponsorshipSmsCopy();
        message.message = object.message ?? '';
        return message;
    },
};
function createBaseVariantMinFundingAmountFee() {
    return { feeAmount: 0, minFundingAmount: 0, controlGroup: false, p2pFlow: false, tier: [] };
}
exports.VariantMinFundingAmountFee = {
    fromJSON(object) {
        const message = {
            feeAmount: isSet(object.feeAmount) ? globalThis.Number(object.feeAmount) : 0,
            minFundingAmount: isSet(object.minFundingAmount)
                ? globalThis.Number(object.minFundingAmount)
                : 0,
            controlGroup: isSet(object.controlGroup) ? globalThis.Boolean(object.controlGroup) : false,
            p2pFlow: isSet(object.p2pFlow) ? globalThis.Boolean(object.p2pFlow) : false,
            tier: globalThis.Array.isArray(object?.tier)
                ? object.tier.map((e) => globalThis.String(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.feeAmount !== 0) {
            obj.feeAmount = message.feeAmount;
        }
        if (message.minFundingAmount !== 0) {
            obj.minFundingAmount = message.minFundingAmount;
        }
        if (message.controlGroup !== false) {
            obj.controlGroup = message.controlGroup;
        }
        if (message.p2pFlow !== false) {
            obj.p2pFlow = message.p2pFlow;
        }
        if (message.tier?.length) {
            obj.tier = message.tier;
        }
        return obj;
    },
    create(base) {
        return exports.VariantMinFundingAmountFee.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantMinFundingAmountFee();
        message.feeAmount = object.feeAmount ?? 0;
        message.minFundingAmount = object.minFundingAmount ?? 0;
        message.controlGroup = object.controlGroup ?? false;
        message.p2pFlow = object.p2pFlow ?? false;
        message.tier = object.tier?.map((e) => e) || [];
        return message;
    },
};
function createBaseVariantSubscriptionManagement() {
    return { merchantHelpCenterArticleIds: {} };
}
exports.VariantSubscriptionManagement = {
    fromJSON(object) {
        const message = {
            merchantHelpCenterArticleIds: isObject(object.merchantHelpCenterArticleIds)
                ? Object.entries(object.merchantHelpCenterArticleIds).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchantHelpCenterArticleIds) {
            const entries = Object.entries(message.merchantHelpCenterArticleIds);
            if (entries.length > 0) {
                obj.merchantHelpCenterArticleIds = {};
                entries.forEach(([k, v]) => {
                    obj.merchantHelpCenterArticleIds[k] = v;
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.VariantSubscriptionManagement.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantSubscriptionManagement();
        message.merchantHelpCenterArticleIds = Object.entries(object.merchantHelpCenterArticleIds ?? {})
            .reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseVariantSubscriptionManagementMerchantHelpCenterArticleIdsEntry() {
    return { key: '', value: '' };
}
exports.VariantSubscriptionManagementMerchantHelpCenterArticleIdsEntry = {
    fromJSON(object) {
        const message = {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
            value: isSet(object.value) ? globalThis.String(object.value) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== '') {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.VariantSubscriptionManagementMerchantHelpCenterArticleIdsEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantSubscriptionManagementMerchantHelpCenterArticleIdsEntry();
        message.key = object.key ?? '';
        message.value = object.value ?? '';
        return message;
    },
};
function createBaseVariantCancelMerchantInfo() {
    return { merchantHelpCenterArticleIds: {}, merchantLinks: {} };
}
exports.VariantCancelMerchantInfo = {
    fromJSON(object) {
        const message = {
            merchantHelpCenterArticleIds: isObject(object.merchantHelpCenterArticleIds)
                ? Object.entries(object.merchantHelpCenterArticleIds).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
            merchantLinks: isObject(object.merchantLinks)
                ? Object.entries(object.merchantLinks).reduce((acc, [key, value]) => {
                    acc[key] = cancel_merchant_link_1.CancelMerchantLink.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchantHelpCenterArticleIds) {
            const entries = Object.entries(message.merchantHelpCenterArticleIds);
            if (entries.length > 0) {
                obj.merchantHelpCenterArticleIds = {};
                entries.forEach(([k, v]) => {
                    obj.merchantHelpCenterArticleIds[k] = v;
                });
            }
        }
        if (message.merchantLinks) {
            const entries = Object.entries(message.merchantLinks);
            if (entries.length > 0) {
                obj.merchantLinks = {};
                entries.forEach(([k, v]) => {
                    obj.merchantLinks[k] = cancel_merchant_link_1.CancelMerchantLink.toJSON(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.VariantCancelMerchantInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantCancelMerchantInfo();
        message.merchantHelpCenterArticleIds = Object.entries(object.merchantHelpCenterArticleIds ?? {})
            .reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        message.merchantLinks = Object.entries(object.merchantLinks ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = cancel_merchant_link_1.CancelMerchantLink.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseVariantCancelMerchantInfoMerchantHelpCenterArticleIdsEntry() {
    return { key: '', value: '' };
}
exports.VariantCancelMerchantInfoMerchantHelpCenterArticleIdsEntry = {
    fromJSON(object) {
        const message = {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
            value: isSet(object.value) ? globalThis.String(object.value) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== '') {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.VariantCancelMerchantInfoMerchantHelpCenterArticleIdsEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantCancelMerchantInfoMerchantHelpCenterArticleIdsEntry();
        message.key = object.key ?? '';
        message.value = object.value ?? '';
        return message;
    },
};
function createBaseVariantCancelMerchantInfoMerchantLinksEntry() {
    return { key: '', value: undefined };
}
exports.VariantCancelMerchantInfoMerchantLinksEntry = {
    fromJSON(object) {
        const message = {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
        };
        if (isSet(object.value)) {
            message.value = cancel_merchant_link_1.CancelMerchantLink.fromJSON(object.value);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = cancel_merchant_link_1.CancelMerchantLink.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.VariantCancelMerchantInfoMerchantLinksEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantCancelMerchantInfoMerchantLinksEntry();
        message.key = object.key ?? '';
        message.value = (object.value !== undefined && object.value !== null)
            ? cancel_merchant_link_1.CancelMerchantLink.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseVariantInstantCashout() {
    return { percentFee: 0, minFeeAmount: 0 };
}
exports.VariantInstantCashout = {
    fromJSON(object) {
        const message = {
            percentFee: isSet(object.percentFee) ? globalThis.Number(object.percentFee) : 0,
            minFeeAmount: isSet(object.minFeeAmount) ? globalThis.Number(object.minFeeAmount) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.percentFee !== 0) {
            obj.percentFee = message.percentFee;
        }
        if (message.minFeeAmount !== 0) {
            obj.minFeeAmount = message.minFeeAmount;
        }
        return obj;
    },
    create(base) {
        return exports.VariantInstantCashout.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantInstantCashout();
        message.percentFee = object.percentFee ?? 0;
        message.minFeeAmount = object.minFeeAmount ?? 0;
        return message;
    },
};
function createBaseVariantTipping() {
    return { title: '', message: '' };
}
exports.VariantTipping = {
    fromJSON(object) {
        const message = {
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            message: isSet(object.message) ? globalThis.String(object.message) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.message !== '') {
            obj.message = message.message;
        }
        return obj;
    },
    create(base) {
        return exports.VariantTipping.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantTipping();
        message.title = object.title ?? '';
        message.message = object.message ?? '';
        return message;
    },
};
function createBaseVariantRefereeReminder() {
    return { attempts: [] };
}
exports.VariantRefereeReminder = {
    fromJSON(object) {
        const message = {
            attempts: globalThis.Array.isArray(object?.attempts)
                ? object.attempts.map((e) => exports.VariantRefereeReminderRefereeReminderAttempt.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.attempts?.length) {
            obj.attempts = message.attempts.map((e) => exports.VariantRefereeReminderRefereeReminderAttempt.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.VariantRefereeReminder.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantRefereeReminder();
        message.attempts =
            object.attempts?.map((e) => exports.VariantRefereeReminderRefereeReminderAttempt.fromPartial(e)) ||
                [];
        return message;
    },
};
function createBaseVariantRefereeReminderRefereeReminderAttempt() {
    return {
        delay: '',
        inviteStatus: referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS,
        titleOne: '',
        messageOne: '',
        titleMany: '',
        messageMany: '',
    };
}
exports.VariantRefereeReminderRefereeReminderAttempt = {
    fromJSON(object) {
        const message = {
            delay: isSet(object.delay) ? globalThis.String(object.delay) : '',
            inviteStatus: isSet(object.inviteStatus)
                ? (0, referral_invite_status_1.referralInviteStatusFromJSON)(object.inviteStatus)
                : referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS,
            titleOne: isSet(object.titleOne) ? globalThis.String(object.titleOne) : '',
            messageOne: isSet(object.messageOne) ? globalThis.String(object.messageOne) : '',
            titleMany: isSet(object.titleMany) ? globalThis.String(object.titleMany) : '',
            messageMany: isSet(object.messageMany) ? globalThis.String(object.messageMany) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.delay !== '') {
            obj.delay = message.delay;
        }
        if (message.inviteStatus !== referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS) {
            obj.inviteStatus = (0, referral_invite_status_1.referralInviteStatusToJSON)(message.inviteStatus);
        }
        if (message.titleOne !== '') {
            obj.titleOne = message.titleOne;
        }
        if (message.messageOne !== '') {
            obj.messageOne = message.messageOne;
        }
        if (message.titleMany !== '') {
            obj.titleMany = message.titleMany;
        }
        if (message.messageMany !== '') {
            obj.messageMany = message.messageMany;
        }
        return obj;
    },
    create(base) {
        return exports.VariantRefereeReminderRefereeReminderAttempt.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantRefereeReminderRefereeReminderAttempt();
        message.delay = object.delay ?? '';
        message.inviteStatus = object.inviteStatus ??
            referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS;
        message.titleOne = object.titleOne ?? '';
        message.messageOne = object.messageOne ?? '';
        message.titleMany = object.titleMany ?? '';
        message.messageMany = object.messageMany ?? '';
        return message;
    },
};
function createBaseVariantStocksTradingVariant() {
    return { hasCrypto: false, hasStocks: false };
}
exports.VariantStocksTradingVariant = {
    fromJSON(object) {
        const message = {
            hasCrypto: isSet(object.hasCrypto) ? globalThis.Boolean(object.hasCrypto) : false,
            hasStocks: isSet(object.hasStocks) ? globalThis.Boolean(object.hasStocks) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.hasCrypto !== false) {
            obj.hasCrypto = message.hasCrypto;
        }
        if (message.hasStocks !== false) {
            obj.hasStocks = message.hasStocks;
        }
        return obj;
    },
    create(base) {
        return exports.VariantStocksTradingVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantStocksTradingVariant();
        message.hasCrypto = object.hasCrypto ?? false;
        message.hasStocks = object.hasStocks ?? false;
        return message;
    },
};
function createBaseVariantWebSponsorshipFundingSkipVariant() {
    return { behavior: VariantWebSponsorshipFundingSkipVariantBehavior.INVALID_WEB_FUNDING_BEHAVIOR };
}
exports.VariantWebSponsorshipFundingSkipVariant = {
    fromJSON(object) {
        const message = {
            behavior: isSet(object.behavior)
                ? variantWebSponsorshipFundingSkipVariantBehaviorFromJSON(object.behavior)
                : VariantWebSponsorshipFundingSkipVariantBehavior.INVALID_WEB_FUNDING_BEHAVIOR,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.behavior !==
            VariantWebSponsorshipFundingSkipVariantBehavior.INVALID_WEB_FUNDING_BEHAVIOR) {
            obj.behavior = variantWebSponsorshipFundingSkipVariantBehaviorToJSON(message.behavior);
        }
        return obj;
    },
    create(base) {
        return exports.VariantWebSponsorshipFundingSkipVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVariantWebSponsorshipFundingSkipVariant();
        message.behavior = object.behavior ??
            VariantWebSponsorshipFundingSkipVariantBehavior.INVALID_WEB_FUNDING_BEHAVIOR;
        return message;
    },
};
function createBaseRequest3DSVariant() {
    return { frequency: Request3DSVariantFrequency.REQUEST_3DS_INVALID, controlGroup: false };
}
exports.Request3DSVariant = {
    fromJSON(object) {
        const message = {
            frequency: isSet(object.frequency)
                ? request3DSVariantFrequencyFromJSON(object.frequency)
                : Request3DSVariantFrequency.REQUEST_3DS_INVALID,
            controlGroup: isSet(object.controlGroup) ? globalThis.Boolean(object.controlGroup) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.frequency !== Request3DSVariantFrequency.REQUEST_3DS_INVALID) {
            obj.frequency = request3DSVariantFrequencyToJSON(message.frequency);
        }
        if (message.controlGroup !== false) {
            obj.controlGroup = message.controlGroup;
        }
        return obj;
    },
    create(base) {
        return exports.Request3DSVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRequest3DSVariant();
        message.frequency = object.frequency ?? Request3DSVariantFrequency.REQUEST_3DS_INVALID;
        message.controlGroup = object.controlGroup ?? false;
        return message;
    },
};
function createBaseLevelSetVariant() {
    return { levelSetId: '' };
}
exports.LevelSetVariant = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.levelSetId)) {
            message.levelSetId = globalThis.String(object.levelSetId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.levelSetId !== undefined && message.levelSetId !== '') {
            obj.levelSetId = message.levelSetId;
        }
        return obj;
    },
    create(base) {
        return exports.LevelSetVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLevelSetVariant();
        message.levelSetId = object.levelSetId ?? '';
        return message;
    },
};
function createBaseRequiredVersions() {
    return { android: '', ios: '' };
}
exports.RequiredVersions = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.android)) {
            message.android = globalThis.String(object.android);
        }
        if (isSet(object.ios)) {
            message.ios = globalThis.String(object.ios);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.android !== undefined && message.android !== '') {
            obj.android = message.android;
        }
        if (message.ios !== undefined && message.ios !== '') {
            obj.ios = message.ios;
        }
        return obj;
    },
    create(base) {
        return exports.RequiredVersions.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRequiredVersions();
        message.android = object.android ?? '';
        message.ios = object.ios ?? '';
        return message;
    },
};
function createBaseFeatureRollout() {
    return {
        percent: 0,
        requiredVersions: exports.RequiredVersions.fromPartial({}),
        userCreatedAfterDateMs: '0',
        disabled: false,
        note: '',
    };
}
exports.FeatureRollout = {
    fromJSON(object) {
        const message = {
            percent: isSet(object.percent) ? globalThis.Number(object.percent) : 0,
            requiredVersions: isSet(object.requiredVersions)
                ? exports.RequiredVersions.fromJSON(object.requiredVersions)
                : exports.RequiredVersions.fromPartial({}),
            disabled: isSet(object.disabled) ? globalThis.Boolean(object.disabled) : false,
        };
        if (isSet(object.userCreatedAfterDateMs)) {
            message.userCreatedAfterDateMs = globalThis.String(object.userCreatedAfterDateMs);
        }
        if (isSet(object.note)) {
            message.note = globalThis.String(object.note);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.percent !== 0) {
            obj.percent = message.percent;
        }
        if (message.requiredVersions !== undefined) {
            obj.requiredVersions = exports.RequiredVersions.toJSON(message.requiredVersions);
        }
        if (message.userCreatedAfterDateMs !== undefined && message.userCreatedAfterDateMs !== '0') {
            obj.userCreatedAfterDateMs = message.userCreatedAfterDateMs;
        }
        if (message.disabled !== false) {
            obj.disabled = message.disabled;
        }
        if (message.note !== undefined && message.note !== '') {
            obj.note = message.note;
        }
        return obj;
    },
    create(base) {
        return exports.FeatureRollout.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeatureRollout();
        message.percent = object.percent ?? 0;
        message.requiredVersions =
            (object.requiredVersions !== undefined && object.requiredVersions !== null)
                ? exports.RequiredVersions.fromPartial(object.requiredVersions)
                : exports.RequiredVersions.fromPartial({});
        message.userCreatedAfterDateMs = object.userCreatedAfterDateMs ?? '0';
        message.disabled = object.disabled ?? false;
        message.note = object.note ?? '';
        return message;
    },
};
function createBaseAssignmentCounts() {
    return { users: 0 };
}
exports.AssignmentCounts = {
    fromJSON(object) {
        const message = {
            users: isSet(object.users) ? globalThis.Number(object.users) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.users !== 0) {
            obj.users = Math.round(message.users);
        }
        return obj;
    },
    create(base) {
        return exports.AssignmentCounts.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAssignmentCounts();
        message.users = object.users ?? 0;
        return message;
    },
};
function createBaseFeatureInfo() {
    return {
        feature: Feature.INVALID_FEATURE,
        definition: exports.FeatureDefinition.fromPartial({}),
        variants: [],
        variantJsons: [],
        rollout: exports.FeatureRollout.fromPartial({}),
        assignmentCounts: exports.AssignmentCounts.fromPartial({}),
        supportsVariants: false,
        updatedAtMs: '0',
    };
}
exports.FeatureInfo = {
    fromJSON(object) {
        const message = {
            feature: isSet(object.feature) ? featureFromJSON(object.feature) : Feature.INVALID_FEATURE,
            definition: isSet(object.definition)
                ? exports.FeatureDefinition.fromJSON(object.definition)
                : exports.FeatureDefinition.fromPartial({}),
            variants: globalThis.Array.isArray(object?.variants)
                ? object.variants.map((e) => exports.Variant.fromJSON(e))
                : [],
            variantJsons: globalThis.Array.isArray(object?.variantJsons)
                ? object.variantJsons.map((e) => globalThis.String(e))
                : [],
            rollout: isSet(object.rollout)
                ? exports.FeatureRollout.fromJSON(object.rollout)
                : exports.FeatureRollout.fromPartial({}),
            assignmentCounts: isSet(object.assignmentCounts)
                ? exports.AssignmentCounts.fromJSON(object.assignmentCounts)
                : exports.AssignmentCounts.fromPartial({}),
            supportsVariants: isSet(object.supportsVariants)
                ? globalThis.Boolean(object.supportsVariants)
                : false,
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.feature !== Feature.INVALID_FEATURE) {
            obj.feature = featureToJSON(message.feature);
        }
        if (message.definition !== undefined) {
            obj.definition = exports.FeatureDefinition.toJSON(message.definition);
        }
        if (message.variants?.length) {
            obj.variants = message.variants.map((e) => exports.Variant.toJSON(e));
        }
        if (message.variantJsons?.length) {
            obj.variantJsons = message.variantJsons;
        }
        if (message.rollout !== undefined) {
            obj.rollout = exports.FeatureRollout.toJSON(message.rollout);
        }
        if (message.assignmentCounts !== undefined) {
            obj.assignmentCounts = exports.AssignmentCounts.toJSON(message.assignmentCounts);
        }
        if (message.supportsVariants !== false) {
            obj.supportsVariants = message.supportsVariants;
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.FeatureInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeatureInfo();
        message.feature = object.feature ?? Feature.INVALID_FEATURE;
        message.definition = (object.definition !== undefined && object.definition !== null)
            ? exports.FeatureDefinition.fromPartial(object.definition)
            : exports.FeatureDefinition.fromPartial({});
        message.variants = object.variants?.map((e) => exports.Variant.fromPartial(e)) || [];
        message.variantJsons = object.variantJsons?.map((e) => e) || [];
        message.rollout = (object.rollout !== undefined && object.rollout !== null)
            ? exports.FeatureRollout.fromPartial(object.rollout)
            : exports.FeatureRollout.fromPartial({});
        message.assignmentCounts =
            (object.assignmentCounts !== undefined && object.assignmentCounts !== null)
                ? exports.AssignmentCounts.fromPartial(object.assignmentCounts)
                : exports.AssignmentCounts.fromPartial({});
        message.supportsVariants = object.supportsVariants ?? false;
        message.updatedAtMs = object.updatedAtMs ?? '0';
        return message;
    },
};
function createBaseFeatureChangelog() {
    return {
        definition: exports.FeatureDefinition.fromPartial({}),
        variants: [],
        rollout: exports.FeatureRollout.fromPartial({}),
        updatedAtMs: '0',
        updatedByUserId: '',
    };
}
exports.FeatureChangelog = {
    fromJSON(object) {
        const message = {
            definition: isSet(object.definition)
                ? exports.FeatureDefinition.fromJSON(object.definition)
                : exports.FeatureDefinition.fromPartial({}),
            variants: globalThis.Array.isArray(object?.variants)
                ? object.variants.map((e) => exports.Variant.fromJSON(e))
                : [],
            rollout: isSet(object.rollout)
                ? exports.FeatureRollout.fromJSON(object.rollout)
                : exports.FeatureRollout.fromPartial({}),
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
        };
        if (isSet(object.updatedByUserId)) {
            message.updatedByUserId = globalThis.String(object.updatedByUserId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.definition !== undefined) {
            obj.definition = exports.FeatureDefinition.toJSON(message.definition);
        }
        if (message.variants?.length) {
            obj.variants = message.variants.map((e) => exports.Variant.toJSON(e));
        }
        if (message.rollout !== undefined) {
            obj.rollout = exports.FeatureRollout.toJSON(message.rollout);
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        if (message.updatedByUserId !== undefined && message.updatedByUserId !== '') {
            obj.updatedByUserId = message.updatedByUserId;
        }
        return obj;
    },
    create(base) {
        return exports.FeatureChangelog.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeatureChangelog();
        message.definition = (object.definition !== undefined && object.definition !== null)
            ? exports.FeatureDefinition.fromPartial(object.definition)
            : exports.FeatureDefinition.fromPartial({});
        message.variants = object.variants?.map((e) => exports.Variant.fromPartial(e)) || [];
        message.rollout = (object.rollout !== undefined && object.rollout !== null)
            ? exports.FeatureRollout.fromPartial(object.rollout)
            : exports.FeatureRollout.fromPartial({});
        message.updatedAtMs = object.updatedAtMs ?? '0';
        message.updatedByUserId = object.updatedByUserId ?? '';
        return message;
    },
};
function createBaseFeatureAssignment() {
    return { feature: Feature.INVALID_FEATURE, variant: undefined };
}
exports.FeatureAssignment = {
    fromJSON(object) {
        const message = {
            feature: isSet(object.feature) ? featureFromJSON(object.feature) : Feature.INVALID_FEATURE,
        };
        if (isSet(object.variant)) {
            message.variant = exports.Variant.fromJSON(object.variant);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.feature !== Feature.INVALID_FEATURE) {
            obj.feature = featureToJSON(message.feature);
        }
        if (message.variant !== undefined) {
            obj.variant = exports.Variant.toJSON(message.variant);
        }
        return obj;
    },
    create(base) {
        return exports.FeatureAssignment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeatureAssignment();
        message.feature = object.feature ?? Feature.INVALID_FEATURE;
        message.variant = (object.variant !== undefined && object.variant !== null)
            ? exports.Variant.fromPartial(object.variant)
            : undefined;
        return message;
    },
};
function createBaseOnboardingQuizVariant() {
    return { questions: [], correctMessage: '', incorrectMessage: '', offerCode: '' };
}
exports.OnboardingQuizVariant = {
    fromJSON(object) {
        const message = {
            questions: globalThis.Array.isArray(object?.questions)
                ? object.questions.map((e) => exports.OnboardingQuizVariantQuestion.fromJSON(e))
                : [],
            correctMessage: isSet(object.correctMessage) ? globalThis.String(object.correctMessage) : '',
            incorrectMessage: isSet(object.incorrectMessage)
                ? globalThis.String(object.incorrectMessage)
                : '',
        };
        if (isSet(object.offerCode)) {
            message.offerCode = globalThis.String(object.offerCode);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.questions?.length) {
            obj.questions = message.questions.map((e) => exports.OnboardingQuizVariantQuestion.toJSON(e));
        }
        if (message.correctMessage !== '') {
            obj.correctMessage = message.correctMessage;
        }
        if (message.incorrectMessage !== '') {
            obj.incorrectMessage = message.incorrectMessage;
        }
        if (message.offerCode !== undefined && message.offerCode !== '') {
            obj.offerCode = message.offerCode;
        }
        return obj;
    },
    create(base) {
        return exports.OnboardingQuizVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOnboardingQuizVariant();
        message.questions =
            object.questions?.map((e) => exports.OnboardingQuizVariantQuestion.fromPartial(e)) || [];
        message.correctMessage = object.correctMessage ?? '';
        message.incorrectMessage = object.incorrectMessage ?? '';
        message.offerCode = object.offerCode ?? '';
        return message;
    },
};
function createBaseOnboardingQuizVariantQuestion() {
    return { question: '', answers: [], feedback: exports.OnboardingQuizVariantFeedback.fromPartial({}) };
}
exports.OnboardingQuizVariantQuestion = {
    fromJSON(object) {
        const message = {
            question: isSet(object.question) ? globalThis.String(object.question) : '',
            answers: globalThis.Array.isArray(object?.answers)
                ? object.answers.map((e) => exports.OnboardingQuizVariantAnswer.fromJSON(e))
                : [],
            feedback: isSet(object.feedback)
                ? exports.OnboardingQuizVariantFeedback.fromJSON(object.feedback)
                : exports.OnboardingQuizVariantFeedback.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.question !== '') {
            obj.question = message.question;
        }
        if (message.answers?.length) {
            obj.answers = message.answers.map((e) => exports.OnboardingQuizVariantAnswer.toJSON(e));
        }
        if (message.feedback !== undefined) {
            obj.feedback = exports.OnboardingQuizVariantFeedback.toJSON(message.feedback);
        }
        return obj;
    },
    create(base) {
        return exports.OnboardingQuizVariantQuestion.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOnboardingQuizVariantQuestion();
        message.question = object.question ?? '';
        message.answers = object.answers?.map((e) => exports.OnboardingQuizVariantAnswer.fromPartial(e)) || [];
        message.feedback = (object.feedback !== undefined && object.feedback !== null)
            ? exports.OnboardingQuizVariantFeedback.fromPartial(object.feedback)
            : exports.OnboardingQuizVariantFeedback.fromPartial({});
        return message;
    },
};
function createBaseOnboardingQuizVariantAnswer() {
    return { answer: '', correct: false };
}
exports.OnboardingQuizVariantAnswer = {
    fromJSON(object) {
        const message = {
            answer: isSet(object.answer) ? globalThis.String(object.answer) : '',
            correct: isSet(object.correct) ? globalThis.Boolean(object.correct) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.answer !== '') {
            obj.answer = message.answer;
        }
        if (message.correct !== false) {
            obj.correct = message.correct;
        }
        return obj;
    },
    create(base) {
        return exports.OnboardingQuizVariantAnswer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOnboardingQuizVariantAnswer();
        message.answer = object.answer ?? '';
        message.correct = object.correct ?? false;
        return message;
    },
};
function createBaseOnboardingQuizVariantFeedback() {
    return { default: '', correct: '', incorrect: '' };
}
exports.OnboardingQuizVariantFeedback = {
    fromJSON(object) {
        const message = {
            default: isSet(object.default) ? globalThis.String(object.default) : '',
        };
        if (isSet(object.correct)) {
            message.correct = globalThis.String(object.correct);
        }
        if (isSet(object.incorrect)) {
            message.incorrect = globalThis.String(object.incorrect);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.default !== '') {
            obj.default = message.default;
        }
        if (message.correct !== undefined && message.correct !== '') {
            obj.correct = message.correct;
        }
        if (message.incorrect !== undefined && message.incorrect !== '') {
            obj.incorrect = message.incorrect;
        }
        return obj;
    },
    create(base) {
        return exports.OnboardingQuizVariantFeedback.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOnboardingQuizVariantFeedback();
        message.default = object.default ?? '';
        message.correct = object.correct ?? '';
        message.incorrect = object.incorrect ?? '';
        return message;
    },
};
function createBaseQuizShareMessageVariant() {
    return { value: '' };
}
exports.QuizShareMessageVariant = {
    fromJSON(object) {
        const message = {
            value: isSet(object.value) ? globalThis.String(object.value) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.value !== '') {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.QuizShareMessageVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQuizShareMessageVariant();
        message.value = object.value ?? '';
        return message;
    },
};
function createBaseHideSuggestedReferralsVariant() {
    return { delayDays: 0 };
}
exports.HideSuggestedReferralsVariant = {
    fromJSON(object) {
        const message = {
            delayDays: isSet(object.delayDays) ? globalThis.Number(object.delayDays) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.delayDays !== 0) {
            obj.delayDays = Math.round(message.delayDays);
        }
        return obj;
    },
    create(base) {
        return exports.HideSuggestedReferralsVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHideSuggestedReferralsVariant();
        message.delayDays = object.delayDays ?? 0;
        return message;
    },
};
function createBaseRequiredMinFundingAmountVariant() {
    return { amount: 0 };
}
exports.RequiredMinFundingAmountVariant = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== 0) {
            obj.amount = message.amount;
        }
        return obj;
    },
    create(base) {
        return exports.RequiredMinFundingAmountVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRequiredMinFundingAmountVariant();
        message.amount = object.amount ?? 0;
        return message;
    },
};
function createBaseStepBlackWaitlistVariant() {
    return { message: '', title: '', terms: '', termsUrl: '', shareSmsText: '', shareMessage: '' };
}
exports.StepBlackWaitlistVariant = {
    fromJSON(object) {
        const message = {
            message: isSet(object.message) ? globalThis.String(object.message) : '',
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            terms: isSet(object.terms) ? globalThis.String(object.terms) : '',
            termsUrl: isSet(object.termsUrl) ? globalThis.String(object.termsUrl) : '',
            shareSmsText: isSet(object.shareSmsText) ? globalThis.String(object.shareSmsText) : '',
            shareMessage: isSet(object.shareMessage) ? globalThis.String(object.shareMessage) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== '') {
            obj.message = message.message;
        }
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.terms !== '') {
            obj.terms = message.terms;
        }
        if (message.termsUrl !== '') {
            obj.termsUrl = message.termsUrl;
        }
        if (message.shareSmsText !== '') {
            obj.shareSmsText = message.shareSmsText;
        }
        if (message.shareMessage !== '') {
            obj.shareMessage = message.shareMessage;
        }
        return obj;
    },
    create(base) {
        return exports.StepBlackWaitlistVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStepBlackWaitlistVariant();
        message.message = object.message ?? '';
        message.title = object.title ?? '';
        message.terms = object.terms ?? '';
        message.termsUrl = object.termsUrl ?? '';
        message.shareSmsText = object.shareSmsText ?? '';
        message.shareMessage = object.shareMessage ?? '';
        return message;
    },
};
function createBaseSuggestedTransferAmountVariant() {
    return { funding: undefined, transfer: undefined };
}
exports.SuggestedTransferAmountVariant = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.funding)) {
            message.funding = exports.SuggestedTransferAmountVariantTransferFlowConfig.fromJSON(object.funding);
        }
        if (isSet(object.transfer)) {
            message.transfer = exports.SuggestedTransferAmountVariantTransferFlowConfig.fromJSON(object.transfer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.funding !== undefined) {
            obj.funding = exports.SuggestedTransferAmountVariantTransferFlowConfig.toJSON(message.funding);
        }
        if (message.transfer !== undefined) {
            obj.transfer = exports.SuggestedTransferAmountVariantTransferFlowConfig.toJSON(message.transfer);
        }
        return obj;
    },
    create(base) {
        return exports.SuggestedTransferAmountVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSuggestedTransferAmountVariant();
        message.funding = (object.funding !== undefined && object.funding !== null)
            ? exports.SuggestedTransferAmountVariantTransferFlowConfig.fromPartial(object.funding)
            : undefined;
        message.transfer = (object.transfer !== undefined && object.transfer !== null)
            ? exports.SuggestedTransferAmountVariantTransferFlowConfig.fromPartial(object.transfer)
            : undefined;
        return message;
    },
};
function createBaseSuggestedTransferAmountVariantTransferFlowConfig() {
    return {
        suggestionModal: [],
        suggestionButtons: [],
        minimumAmount: 0,
        skipTransferScreenWithSuggestedAmount: false,
    };
}
exports.SuggestedTransferAmountVariantTransferFlowConfig = {
    fromJSON(object) {
        const message = {
            suggestionModal: globalThis.Array.isArray(object?.suggestionModal)
                ? object.suggestionModal.map((e) => globalThis.Number(e))
                : [],
            suggestionButtons: globalThis.Array.isArray(object?.suggestionButtons)
                ? object.suggestionButtons.map((e) => globalThis.Number(e))
                : [],
            minimumAmount: isSet(object.minimumAmount) ? globalThis.Number(object.minimumAmount) : 0,
            skipTransferScreenWithSuggestedAmount: isSet(object.skipTransferScreenWithSuggestedAmount)
                ? globalThis.Boolean(object.skipTransferScreenWithSuggestedAmount)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.suggestionModal?.length) {
            obj.suggestionModal = message.suggestionModal;
        }
        if (message.suggestionButtons?.length) {
            obj.suggestionButtons = message.suggestionButtons;
        }
        if (message.minimumAmount !== 0) {
            obj.minimumAmount = message.minimumAmount;
        }
        if (message.skipTransferScreenWithSuggestedAmount !== false) {
            obj.skipTransferScreenWithSuggestedAmount = message.skipTransferScreenWithSuggestedAmount;
        }
        return obj;
    },
    create(base) {
        return exports.SuggestedTransferAmountVariantTransferFlowConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSuggestedTransferAmountVariantTransferFlowConfig();
        message.suggestionModal = object.suggestionModal?.map((e) => e) || [];
        message.suggestionButtons = object.suggestionButtons?.map((e) => e) || [];
        message.minimumAmount = object.minimumAmount ?? 0;
        message.skipTransferScreenWithSuggestedAmount = object.skipTransferScreenWithSuggestedAmount ??
            false;
        return message;
    },
};
function createBaseSoloVsParentDecisionAgeVariant() {
    return { age: 0 };
}
exports.SoloVsParentDecisionAgeVariant = {
    fromJSON(object) {
        const message = {
            age: isSet(object.age) ? globalThis.Number(object.age) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.age !== 0) {
            obj.age = Math.round(message.age);
        }
        return obj;
    },
    create(base) {
        return exports.SoloVsParentDecisionAgeVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSoloVsParentDecisionAgeVariant();
        message.age = object.age ?? 0;
        return message;
    },
};
function createBasePayOverTimeBorrowCashVariant() {
    return { allowTransactions: false };
}
exports.PayOverTimeBorrowCashVariant = {
    fromJSON(object) {
        const message = {
            allowTransactions: isSet(object.allowTransactions)
                ? globalThis.Boolean(object.allowTransactions)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.allowTransactions !== false) {
            obj.allowTransactions = message.allowTransactions;
        }
        return obj;
    },
    create(base) {
        return exports.PayOverTimeBorrowCashVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePayOverTimeBorrowCashVariant();
        message.allowTransactions = object.allowTransactions ?? false;
        return message;
    },
};
function createBaseDynamicReferralCampaignsVariant() {
    return { campaignId: '' };
}
exports.DynamicReferralCampaignsVariant = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.campaignId)) {
            message.campaignId = globalThis.String(object.campaignId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.campaignId !== undefined && message.campaignId !== '') {
            obj.campaignId = message.campaignId;
        }
        return obj;
    },
    create(base) {
        return exports.DynamicReferralCampaignsVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDynamicReferralCampaignsVariant();
        message.campaignId = object.campaignId ?? '';
        return message;
    },
};
function createBaseWelcomeOfferVariant() {
    return { delay: '' };
}
exports.WelcomeOfferVariant = {
    fromJSON(object) {
        const message = {
            delay: isSet(object.delay) ? globalThis.String(object.delay) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.delay !== '') {
            obj.delay = message.delay;
        }
        return obj;
    },
    create(base) {
        return exports.WelcomeOfferVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWelcomeOfferVariant();
        message.delay = object.delay ?? '';
        return message;
    },
};
function createBaseTiersVariant() {
    return {
        basic: exports.TiersVariantTierUpsell.fromPartial({}),
        plus: exports.TiersVariantTierUpsell.fromPartial({}),
        black: exports.TiersVariantTierUpsell.fromPartial({}),
    };
}
exports.TiersVariant = {
    fromJSON(object) {
        const message = {
            basic: isSet(object.basic)
                ? exports.TiersVariantTierUpsell.fromJSON(object.basic)
                : exports.TiersVariantTierUpsell.fromPartial({}),
            plus: isSet(object.plus)
                ? exports.TiersVariantTierUpsell.fromJSON(object.plus)
                : exports.TiersVariantTierUpsell.fromPartial({}),
            black: isSet(object.black)
                ? exports.TiersVariantTierUpsell.fromJSON(object.black)
                : exports.TiersVariantTierUpsell.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.basic !== undefined) {
            obj.basic = exports.TiersVariantTierUpsell.toJSON(message.basic);
        }
        if (message.plus !== undefined) {
            obj.plus = exports.TiersVariantTierUpsell.toJSON(message.plus);
        }
        if (message.black !== undefined) {
            obj.black = exports.TiersVariantTierUpsell.toJSON(message.black);
        }
        return obj;
    },
    create(base) {
        return exports.TiersVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTiersVariant();
        message.basic = (object.basic !== undefined && object.basic !== null)
            ? exports.TiersVariantTierUpsell.fromPartial(object.basic)
            : exports.TiersVariantTierUpsell.fromPartial({});
        message.plus = (object.plus !== undefined && object.plus !== null)
            ? exports.TiersVariantTierUpsell.fromPartial(object.plus)
            : exports.TiersVariantTierUpsell.fromPartial({});
        message.black = (object.black !== undefined && object.black !== null)
            ? exports.TiersVariantTierUpsell.fromPartial(object.black)
            : exports.TiersVariantTierUpsell.fromPartial({});
        return message;
    },
};
function createBaseTiersVariantTierUpsell() {
    return { summary: '', full: '', headerImageUrls: [] };
}
exports.TiersVariantTierUpsell = {
    fromJSON(object) {
        const message = {
            headerImageUrls: globalThis.Array.isArray(object?.headerImageUrls)
                ? object.headerImageUrls.map((e) => globalThis.String(e))
                : [],
        };
        if (isSet(object.summary)) {
            message.summary = globalThis.String(object.summary);
        }
        if (isSet(object.full)) {
            message.full = globalThis.String(object.full);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.summary !== undefined && message.summary !== '') {
            obj.summary = message.summary;
        }
        if (message.full !== undefined && message.full !== '') {
            obj.full = message.full;
        }
        if (message.headerImageUrls?.length) {
            obj.headerImageUrls = message.headerImageUrls;
        }
        return obj;
    },
    create(base) {
        return exports.TiersVariantTierUpsell.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTiersVariantTierUpsell();
        message.summary = object.summary ?? '';
        message.full = object.full ?? '';
        message.headerImageUrls = object.headerImageUrls?.map((e) => e) || [];
        return message;
    },
};
function createBaseEmancipationVariant() {
    return { emancipationIntro: [] };
}
exports.EmancipationVariant = {
    fromJSON(object) {
        const message = {
            emancipationIntro: globalThis.Array.isArray(object?.emancipationIntro)
                ? object.emancipationIntro.map((e) => exports.EmancipationVariantEmancipationIntro.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.emancipationIntro?.length) {
            obj.emancipationIntro = message.emancipationIntro.map((e) => exports.EmancipationVariantEmancipationIntro.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.EmancipationVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEmancipationVariant();
        message.emancipationIntro =
            object.emancipationIntro?.map((e) => exports.EmancipationVariantEmancipationIntro.fromPartial(e)) ||
                [];
        return message;
    },
};
function createBaseEmancipationVariantEmancipationIntro() {
    return {
        id: '',
        caption: '',
        illustration: '',
        message: exports.EmancipationVariantEmancipationIntroEmancipationMessage.fromPartial({}),
        messageAlt: undefined,
        primaryLabel: '',
    };
}
exports.EmancipationVariantEmancipationIntro = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            caption: isSet(object.caption) ? globalThis.String(object.caption) : '',
            illustration: isSet(object.illustration) ? globalThis.String(object.illustration) : '',
            message: isSet(object.message)
                ? exports.EmancipationVariantEmancipationIntroEmancipationMessage.fromJSON(object.message)
                : exports.EmancipationVariantEmancipationIntroEmancipationMessage.fromPartial({}),
            primaryLabel: isSet(object.primaryLabel) ? globalThis.String(object.primaryLabel) : '',
        };
        if (isSet(object.messageAlt)) {
            message.messageAlt = exports.EmancipationVariantEmancipationIntroEmancipationMessage.fromJSON(object.messageAlt);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.caption !== '') {
            obj.caption = message.caption;
        }
        if (message.illustration !== '') {
            obj.illustration = message.illustration;
        }
        if (message.message !== undefined) {
            obj.message = exports.EmancipationVariantEmancipationIntroEmancipationMessage.toJSON(message.message);
        }
        if (message.messageAlt !== undefined) {
            obj.messageAlt = exports.EmancipationVariantEmancipationIntroEmancipationMessage.toJSON(message.messageAlt);
        }
        if (message.primaryLabel !== '') {
            obj.primaryLabel = message.primaryLabel;
        }
        return obj;
    },
    create(base) {
        return exports.EmancipationVariantEmancipationIntro.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEmancipationVariantEmancipationIntro();
        message.id = object.id ?? '';
        message.caption = object.caption ?? '';
        message.illustration = object.illustration ?? '';
        message.message = (object.message !== undefined && object.message !== null)
            ? exports.EmancipationVariantEmancipationIntroEmancipationMessage.fromPartial(object.message)
            : exports.EmancipationVariantEmancipationIntroEmancipationMessage.fromPartial({});
        message.messageAlt = (object.messageAlt !== undefined && object.messageAlt !== null)
            ? exports.EmancipationVariantEmancipationIntroEmancipationMessage.fromPartial(object.messageAlt)
            : undefined;
        message.primaryLabel = object.primaryLabel ?? '';
        return message;
    },
};
function createBaseEmancipationVariantEmancipationIntroEmancipationMessage() {
    return { message: '', subMessage: '' };
}
exports.EmancipationVariantEmancipationIntroEmancipationMessage = {
    fromJSON(object) {
        const message = {
            message: isSet(object.message) ? globalThis.String(object.message) : '',
        };
        if (isSet(object.subMessage)) {
            message.subMessage = globalThis.String(object.subMessage);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== '') {
            obj.message = message.message;
        }
        if (message.subMessage !== undefined && message.subMessage !== '') {
            obj.subMessage = message.subMessage;
        }
        return obj;
    },
    create(base) {
        return exports.EmancipationVariantEmancipationIntroEmancipationMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEmancipationVariantEmancipationIntroEmancipationMessage();
        message.message = object.message ?? '';
        message.subMessage = object.subMessage ?? '';
        return message;
    },
};
function createBaseUserTierReferralCampaignVariant() {
    return { campaignId: undefined, inviteMessage: undefined };
}
exports.UserTierReferralCampaignVariant = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.campaignId)) {
            message.campaignId = exports.UserTierReferralCampaignVariantCampaignId.fromJSON(object.campaignId);
        }
        if (isSet(object.inviteMessage)) {
            message.inviteMessage = exports.UserTierReferralCampaignVariantInviteMessage.fromJSON(object.inviteMessage);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.campaignId !== undefined) {
            obj.campaignId = exports.UserTierReferralCampaignVariantCampaignId.toJSON(message.campaignId);
        }
        if (message.inviteMessage !== undefined) {
            obj.inviteMessage = exports.UserTierReferralCampaignVariantInviteMessage.toJSON(message.inviteMessage);
        }
        return obj;
    },
    create(base) {
        return exports.UserTierReferralCampaignVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserTierReferralCampaignVariant();
        message.campaignId = (object.campaignId !== undefined && object.campaignId !== null)
            ? exports.UserTierReferralCampaignVariantCampaignId.fromPartial(object.campaignId)
            : undefined;
        message.inviteMessage = (object.inviteMessage !== undefined && object.inviteMessage !== null)
            ? exports.UserTierReferralCampaignVariantInviteMessage.fromPartial(object.inviteMessage)
            : undefined;
        return message;
    },
};
function createBaseUserTierReferralCampaignVariantCampaignId() {
    return { basic: '', plus: '', black: '' };
}
exports.UserTierReferralCampaignVariantCampaignId = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.basic)) {
            message.basic = globalThis.String(object.basic);
        }
        if (isSet(object.plus)) {
            message.plus = globalThis.String(object.plus);
        }
        if (isSet(object.black)) {
            message.black = globalThis.String(object.black);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.basic !== undefined && message.basic !== '') {
            obj.basic = message.basic;
        }
        if (message.plus !== undefined && message.plus !== '') {
            obj.plus = message.plus;
        }
        if (message.black !== undefined && message.black !== '') {
            obj.black = message.black;
        }
        return obj;
    },
    create(base) {
        return exports.UserTierReferralCampaignVariantCampaignId.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserTierReferralCampaignVariantCampaignId();
        message.basic = object.basic ?? '';
        message.plus = object.plus ?? '';
        message.black = object.black ?? '';
        return message;
    },
};
function createBaseUserTierReferralCampaignVariantInviteMessage() {
    return { basic: '', plus: '', black: '' };
}
exports.UserTierReferralCampaignVariantInviteMessage = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.basic)) {
            message.basic = globalThis.String(object.basic);
        }
        if (isSet(object.plus)) {
            message.plus = globalThis.String(object.plus);
        }
        if (isSet(object.black)) {
            message.black = globalThis.String(object.black);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.basic !== undefined && message.basic !== '') {
            obj.basic = message.basic;
        }
        if (message.plus !== undefined && message.plus !== '') {
            obj.plus = message.plus;
        }
        if (message.black !== undefined && message.black !== '') {
            obj.black = message.black;
        }
        return obj;
    },
    create(base) {
        return exports.UserTierReferralCampaignVariantInviteMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserTierReferralCampaignVariantInviteMessage();
        message.basic = object.basic ?? '';
        message.plus = object.plus ?? '';
        message.black = object.black ?? '';
        return message;
    },
};
function createBaseGiftCardVariant() {
    return { pollingDurationSeconds: 0 };
}
exports.GiftCardVariant = {
    fromJSON(object) {
        const message = {
            pollingDurationSeconds: isSet(object.pollingDurationSeconds)
                ? globalThis.Number(object.pollingDurationSeconds)
                : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.pollingDurationSeconds !== 0) {
            obj.pollingDurationSeconds = Math.round(message.pollingDurationSeconds);
        }
        return obj;
    },
    create(base) {
        return exports.GiftCardVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGiftCardVariant();
        message.pollingDurationSeconds = object.pollingDurationSeconds ?? 0;
        return message;
    },
};
function createBaseSignupInterestSurveyVariant() {
    return { title: '', subtitle: '', options: [] };
}
exports.SignupInterestSurveyVariant = {
    fromJSON(object) {
        const message = {
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            subtitle: isSet(object.subtitle) ? globalThis.String(object.subtitle) : '',
        };
        if (globalThis.Array.isArray(object?.options)) {
            message.options = object.options.map((e) => globalThis.String(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.subtitle !== '') {
            obj.subtitle = message.subtitle;
        }
        if (message.options?.length) {
            obj.options = message.options;
        }
        return obj;
    },
    create(base) {
        return exports.SignupInterestSurveyVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSignupInterestSurveyVariant();
        message.title = object.title ?? '';
        message.subtitle = object.subtitle ?? '';
        message.options = object.options?.map((e) => e) || [];
        return message;
    },
};
function createBaseDirectDepositInOnboardingVariant() {
    return { dependentOnInterestSurvey: false };
}
exports.DirectDepositInOnboardingVariant = {
    fromJSON(object) {
        const message = {
            dependentOnInterestSurvey: isSet(object.dependentOnInterestSurvey)
                ? globalThis.Boolean(object.dependentOnInterestSurvey)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.dependentOnInterestSurvey !== false) {
            obj.dependentOnInterestSurvey = message.dependentOnInterestSurvey;
        }
        return obj;
    },
    create(base) {
        return exports.DirectDepositInOnboardingVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDirectDepositInOnboardingVariant();
        message.dependentOnInterestSurvey = object.dependentOnInterestSurvey ?? false;
        return message;
    },
};
function createBaseAutoReloadVariant() {
    return {
        minBalanceMin: '',
        minBalanceDefault: '',
        reloadMin: '',
        reloadDefault: '',
        controlGroup: false,
    };
}
exports.AutoReloadVariant = {
    fromJSON(object) {
        const message = {
            minBalanceMin: isSet(object.minBalanceMin) ? globalThis.String(object.minBalanceMin) : '',
            minBalanceDefault: isSet(object.minBalanceDefault)
                ? globalThis.String(object.minBalanceDefault)
                : '',
            reloadMin: isSet(object.reloadMin) ? globalThis.String(object.reloadMin) : '',
            reloadDefault: isSet(object.reloadDefault) ? globalThis.String(object.reloadDefault) : '',
            controlGroup: isSet(object.controlGroup) ? globalThis.Boolean(object.controlGroup) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.minBalanceMin !== '') {
            obj.minBalanceMin = message.minBalanceMin;
        }
        if (message.minBalanceDefault !== '') {
            obj.minBalanceDefault = message.minBalanceDefault;
        }
        if (message.reloadMin !== '') {
            obj.reloadMin = message.reloadMin;
        }
        if (message.reloadDefault !== '') {
            obj.reloadDefault = message.reloadDefault;
        }
        if (message.controlGroup !== false) {
            obj.controlGroup = message.controlGroup;
        }
        return obj;
    },
    create(base) {
        return exports.AutoReloadVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAutoReloadVariant();
        message.minBalanceMin = object.minBalanceMin ?? '';
        message.minBalanceDefault = object.minBalanceDefault ?? '';
        message.reloadMin = object.reloadMin ?? '';
        message.reloadDefault = object.reloadDefault ?? '';
        message.controlGroup = object.controlGroup ?? false;
        return message;
    },
};
function createBaseServerSideFullScreenModalVariant() {
    return { types: [] };
}
exports.ServerSideFullScreenModalVariant = {
    fromJSON(object) {
        const message = {
            types: globalThis.Array.isArray(object?.types)
                ? object.types.map((e) => serverSideFullScreenModalVariantFullScreenModalTypeFromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.types?.length) {
            obj.types = message.types.map((e) => serverSideFullScreenModalVariantFullScreenModalTypeToJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ServerSideFullScreenModalVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseServerSideFullScreenModalVariant();
        message.types = object.types?.map((e) => e) || [];
        return message;
    },
};
function createBaseRecurringPaymentVariant() {
    return { minAmount: 0, defaultAmount: 0 };
}
exports.RecurringPaymentVariant = {
    fromJSON(object) {
        const message = {
            minAmount: isSet(object.minAmount) ? globalThis.Number(object.minAmount) : 0,
            defaultAmount: isSet(object.defaultAmount) ? globalThis.Number(object.defaultAmount) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.minAmount !== 0) {
            obj.minAmount = message.minAmount;
        }
        if (message.defaultAmount !== 0) {
            obj.defaultAmount = message.defaultAmount;
        }
        return obj;
    },
    create(base) {
        return exports.RecurringPaymentVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecurringPaymentVariant();
        message.minAmount = object.minAmount ?? 0;
        message.defaultAmount = object.defaultAmount ?? 0;
        return message;
    },
};
function createBaseDelayedReferralVariant() {
    return { minAccountAgeDays: undefined, accountProgressDone: undefined };
}
exports.DelayedReferralVariant = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.minAccountAgeDays)) {
            message.minAccountAgeDays = globalThis.Number(object.minAccountAgeDays);
        }
        if (isSet(object.accountProgressDone)) {
            message.accountProgressDone = globalThis.Boolean(object.accountProgressDone);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.minAccountAgeDays !== undefined) {
            obj.minAccountAgeDays = Math.round(message.minAccountAgeDays);
        }
        if (message.accountProgressDone !== undefined) {
            obj.accountProgressDone = message.accountProgressDone;
        }
        return obj;
    },
    create(base) {
        return exports.DelayedReferralVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDelayedReferralVariant();
        message.minAccountAgeDays = object.minAccountAgeDays ?? undefined;
        message.accountProgressDone = object.accountProgressDone ?? undefined;
        return message;
    },
};
function createBaseUnlockAppVariant() {
    return { defaultOn: false };
}
exports.UnlockAppVariant = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.defaultOn)) {
            message.defaultOn = globalThis.Boolean(object.defaultOn);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.defaultOn !== undefined && message.defaultOn !== false) {
            obj.defaultOn = message.defaultOn;
        }
        return obj;
    },
    create(base) {
        return exports.UnlockAppVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnlockAppVariant();
        message.defaultOn = object.defaultOn ?? false;
        return message;
    },
};
function createBaseMilestoneCtaOverrideVariant() {
    return { overrides: [] };
}
exports.MilestoneCtaOverrideVariant = {
    fromJSON(object) {
        const message = {
            overrides: globalThis.Array.isArray(object?.overrides)
                ? object.overrides.map((e) => exports.MilestoneCtaOverrideVariantOverride.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.overrides?.length) {
            obj.overrides = message.overrides.map((e) => exports.MilestoneCtaOverrideVariantOverride.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.MilestoneCtaOverrideVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMilestoneCtaOverrideVariant();
        message.overrides =
            object.overrides?.map((e) => exports.MilestoneCtaOverrideVariantOverride.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMilestoneCtaOverrideVariantOverride() {
    return { milestoneType: '', actions: [] };
}
exports.MilestoneCtaOverrideVariantOverride = {
    fromJSON(object) {
        const message = {
            milestoneType: isSet(object.milestoneType) ? globalThis.String(object.milestoneType) : '',
            actions: globalThis.Array.isArray(object?.actions)
                ? object.actions.map((e) => globalThis.String(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.milestoneType !== '') {
            obj.milestoneType = message.milestoneType;
        }
        if (message.actions?.length) {
            obj.actions = message.actions;
        }
        return obj;
    },
    create(base) {
        return exports.MilestoneCtaOverrideVariantOverride.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMilestoneCtaOverrideVariantOverride();
        message.milestoneType = object.milestoneType ?? '';
        message.actions = object.actions?.map((e) => e) || [];
        return message;
    },
};
function createBaseDirectDepositFundingRecommendationVariant() {
    return { title: '', subtitle: '' };
}
exports.DirectDepositFundingRecommendationVariant = {
    fromJSON(object) {
        const message = {
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            subtitle: isSet(object.subtitle) ? globalThis.String(object.subtitle) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.subtitle !== '') {
            obj.subtitle = message.subtitle;
        }
        return obj;
    },
    create(base) {
        return exports.DirectDepositFundingRecommendationVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDirectDepositFundingRecommendationVariant();
        message.title = object.title ?? '';
        message.subtitle = object.subtitle ?? '';
        return message;
    },
};
function createBaseOnboardingStepBlackVariant() {
    return {
        mode: OnboardingStepBlackVariantOnboardingStepBlackMode.INVALID_ONBOARDING_STEP_BLACK_MODE,
    };
}
exports.OnboardingStepBlackVariant = {
    fromJSON(object) {
        const message = {
            mode: isSet(object.mode)
                ? onboardingStepBlackVariantOnboardingStepBlackModeFromJSON(object.mode)
                : OnboardingStepBlackVariantOnboardingStepBlackMode.INVALID_ONBOARDING_STEP_BLACK_MODE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.mode !==
            OnboardingStepBlackVariantOnboardingStepBlackMode.INVALID_ONBOARDING_STEP_BLACK_MODE) {
            obj.mode = onboardingStepBlackVariantOnboardingStepBlackModeToJSON(message.mode);
        }
        return obj;
    },
    create(base) {
        return exports.OnboardingStepBlackVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOnboardingStepBlackVariant();
        message.mode = object.mode ??
            OnboardingStepBlackVariantOnboardingStepBlackMode.INVALID_ONBOARDING_STEP_BLACK_MODE;
        return message;
    },
};
function createBaseAlloyJourneyVersionVariant() {
    return { version: 0 };
}
exports.AlloyJourneyVersionVariant = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.version)) {
            message.version = globalThis.Number(object.version);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.version !== undefined && message.version !== 0) {
            obj.version = Math.round(message.version);
        }
        return obj;
    },
    create(base) {
        return exports.AlloyJourneyVersionVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAlloyJourneyVersionVariant();
        message.version = object.version ?? 0;
        return message;
    },
};
function createBaseDirectDepositUpdatesM1Variant() {
    return { defaultOn: false };
}
exports.DirectDepositUpdatesM1Variant = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.defaultOn)) {
            message.defaultOn = globalThis.Boolean(object.defaultOn);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.defaultOn !== undefined && message.defaultOn !== false) {
            obj.defaultOn = message.defaultOn;
        }
        return obj;
    },
    create(base) {
        return exports.DirectDepositUpdatesM1Variant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDirectDepositUpdatesM1Variant();
        message.defaultOn = object.defaultOn ?? false;
        return message;
    },
};
function createBaseTopMerchantsOnCardsScreenVariant() {
    return { defaultOn: false };
}
exports.TopMerchantsOnCardsScreenVariant = {
    fromJSON(object) {
        const message = {
            defaultOn: isSet(object.defaultOn) ? globalThis.Boolean(object.defaultOn) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.defaultOn !== false) {
            obj.defaultOn = message.defaultOn;
        }
        return obj;
    },
    create(base) {
        return exports.TopMerchantsOnCardsScreenVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTopMerchantsOnCardsScreenVariant();
        message.defaultOn = object.defaultOn ?? false;
        return message;
    },
};
function createBaseBirthday18OfferVariant() {
    return { enrollmentType: Birthday18OfferVariantEnrollmentType.INVALID_ENROLLMENT_TYPE };
}
exports.Birthday18OfferVariant = {
    fromJSON(object) {
        const message = {
            enrollmentType: isSet(object.enrollmentType)
                ? birthday18OfferVariantEnrollmentTypeFromJSON(object.enrollmentType)
                : Birthday18OfferVariantEnrollmentType.INVALID_ENROLLMENT_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enrollmentType !== Birthday18OfferVariantEnrollmentType.INVALID_ENROLLMENT_TYPE) {
            obj.enrollmentType = birthday18OfferVariantEnrollmentTypeToJSON(message.enrollmentType);
        }
        return obj;
    },
    create(base) {
        return exports.Birthday18OfferVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBirthday18OfferVariant();
        message.enrollmentType = object.enrollmentType ??
            Birthday18OfferVariantEnrollmentType.INVALID_ENROLLMENT_TYPE;
        return message;
    },
};
function createBasePotConfigurableAprVariant() {
    return { apr: 0 };
}
exports.PotConfigurableAprVariant = {
    fromJSON(object) {
        const message = {
            apr: isSet(object.apr) ? globalThis.Number(object.apr) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.apr !== 0) {
            obj.apr = message.apr;
        }
        return obj;
    },
    create(base) {
        return exports.PotConfigurableAprVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePotConfigurableAprVariant();
        message.apr = object.apr ?? 0;
        return message;
    },
};
function createBasePotLateFeeVariant() {
    return { amount: 0 };
}
exports.PotLateFeeVariant = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== 0) {
            obj.amount = message.amount;
        }
        return obj;
    },
    create(base) {
        return exports.PotLateFeeVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePotLateFeeVariant();
        message.amount = object.amount ?? 0;
        return message;
    },
};
function createBaseMoveMoneyV2Variant() {
    return { enabled: false };
}
exports.MoveMoneyV2Variant = {
    fromJSON(object) {
        const message = {
            enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        return obj;
    },
    create(base) {
        return exports.MoveMoneyV2Variant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMoveMoneyV2Variant();
        message.enabled = object.enabled ?? false;
        return message;
    },
};
function createBaseFriendsTriviaLeaderboardVariant() {
    return {
        inviteMessage: exports.FriendsTriviaLeaderboardVariantInviteMessage.fromPartial({}),
        controlGroup: false,
    };
}
exports.FriendsTriviaLeaderboardVariant = {
    fromJSON(object) {
        const message = {
            inviteMessage: isSet(object.inviteMessage)
                ? exports.FriendsTriviaLeaderboardVariantInviteMessage.fromJSON(object.inviteMessage)
                : exports.FriendsTriviaLeaderboardVariantInviteMessage.fromPartial({}),
            controlGroup: isSet(object.controlGroup) ? globalThis.Boolean(object.controlGroup) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.inviteMessage !== undefined) {
            obj.inviteMessage = exports.FriendsTriviaLeaderboardVariantInviteMessage.toJSON(message.inviteMessage);
        }
        if (message.controlGroup !== false) {
            obj.controlGroup = message.controlGroup;
        }
        return obj;
    },
    create(base) {
        return exports.FriendsTriviaLeaderboardVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFriendsTriviaLeaderboardVariant();
        message.inviteMessage = (object.inviteMessage !== undefined && object.inviteMessage !== null)
            ? exports.FriendsTriviaLeaderboardVariantInviteMessage.fromPartial(object.inviteMessage)
            : exports.FriendsTriviaLeaderboardVariantInviteMessage.fromPartial({});
        message.controlGroup = object.controlGroup ?? false;
        return message;
    },
};
function createBaseFriendsTriviaLeaderboardVariantInviteMessage() {
    return { title: '', subtitle: '' };
}
exports.FriendsTriviaLeaderboardVariantInviteMessage = {
    fromJSON(object) {
        const message = {
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            subtitle: isSet(object.subtitle) ? globalThis.String(object.subtitle) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.subtitle !== '') {
            obj.subtitle = message.subtitle;
        }
        return obj;
    },
    create(base) {
        return exports.FriendsTriviaLeaderboardVariantInviteMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFriendsTriviaLeaderboardVariantInviteMessage();
        message.title = object.title ?? '';
        message.subtitle = object.subtitle ?? '';
        return message;
    },
};
function createBaseSpinTheWheelVariant() {
    return {
        backgroundImageUrl: '',
        wheelImageUrl: '',
        pointerImageUrl: '',
        rewards: [],
        excludeStates: [],
    };
}
exports.SpinTheWheelVariant = {
    fromJSON(object) {
        const message = {
            backgroundImageUrl: isSet(object.backgroundImageUrl)
                ? globalThis.String(object.backgroundImageUrl)
                : '',
            wheelImageUrl: isSet(object.wheelImageUrl) ? globalThis.String(object.wheelImageUrl) : '',
            pointerImageUrl: isSet(object.pointerImageUrl)
                ? globalThis.String(object.pointerImageUrl)
                : '',
            rewards: globalThis.Array.isArray(object?.rewards)
                ? object.rewards.map((e) => amount_1.Amount.fromJSON(e))
                : [],
            excludeStates: globalThis.Array.isArray(object?.excludeStates)
                ? object.excludeStates.map((e) => globalThis.String(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.backgroundImageUrl !== '') {
            obj.backgroundImageUrl = message.backgroundImageUrl;
        }
        if (message.wheelImageUrl !== '') {
            obj.wheelImageUrl = message.wheelImageUrl;
        }
        if (message.pointerImageUrl !== '') {
            obj.pointerImageUrl = message.pointerImageUrl;
        }
        if (message.rewards?.length) {
            obj.rewards = message.rewards.map((e) => amount_1.Amount.toJSON(e));
        }
        if (message.excludeStates?.length) {
            obj.excludeStates = message.excludeStates;
        }
        return obj;
    },
    create(base) {
        return exports.SpinTheWheelVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSpinTheWheelVariant();
        message.backgroundImageUrl = object.backgroundImageUrl ?? '';
        message.wheelImageUrl = object.wheelImageUrl ?? '';
        message.pointerImageUrl = object.pointerImageUrl ?? '';
        message.rewards = object.rewards?.map((e) => amount_1.Amount.fromPartial(e)) || [];
        message.excludeStates = object.excludeStates?.map((e) => e) || [];
        return message;
    },
};
function createBaseDirectDepositUpdatesM1V2Variant() {
    return { enabled: false };
}
exports.DirectDepositUpdatesM1V2Variant = {
    fromJSON(object) {
        const message = {
            enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        return obj;
    },
    create(base) {
        return exports.DirectDepositUpdatesM1V2Variant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDirectDepositUpdatesM1V2Variant();
        message.enabled = object.enabled ?? false;
        return message;
    },
};
function createBaseEarnWithStepVariant() {
    return { title: '' };
}
exports.EarnWithStepVariant = {
    fromJSON(object) {
        const message = {
            title: isSet(object.title) ? globalThis.String(object.title) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== '') {
            obj.title = message.title;
        }
        return obj;
    },
    create(base) {
        return exports.EarnWithStepVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEarnWithStepVariant();
        message.title = object.title ?? '';
        return message;
    },
};
function createBaseGigsMobileVariant() {
    return { primerTitle: '', primerContent: '' };
}
exports.GigsMobileVariant = {
    fromJSON(object) {
        const message = {
            primerTitle: isSet(object.primerTitle) ? globalThis.String(object.primerTitle) : '',
            primerContent: isSet(object.primerContent) ? globalThis.String(object.primerContent) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primerTitle !== '') {
            obj.primerTitle = message.primerTitle;
        }
        if (message.primerContent !== '') {
            obj.primerContent = message.primerContent;
        }
        return obj;
    },
    create(base) {
        return exports.GigsMobileVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGigsMobileVariant();
        message.primerTitle = object.primerTitle ?? '';
        message.primerContent = object.primerContent ?? '';
        return message;
    },
};
function createBaseCopyVariant() {
    return { group: CopyVariantCopyVariantGroup.INVALID_COPY_VARIANT_GROUP };
}
exports.CopyVariant = {
    fromJSON(object) {
        const message = {
            group: isSet(object.group)
                ? copyVariantCopyVariantGroupFromJSON(object.group)
                : CopyVariantCopyVariantGroup.INVALID_COPY_VARIANT_GROUP,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.group !== CopyVariantCopyVariantGroup.INVALID_COPY_VARIANT_GROUP) {
            obj.group = copyVariantCopyVariantGroupToJSON(message.group);
        }
        return obj;
    },
    create(base) {
        return exports.CopyVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCopyVariant();
        message.group = object.group ?? CopyVariantCopyVariantGroup.INVALID_COPY_VARIANT_GROUP;
        return message;
    },
};
function featureFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_FEATURE':
            return Feature.INVALID_FEATURE;
        case 1:
        case 'GET_A_CARD':
            return Feature.GET_A_CARD;
        case 2:
        case 'REPORT_MERCHANT_LOCATION':
            return Feature.REPORT_MERCHANT_LOCATION;
        case 4:
        case 'ACCOUNT_STATEMENTS':
            return Feature.ACCOUNT_STATEMENTS;
        case 5:
        case 'COACHING_MODALS':
            return Feature.COACHING_MODALS;
        case 6:
        case 'PERSONALIZED_COLOR':
            return Feature.PERSONALIZED_COLOR;
        case 7:
        case 'DARK_MODE':
            return Feature.DARK_MODE;
        case 8:
        case 'ACH_ACCOUNT':
            return Feature.ACH_ACCOUNT;
        case 9:
        case 'CARD_DESIGN':
            return Feature.CARD_DESIGN;
        case 10:
        case 'TEEN_LINK_DEBIT_CARD':
            return Feature.TEEN_LINK_DEBIT_CARD;
        case 11:
        case 'SPONSORSHIP_REQUEST_INCENTIVE':
            return Feature.SPONSORSHIP_REQUEST_INCENTIVE;
        case 12:
        case 'REFERRALS':
            return Feature.REFERRALS;
        case 13:
        case 'PERSONA_DOCUMENT_VERIFICATION':
            return Feature.PERSONA_DOCUMENT_VERIFICATION;
        case 14:
        case 'RECURRING_TRANSFERS':
            return Feature.RECURRING_TRANSFERS;
        case 15:
        case 'LINK_ACH_ACCOUNT':
            return Feature.LINK_ACH_ACCOUNT;
        case 16:
        case 'DEVELOPER_UX':
            return Feature.DEVELOPER_UX;
        case 17:
        case 'STEP_SQUAD':
            return Feature.STEP_SQUAD;
        case 18:
        case 'STEP_SQUAD_MEMBER':
            return Feature.STEP_SQUAD_MEMBER;
        case 19:
        case 'APP_RATING':
            return Feature.APP_RATING;
        case 20:
        case 'CUSTOM_PROFILE_PICTURE':
            return Feature.CUSTOM_PROFILE_PICTURE;
        case 21:
        case 'SHOW_DECLINES':
            return Feature.SHOW_DECLINES;
        case 22:
        case 'ATM':
            return Feature.ATM;
        case 24:
        case 'SHOW_RECURRING_PAYMENTS_MORE_OFTEN':
            return Feature.SHOW_RECURRING_PAYMENTS_MORE_OFTEN;
        case 25:
        case 'SSN_LAST_4_DIGITS':
            return Feature.SSN_LAST_4_DIGITS;
        case 26:
        case 'DELAYED_REFERRAL_REDEMPTION':
            return Feature.DELAYED_REFERRAL_REDEMPTION;
        case 27:
        case 'REVERSE_CARD_COLORS':
            return Feature.REVERSE_CARD_COLORS;
        case 28:
        case 'VALIDATE_SHIPPING_ADDRESS':
            return Feature.VALIDATE_SHIPPING_ADDRESS;
        case 29:
        case 'EMAIL_BASED_RECOVERY':
            return Feature.EMAIL_BASED_RECOVERY;
        case 30:
        case 'VIRTUAL_CARD':
            return Feature.VIRTUAL_CARD;
        case 31:
        case 'RETRYABLE_KYC':
            return Feature.RETRYABLE_KYC;
        case 32:
        case 'SSO':
            return Feature.SSO;
        case 37:
        case 'SSO_V2':
            return Feature.SSO_V2;
        case 35:
        case 'EXPERIMENTAL':
            return Feature.EXPERIMENTAL;
        case 36:
        case 'POST_SIGNUP_SSO':
            return Feature.POST_SIGNUP_SSO;
        case 38:
        case 'EDITABLE_PROFILE':
            return Feature.EDITABLE_PROFILE;
        case 39:
        case 'REPLACE_CARD_NAME_CHANGE':
            return Feature.REPLACE_CARD_NAME_CHANGE;
        case 40:
        case 'WARNING_SMS_OTP_MESSAGE':
            return Feature.WARNING_SMS_OTP_MESSAGE;
        case 41:
        case 'DEBIT_CARD_SCANNER':
            return Feature.DEBIT_CARD_SCANNER;
        case 42:
        case 'CONTENT_CARDS_ONBOARDING':
            return Feature.CONTENT_CARDS_ONBOARDING;
        case 44:
        case 'SYNC_CONTACTS':
            return Feature.SYNC_CONTACTS;
        case 45:
        case 'PARENT_HOMESCREEN':
            return Feature.PARENT_HOMESCREEN;
        case 46:
        case 'AUTOMATED_TRANSACTION_DISPUTES':
            return Feature.AUTOMATED_TRANSACTION_DISPUTES;
        case 47:
        case 'PLAID_LINK_OAUTH':
            return Feature.PLAID_LINK_OAUTH;
        case 48:
        case 'GET_STARTED_COPY':
            return Feature.GET_STARTED_COPY;
        case 49:
        case 'CASH_DEPOSIT':
            return Feature.CASH_DEPOSIT;
        case 52:
        case 'IOS_APP_TRACKING':
            return Feature.IOS_APP_TRACKING;
        case 53:
        case 'REFERRAL_CODE_MANUAL_ENTRY':
            return Feature.REFERRAL_CODE_MANUAL_ENTRY;
        case 55:
        case 'MONITOR_APP_NOT_RESPONDING':
            return Feature.MONITOR_APP_NOT_RESPONDING;
        case 56:
        case 'ATM_PIN_WITHOUT_OTP':
            return Feature.ATM_PIN_WITHOUT_OTP;
        case 57:
        case 'VOICE_OTP':
            return Feature.VOICE_OTP;
        case 58:
        case 'DYNAMIC_REFERRAL_CAMPAIGNS':
            return Feature.DYNAMIC_REFERRAL_CAMPAIGNS;
        case 60:
        case 'REIMBURSING_TRANSACTIONS':
            return Feature.REIMBURSING_TRANSACTIONS;
        case 61:
        case 'FAMILY_MANAGEMENT':
            return Feature.FAMILY_MANAGEMENT;
        case 62:
        case 'REFERRAL_CONTACT_PICKER':
            return Feature.REFERRAL_CONTACT_PICKER;
        case 63:
        case 'RECURRING_PAYMENTS_V2':
            return Feature.RECURRING_PAYMENTS_V2;
        case 64:
        case 'APP_DIAGNOSTICS_BUG_REPORT':
            return Feature.APP_DIAGNOSTICS_BUG_REPORT;
        case 65:
        case 'DATASTORE_LOAD_RANDOM_ERROR':
            return Feature.DATASTORE_LOAD_RANDOM_ERROR;
        case 66:
        case 'REFERRAL_TRACKING':
            return Feature.REFERRAL_TRACKING;
        case 67:
        case 'REFERRAL_CELL_TOP':
            return Feature.REFERRAL_CELL_TOP;
        case 68:
        case 'REFERRAL_FAMILY_CELL':
            return Feature.REFERRAL_FAMILY_CELL;
        case 69:
        case 'WEB_SPONSOR_APPROVAL':
            return Feature.WEB_SPONSOR_APPROVAL;
        case 70:
        case 'SPONSOR_FREE_FUNDING':
            return Feature.SPONSOR_FREE_FUNDING;
        case 71:
        case 'ATM_MAP_NATIVE':
            return Feature.ATM_MAP_NATIVE;
        case 73:
        case 'DIRECT_DEPOSIT_IMPROVED_SURFACING':
            return Feature.DIRECT_DEPOSIT_IMPROVED_SURFACING;
        case 75:
        case 'INVITES_WHEN_P2P':
            return Feature.INVITES_WHEN_P2P;
        case 76:
        case 'TRANSFERS_V2':
            return Feature.TRANSFERS_V2;
        case 77:
        case 'GESTURE_BUG_REPORTING':
            return Feature.GESTURE_BUG_REPORTING;
        case 78:
        case 'SILENT_BUG_REPORTING':
            return Feature.SILENT_BUG_REPORTING;
        case 80:
        case 'P2P_FOR_NON_STEP_USERS_REQUEST':
            return Feature.P2P_FOR_NON_STEP_USERS_REQUEST;
        case 81:
        case 'P2P_FOR_NON_STEP_USERS_SEND':
            return Feature.P2P_FOR_NON_STEP_USERS_SEND;
        case 82:
        case 'ADVANCED_REFERRAL_CODE_SHARING':
            return Feature.ADVANCED_REFERRAL_CODE_SHARING;
        case 83:
        case 'LIGHT_MODE_HEADERS':
            return Feature.LIGHT_MODE_HEADERS;
        case 84:
        case 'NATIVE_HELP_CENTER':
            return Feature.NATIVE_HELP_CENTER;
        case 85:
        case 'PAY_ME_PAGE':
            return Feature.PAY_ME_PAGE;
        case 86:
        case 'EARLY_DIRECT_DEPOSIT':
            return Feature.EARLY_DIRECT_DEPOSIT;
        case 87:
        case 'USER_RISK_EVALUATION':
            return Feature.USER_RISK_EVALUATION;
        case 88:
        case 'CASH_DEPOSIT_MAP':
            return Feature.CASH_DEPOSIT_MAP;
        case 89:
        case 'SAVINGS':
            return Feature.SAVINGS;
        case 91:
        case 'MULTIPLE_SPONSOR_INVITES':
            return Feature.MULTIPLE_SPONSOR_INVITES;
        case 92:
        case 'IN_APP_LIMITS':
            return Feature.IN_APP_LIMITS;
        case 93:
        case 'ALLOW_MULTIPLE_COSPONSOR_INVITES':
            return Feature.ALLOW_MULTIPLE_COSPONSOR_INVITES;
        case 94:
        case 'SPLIT_SIGN_UP_AND_LOG_IN_FLOWS':
            return Feature.SPLIT_SIGN_UP_AND_LOG_IN_FLOWS;
        case 95:
        case 'ACCOUNT_DELETION_PAGE':
            return Feature.ACCOUNT_DELETION_PAGE;
        case 96:
        case 'P2P_FOR_NON_STEP_PERSONALIZED_UI':
            return Feature.P2P_FOR_NON_STEP_PERSONALIZED_UI;
        case 97:
        case 'P2P_FOR_NON_STEP_WEB_PAYMENT':
            return Feature.P2P_FOR_NON_STEP_WEB_PAYMENT;
        case 98:
        case 'CASH_DEPOSIT_FEE':
            return Feature.CASH_DEPOSIT_FEE;
        case 100:
        case 'BACKGROUND_TASK_MANAGER':
            return Feature.BACKGROUND_TASK_MANAGER;
        case 101:
        case 'FOOTER_DIVIDERS':
            return Feature.FOOTER_DIVIDERS;
        case 102:
        case 'STRIPE_ELEMENTS':
            return Feature.STRIPE_ELEMENTS;
        case 104:
        case 'SPONSOR_MANAGED_ACCOUNTS':
            return Feature.SPONSOR_MANAGED_ACCOUNTS;
        case 105:
        case 'PERSONALIZE_GEN_LINK_WITH_APPSFLYER':
            return Feature.PERSONALIZE_GEN_LINK_WITH_APPSFLYER;
        case 106:
        case 'PERSONALIZE_PARAMS_WITH_APPSFLYER':
            return Feature.PERSONALIZE_PARAMS_WITH_APPSFLYER;
        case 107:
        case 'SCHOOL_SELECTION':
            return Feature.SCHOOL_SELECTION;
        case 108:
        case 'SKIP_SPONSOR_REQUEST':
            return Feature.SKIP_SPONSOR_REQUEST;
        case 109:
        case 'REFERRAL_PROMPT':
            return Feature.REFERRAL_PROMPT;
        case 110:
        case 'REFERRAL_RECOMMENDATIONS':
            return Feature.REFERRAL_RECOMMENDATIONS;
        case 111:
        case 'P2P_PERSONALIZED_UI':
            return Feature.P2P_PERSONALIZED_UI;
        case 112:
        case 'ATM_FEE_REIMBURSEMENT_QUOTA':
            return Feature.ATM_FEE_REIMBURSEMENT_QUOTA;
        case 114:
        case 'FUNDING_SHORTCUT_40':
            return Feature.FUNDING_SHORTCUT_40;
        case 117:
        case 'CARD_FUNDING_MIN_5':
            return Feature.CARD_FUNDING_MIN_5;
        case 118:
        case 'CARD_FUNDING_MIN_10':
            return Feature.CARD_FUNDING_MIN_10;
        case 119:
        case 'THIN_FILE_SUPPORT':
            return Feature.THIN_FILE_SUPPORT;
        case 120:
        case 'LIMIT_LEVEL_2_POST_KYC_CONTROL':
            return Feature.LIMIT_LEVEL_2_POST_KYC_CONTROL;
        case 121:
        case 'LIMIT_LEVEL_2_POST_KYC_TREATMENT':
            return Feature.LIMIT_LEVEL_2_POST_KYC_TREATMENT;
        case 122:
        case 'SKIP_PAYFONE_VERIFICATION':
            return Feature.SKIP_PAYFONE_VERIFICATION;
        case 123:
        case 'POST_SPONSORSHIP_RECURRING_FUNDING_CTA':
            return Feature.POST_SPONSORSHIP_RECURRING_FUNDING_CTA;
        case 124:
        case 'ROUND_UP_TO_SAVINGS':
            return Feature.ROUND_UP_TO_SAVINGS;
        case 125:
        case 'SIGNUP_REFERRAL_PROMPT':
            return Feature.SIGNUP_REFERRAL_PROMPT;
        case 126:
        case 'POSITIVE_REFERRAL_PROMPT':
            return Feature.POSITIVE_REFERRAL_PROMPT;
        case 127:
        case 'PRE_SPONSORSHIP_PROFILE_PICTURE':
            return Feature.PRE_SPONSORSHIP_PROFILE_PICTURE;
        case 128:
        case 'SAVINGS_ROUND_UP':
            return Feature.SAVINGS_ROUND_UP;
        case 129:
        case 'PENDING_REFERRAL_BONUS':
            return Feature.PENDING_REFERRAL_BONUS;
        case 130:
        case 'CREDIT_REPORTING_ADULT':
            return Feature.CREDIT_REPORTING_ADULT;
        case 132:
        case 'RECOMMENDED_REFERRAL_INVITES':
            return Feature.RECOMMENDED_REFERRAL_INVITES;
        case 133:
        case 'POSITIVE_REFERRAL_PROMPT_V2':
            return Feature.POSITIVE_REFERRAL_PROMPT_V2;
        case 134:
        case 'SKIP_GET_CARD':
            return Feature.SKIP_GET_CARD;
        case 135:
        case 'SPONSORSHIP_SMS_COPY':
            return Feature.SPONSORSHIP_SMS_COPY;
        case 136:
        case 'SKIP_PHONE_CONFIRMATION_MODAL':
            return Feature.SKIP_PHONE_CONFIRMATION_MODAL;
        case 137:
        case 'SPONSORSHIP_PRIMER_COPY':
            return Feature.SPONSORSHIP_PRIMER_COPY;
        case 141:
        case 'ROLLING_BILLING':
            return Feature.ROLLING_BILLING;
        case 142:
        case 'OVERDRAFT_PROTECTION':
            return Feature.OVERDRAFT_PROTECTION;
        case 143:
        case 'SPONSOR_MANAGED_ACCOUNTS_GRADUATION':
            return Feature.SPONSOR_MANAGED_ACCOUNTS_GRADUATION;
        case 144:
        case 'LIMIT_LEVEL_2_RISK_SCORE':
            return Feature.LIMIT_LEVEL_2_RISK_SCORE;
        case 145:
        case 'EMANCIPATION':
            return Feature.EMANCIPATION;
        case 147:
        case 'BUY_NOW_PAY_LATER':
            return Feature.BUY_NOW_PAY_LATER;
        case 148:
        case 'CRYPTO_REWARDS':
            return Feature.CRYPTO_REWARDS;
        case 149:
        case 'OFFERS_VIEW':
            return Feature.OFFERS_VIEW;
        case 151:
        case 'SERVER_SIDE_SPONSORSHIP_INVITE':
            return Feature.SERVER_SIDE_SPONSORSHIP_INVITE;
        case 152:
        case 'SUGGESTED_FRIEND_INVITES':
            return Feature.SUGGESTED_FRIEND_INVITES;
        case 154:
        case 'SKIP_SHIPPING_ADDRESS_FOR_CARD':
            return Feature.SKIP_SHIPPING_ADDRESS_FOR_CARD;
        case 155:
        case 'CRYPTO_REWARDS_FOR_TEENS':
            return Feature.CRYPTO_REWARDS_FOR_TEENS;
        case 156:
        case 'ECBSV':
            return Feature.ECBSV;
        case 157:
        case 'SERVER_SIDE_REFERRAL_INVITE':
            return Feature.SERVER_SIDE_REFERRAL_INVITE;
        case 158:
        case 'ADDITIONAL_CREDIT_REPORTING_REQUIREMENTS':
            return Feature.ADDITIONAL_CREDIT_REPORTING_REQUIREMENTS;
        case 159:
        case 'CRYPTO_TRADING':
            return Feature.CRYPTO_TRADING;
        case 160:
        case 'REPLACE_DECISION_WITH_DOB':
            return Feature.REPLACE_DECISION_WITH_DOB;
        case 161:
        case 'HIDE_LINK_ACCOUNT_ITEM_SUBTITLE':
            return Feature.HIDE_LINK_ACCOUNT_ITEM_SUBTITLE;
        case 162:
        case 'REFERRAL_RECOMMENDATIONS_SERVER_RANK':
            return Feature.REFERRAL_RECOMMENDATIONS_SERVER_RANK;
        case 163:
        case 'CARD_REPLACEMENT_FEE':
            return Feature.CARD_REPLACEMENT_FEE;
        case 166:
        case 'CHECK_DEPOSIT':
            return Feature.CHECK_DEPOSIT;
        case 167:
        case 'CRYPTO_PARENTAL_CONTROLS':
            return Feature.CRYPTO_PARENTAL_CONTROLS;
        case 170:
        case 'HELPER_CARD_CAROUSEL':
            return Feature.HELPER_CARD_CAROUSEL;
        case 171:
        case 'APP_START_PERFORMANCE_LOGGING':
            return Feature.APP_START_PERFORMANCE_LOGGING;
        case 172:
        case 'CREDIT_MONITORING':
            return Feature.CREDIT_MONITORING;
        case 173:
        case 'STOCKS_TRADING':
            return Feature.STOCKS_TRADING;
        case 174:
        case 'OFFER_CRYPTOGIVEAWAY100OCT12':
            return Feature.OFFER_CRYPTOGIVEAWAY100OCT12;
        case 175:
        case 'SUBSCRIPTION_MANAGEMENT':
            return Feature.SUBSCRIPTION_MANAGEMENT;
        case 176:
        case 'INSTANT_CASHOUT':
            return Feature.INSTANT_CASHOUT;
        case 177:
        case 'BNPL_PARTIAL_PAYMENT':
            return Feature.BNPL_PARTIAL_PAYMENT;
        case 178:
        case 'MILESTONE_REPORTING':
            return Feature.MILESTONE_REPORTING;
        case 179:
        case 'FRACTIONAL_LIMITS':
            return Feature.FRACTIONAL_LIMITS;
        case 180:
        case 'ACCOUNT_SCREEN_WITH_SUGGESTED_FRIENDS':
            return Feature.ACCOUNT_SCREEN_WITH_SUGGESTED_FRIENDS;
        case 181:
        case 'SUGGESTED_FRIENDS_WITH_REFRESH':
            return Feature.SUGGESTED_FRIENDS_WITH_REFRESH;
        case 182:
        case 'SUGGESTED_FRIENDS_WITH_DISMISS':
            return Feature.SUGGESTED_FRIENDS_WITH_DISMISS;
        case 183:
        case 'STREAMLINED_TRANSFERS':
            return Feature.STREAMLINED_TRANSFERS;
        case 184:
        case 'CANCEL_MERCHANT_INFO':
            return Feature.CANCEL_MERCHANT_INFO;
        case 185:
        case 'UNSECURED_CARD':
            return Feature.UNSECURED_CARD;
        case 186:
        case 'USE_STRIPE_PAYMENT_INTENT':
            return Feature.USE_STRIPE_PAYMENT_INTENT;
        case 187:
        case 'REQUEST_3DS':
            return Feature.REQUEST_3DS;
        case 188:
        case 'MERCHANT_BLOCKING':
            return Feature.MERCHANT_BLOCKING;
        case 189:
        case 'CREDIT_MONITORING_GRAPH':
            return Feature.CREDIT_MONITORING_GRAPH;
        case 190:
        case 'TIPPING':
            return Feature.TIPPING;
        case 191:
        case 'PAY_OVER_TIME':
            return Feature.PAY_OVER_TIME;
        case 192:
        case 'STEP_EMPLOYEE':
            return Feature.STEP_EMPLOYEE;
        case 193:
        case 'BLOCK_FOREIGN_CHARGES':
            return Feature.BLOCK_FOREIGN_CHARGES;
        case 194:
        case 'ONBOARDING_FLOW_REFACTOR':
            return Feature.ONBOARDING_FLOW_REFACTOR;
        case 195:
        case 'WEB_SPONSORSHIP_PERSONALIZATION':
            return Feature.WEB_SPONSORSHIP_PERSONALIZATION;
        case 196:
        case 'WEB_SPONSORSHIP_FUNDING':
            return Feature.WEB_SPONSORSHIP_FUNDING;
        case 197:
        case 'CREDIT_MONITORING_ADVERSE_ACTION_CODES':
            return Feature.CREDIT_MONITORING_ADVERSE_ACTION_CODES;
        case 198:
        case 'STEP_BACK_ANNUAL':
            return Feature.STEP_BACK_ANNUAL;
        case 200:
        case 'REFEREE_REMINDER':
            return Feature.REFEREE_REMINDER;
        case 201:
        case 'WEB_SPONSORSHIP_VALUE_PROPS':
            return Feature.WEB_SPONSORSHIP_VALUE_PROPS;
        case 202:
        case 'WRONG_LOGIN_FLOW_SIGNUP':
            return Feature.WRONG_LOGIN_FLOW_SIGNUP;
        case 205:
        case 'AA_FAMILY':
            return Feature.AA_FAMILY;
        case 206:
        case 'AA_FAMILY_VARIANTS':
            return Feature.AA_FAMILY_VARIANTS;
        case 207:
        case 'AA_USER':
            return Feature.AA_USER;
        case 208:
        case 'AA_USER_VARIANTS':
            return Feature.AA_USER_VARIANTS;
        case 209:
        case 'OFFER_BUNDLES':
            return Feature.OFFER_BUNDLES;
        case 210:
        case 'STOCKS_TRADING_M2':
            return Feature.STOCKS_TRADING_M2;
        case 211:
        case 'HIDE_REFERRALS':
            return Feature.HIDE_REFERRALS;
        case 214:
        case 'WEB_SPONSORSHIP_FUNDING_SKIP':
            return Feature.WEB_SPONSORSHIP_FUNDING_SKIP;
        case 215:
        case 'STOCKS_SEARCH_WITHOUT_ENROLLMENT':
            return Feature.STOCKS_SEARCH_WITHOUT_ENROLLMENT;
        case 216:
        case 'POINTS':
            return Feature.POINTS;
        case 217:
        case 'CARD_FUNDING_ACTION_ORDER':
            return Feature.CARD_FUNDING_ACTION_ORDER;
        case 218:
        case 'SAVINGS_APY':
            return Feature.SAVINGS_APY;
        case 219:
        case 'TIERS':
            return Feature.TIERS;
        case 220:
        case 'SHOW_VIRTUAL_CARD_INTRO_VIDEO':
            return Feature.SHOW_VIRTUAL_CARD_INTRO_VIDEO;
        case 222:
        case 'ONBOARDING_QUIZ':
            return Feature.ONBOARDING_QUIZ;
        case 223:
        case 'INVESTING_ACTIONS_IN_HELPER_CARDS':
            return Feature.INVESTING_ACTIONS_IN_HELPER_CARDS;
        case 224:
        case 'CUSTOM_CHECK_SCANNING':
            return Feature.CUSTOM_CHECK_SCANNING;
        case 225:
        case 'DIRECT_DEPOSIT_SWITCH':
            return Feature.DIRECT_DEPOSIT_SWITCH;
        case 226:
        case 'ACCOUNT_PROGRESS':
            return Feature.ACCOUNT_PROGRESS;
        case 227:
        case 'LESS_STRICT_PAYME':
            return Feature.LESS_STRICT_PAYME;
        case 228:
        case 'SUGGESTED_FRIENDS_NO_PREVIEW_DISMISS':
            return Feature.SUGGESTED_FRIENDS_NO_PREVIEW_DISMISS;
        case 230:
        case 'QUIZ_SHARE_MESSAGE':
            return Feature.QUIZ_SHARE_MESSAGE;
        case 231:
        case 'WEB_HOME_TEEN_BANKING':
            return Feature.WEB_HOME_TEEN_BANKING;
        case 232:
        case 'WEB_SPONSORSHIP_PREVIEW_IMAGE':
            return Feature.WEB_SPONSORSHIP_PREVIEW_IMAGE;
        case 233:
        case 'CRYPTO_TAX_DOCUMENTS':
            return Feature.CRYPTO_TAX_DOCUMENTS;
        case 234:
        case 'STEP_BLACK_WAITLIST':
            return Feature.STEP_BLACK_WAITLIST;
        case 235:
        case 'STEP_BLACK_TIER':
            return Feature.STEP_BLACK_TIER;
        case 236:
        case 'CARD_MANAGEMENT_V2':
            return Feature.CARD_MANAGEMENT_V2;
        case 237:
        case 'POINTS_OFFERS':
            return Feature.POINTS_OFFERS;
        case 238:
        case 'NEW_APP_THEMES':
            return Feature.NEW_APP_THEMES;
        case 239:
        case 'STOCKS_GRADUATION':
            return Feature.STOCKS_GRADUATION;
        case 240:
        case 'SERVER_SIDE_ACCOUNT_PROGRESS':
            return Feature.SERVER_SIDE_ACCOUNT_PROGRESS;
        case 241:
        case 'CASH_BUNDLES':
            return Feature.CASH_BUNDLES;
        case 242:
        case 'STOCKS_DISCOVER':
            return Feature.STOCKS_DISCOVER;
        case 243:
        case 'PUBLIC_PAY_ME_LINK':
            return Feature.PUBLIC_PAY_ME_LINK;
        case 244:
        case 'POT_FIXED_APR':
            return Feature.POT_FIXED_APR;
        case 245:
        case 'AUTOCANCEL_STUCK_INSTANT_PAYOUTS':
            return Feature.AUTOCANCEL_STUCK_INSTANT_PAYOUTS;
        case 246:
        case 'HIDE_SUGGESTED_REFERRALS':
            return Feature.HIDE_SUGGESTED_REFERRALS;
        case 247:
        case 'CARD_FUNDING_RECEIPT_EMAIL':
            return Feature.CARD_FUNDING_RECEIPT_EMAIL;
        case 248:
        case 'REQUIRED_MIN_FUNDING_AMOUNT':
            return Feature.REQUIRED_MIN_FUNDING_AMOUNT;
        case 249:
        case 'POT_ESTIMATE_DATES':
            return Feature.POT_ESTIMATE_DATES;
        case 250:
        case 'APP_TAB_NAVIGATION':
            return Feature.APP_TAB_NAVIGATION;
        case 251:
        case 'PLATFORM_PAY_FUNDING':
            return Feature.PLATFORM_PAY_FUNDING;
        case 252:
        case 'SUGGESTED_TRANSFER_AMOUNT':
            return Feature.SUGGESTED_TRANSFER_AMOUNT;
        case 253:
        case 'PHONE_NUMBER_TAKEOVER':
            return Feature.PHONE_NUMBER_TAKEOVER;
        case 254:
        case 'SOLO_VS_PARENT_DECISION_AGE':
            return Feature.SOLO_VS_PARENT_DECISION_AGE;
        case 255:
        case 'NO_DESIGN_CARD_ONBOARDING':
            return Feature.NO_DESIGN_CARD_ONBOARDING;
        case 256:
        case 'LOGIN_SIGNUP_IMPROVEMENTS':
            return Feature.LOGIN_SIGNUP_IMPROVEMENTS;
        case 257:
        case 'PRIORITY_SHIPPING':
            return Feature.PRIORITY_SHIPPING;
        case 259:
        case 'STEP_BLACK_LANDING_PAGE_OPTIMIZED_LAYOUT':
            return Feature.STEP_BLACK_LANDING_PAGE_OPTIMIZED_LAYOUT;
        case 261:
        case 'CREDIT_PULL_CONSENT':
            return Feature.CREDIT_PULL_CONSENT;
        case 262:
        case 'POT_BORROW_CASH':
            return Feature.POT_BORROW_CASH;
        case 263:
        case 'WEB_SPONSORSHIP_ALLOWANCE':
            return Feature.WEB_SPONSORSHIP_ALLOWANCE;
        case 264:
        case 'WEB_SPONSORSHIP_FUNDING_WALLET_PAYMENTS':
            return Feature.WEB_SPONSORSHIP_FUNDING_WALLET_PAYMENTS;
        case 265:
        case 'WEB_SPONSORSHIP_FUNDING_RECOMMENDED_AMOUNT':
            return Feature.WEB_SPONSORSHIP_FUNDING_RECOMMENDED_AMOUNT;
        case 266:
        case 'INVESTING_PORTFOLIO_PERFORMANCE':
            return Feature.INVESTING_PORTFOLIO_PERFORMANCE;
        case 268:
        case 'TRANSFER_DIRECTLY_FROM_BANK':
            return Feature.TRANSFER_DIRECTLY_FROM_BANK;
        case 269:
        case 'WEB_UNAUTHED_WALLET_PAYMENTS':
            return Feature.WEB_UNAUTHED_WALLET_PAYMENTS;
        case 270:
        case 'CLOSED_CRYPTO_ACCOUNTS':
            return Feature.CLOSED_CRYPTO_ACCOUNTS;
        case 271:
        case 'CLOSED_STOCK_ACCOUNTS':
            return Feature.CLOSED_STOCK_ACCOUNTS;
        case 272:
        case 'CRYPTO_CHARTS':
            return Feature.CRYPTO_CHARTS;
        case 273:
        case 'ENHANCED_PARENT_SAVINGS':
            return Feature.ENHANCED_PARENT_SAVINGS;
        case 274:
        case 'WEB_SPONSORSHIP_FIXED_APPROVE_BUTTON':
            return Feature.WEB_SPONSORSHIP_FIXED_APPROVE_BUTTON;
        case 275:
        case 'CHECK_SCANNING_V2':
            return Feature.CHECK_SCANNING_V2;
        case 278:
        case 'VISA_SIGNATURE':
            return Feature.VISA_SIGNATURE;
        case 279:
        case 'INVESTING_ROUND_UPS':
            return Feature.INVESTING_ROUND_UPS;
        case 280:
        case 'IOS_ONLY_OFFER':
            return Feature.IOS_ONLY_OFFER;
        case 281:
        case 'DAILY_TRIVIA_LEADERBOARD':
            return Feature.DAILY_TRIVIA_LEADERBOARD;
        case 282:
        case 'CRYPTO_ROUND_UPS':
            return Feature.CRYPTO_ROUND_UPS;
        case 283:
        case 'BORROW_APPLICATION_FLOW':
            return Feature.BORROW_APPLICATION_FLOW;
        case 284:
        case 'USER_TIER_REFERRAL_CAMPAIGN':
            return Feature.USER_TIER_REFERRAL_CAMPAIGN;
        case 285:
        case 'AUTO_PERFORMANCE_LOGGING':
            return Feature.AUTO_PERFORMANCE_LOGGING;
        case 286:
        case 'LEGAL_ADDRESS_PO_BOX_VALIDATION':
            return Feature.LEGAL_ADDRESS_PO_BOX_VALIDATION;
        case 287:
        case 'FAIL_KYC_ON_IDV_REQUIRED':
            return Feature.FAIL_KYC_ON_IDV_REQUIRED;
        case 288:
        case 'UNLIMITED_REFERRALS':
            return Feature.UNLIMITED_REFERRALS;
        case 289:
        case 'POINTS_AS_DOLLARS_REFERRALS':
            return Feature.POINTS_AS_DOLLARS_REFERRALS;
        case 290:
        case 'GIFT_CARDS':
            return Feature.GIFT_CARDS;
        case 291:
        case 'DATASTORE_CACHE_FAMILY_MEMBERS':
            return Feature.DATASTORE_CACHE_FAMILY_MEMBERS;
        case 292:
        case 'ASYNC_PHYSICAL_CARD_ISSUING':
            return Feature.ASYNC_PHYSICAL_CARD_ISSUING;
        case 293:
        case 'SIGNUP_INTEREST_SURVEY':
            return Feature.SIGNUP_INTEREST_SURVEY;
        case 294:
        case 'DAILY_TRIVIA_REWARDS':
            return Feature.DAILY_TRIVIA_REWARDS;
        case 295:
        case 'SIGNUP_NEW_INTRO_SCREENS':
            return Feature.SIGNUP_NEW_INTRO_SCREENS;
        case 296:
        case 'SOLO_ADULT_PRE_KYC_PREMIER':
            return Feature.SOLO_ADULT_PRE_KYC_PREMIER;
        case 297:
        case 'HIGH_DPI_CARD_SIGNATURE':
            return Feature.HIGH_DPI_CARD_SIGNATURE;
        case 298:
        case 'BNPL_CHECK_MLA':
            return Feature.BNPL_CHECK_MLA;
        case 299:
        case 'NEW_NAVIGATION_HELPER_CARD':
            return Feature.NEW_NAVIGATION_HELPER_CARD;
        case 301:
        case 'ACCOUNT_PROGRESS_WITH_INCENTIVES':
            return Feature.ACCOUNT_PROGRESS_WITH_INCENTIVES;
        case 302:
        case 'RECURRING_PAYMENTS':
            return Feature.RECURRING_PAYMENTS;
        case 303:
        case 'PLATFORM_PAY_REQUIRE_ADDRESS':
            return Feature.PLATFORM_PAY_REQUIRE_ADDRESS;
        case 305:
        case 'DIRECT_DEPOSIT_IN_ONBOARDING':
            return Feature.DIRECT_DEPOSIT_IN_ONBOARDING;
        case 306:
        case 'NO_REFERRALS_ONBOARDING':
            return Feature.NO_REFERRALS_ONBOARDING;
        case 307:
        case 'AUTO_RELOAD':
            return Feature.AUTO_RELOAD;
        case 308:
        case 'PLOTLINE':
            return Feature.PLOTLINE;
        case 310:
        case 'CRYPTO_ENROLL_AND_BUY':
            return Feature.CRYPTO_ENROLL_AND_BUY;
        case 312:
        case 'CREDIT_REPORTING_BY_DEFAULT':
            return Feature.CREDIT_REPORTING_BY_DEFAULT;
        case 313:
        case 'APP_TAB_NAVIGATION_M2':
            return Feature.APP_TAB_NAVIGATION_M2;
        case 314:
        case 'STEP_BLACK_V2':
            return Feature.STEP_BLACK_V2;
        case 317:
        case 'PREMIUM_V2_FEES':
            return Feature.PREMIUM_V2_FEES;
        case 318:
        case 'SOLO_ADULT_CONDITIONAL_PHYSICAL_CARD':
            return Feature.SOLO_ADULT_CONDITIONAL_PHYSICAL_CARD;
        case 319:
        case 'COMBINED_BORROW_APPLICATION_FLOW':
            return Feature.COMBINED_BORROW_APPLICATION_FLOW;
        case 320:
        case 'NEW_LIMIT_LEVELS':
            return Feature.NEW_LIMIT_LEVELS;
        case 321:
        case 'LLM_CHAT':
            return Feature.LLM_CHAT;
        case 322:
        case 'BILL_PAY':
            return Feature.BILL_PAY;
        case 323:
        case 'ACTIVITY_FEED_V2':
            return Feature.ACTIVITY_FEED_V2;
        case 324:
        case 'UNLOCK_APP':
            return Feature.UNLOCK_APP;
        case 326:
        case 'MILESTONE_CTA_OVERRIDE':
            return Feature.MILESTONE_CTA_OVERRIDE;
        case 327:
        case 'EMAIL_MAGIC_LINK':
            return Feature.EMAIL_MAGIC_LINK;
        case 328:
        case 'BILL_PAY_M2':
            return Feature.BILL_PAY_M2;
        case 329:
        case 'NEW_NAV_M2_REFERRAL_ENTRY_POINTS':
            return Feature.NEW_NAV_M2_REFERRAL_ENTRY_POINTS;
        case 330:
        case 'SUSPICIOUS_TXN_SMS_CHALLENGE':
            return Feature.SUSPICIOUS_TXN_SMS_CHALLENGE;
        case 331:
        case 'ONBOARDING_SERVICE_ONBOARD_API':
            return Feature.ONBOARDING_SERVICE_ONBOARD_API;
        case 332:
        case 'UNLOCK_APP_DEFAULT_ON':
            return Feature.UNLOCK_APP_DEFAULT_ON;
        case 333:
        case 'ML_FOR_ACH_REVIEW':
            return Feature.ML_FOR_ACH_REVIEW;
        case 334:
        case 'FORCE_SMS_CHALLENGE':
            return Feature.FORCE_SMS_CHALLENGE;
        case 335:
        case 'NEW_DEVICE_LOGIN_NOTIFICATION':
            return Feature.NEW_DEVICE_LOGIN_NOTIFICATION;
        case 336:
        case 'ONBOARDING_JOURNEY_FLOW':
            return Feature.ONBOARDING_JOURNEY_FLOW;
        case 337:
        case 'ONBOARDING_FUNDING':
            return Feature.ONBOARDING_FUNDING;
        case 338:
        case 'SIGNUP_INTEREST_BASED_KYC_PRIMER':
            return Feature.SIGNUP_INTEREST_BASED_KYC_PRIMER;
        case 339:
        case 'PASSKEY_LOGIN':
            return Feature.PASSKEY_LOGIN;
        case 340:
        case 'ACCOUNT_PROGRESS_LANDING':
            return Feature.ACCOUNT_PROGRESS_LANDING;
        case 341:
        case 'CRITICAL_ONLY_MAIN_SCREEN':
            return Feature.CRITICAL_ONLY_MAIN_SCREEN;
        case 342:
        case 'ACCOUNT_PROGRESS_SERIES':
            return Feature.ACCOUNT_PROGRESS_SERIES;
        case 343:
        case 'ACCOUNT_PROGRESS_INTEREST_BASED':
            return Feature.ACCOUNT_PROGRESS_INTEREST_BASED;
        case 344:
        case 'DIRECT_DEPOSIT_FUNDING_RECOMMENDATION':
            return Feature.DIRECT_DEPOSIT_FUNDING_RECOMMENDATION;
        case 345:
        case 'FLEX_DUE_DATE':
            return Feature.FLEX_DUE_DATE;
        case 346:
        case 'DISPUTES_INTAKE_REVAMP':
            return Feature.DISPUTES_INTAKE_REVAMP;
        case 347:
        case 'STEP_BLACK_AS_DEFAULT_IN_AP':
            return Feature.STEP_BLACK_AS_DEFAULT_IN_AP;
        case 348:
        case 'ACCOUNT_PROGRESS_STATUS_ICON':
            return Feature.ACCOUNT_PROGRESS_STATUS_ICON;
        case 349:
        case 'PASSKEY_UPSELL_ON_LOGIN':
            return Feature.PASSKEY_UPSELL_ON_LOGIN;
        case 350:
        case 'LIFECYCLE_STORE_REFRESH_ON_LEDGER_UPDATE':
            return Feature.LIFECYCLE_STORE_REFRESH_ON_LEDGER_UPDATE;
        case 351:
        case 'CREDIT_MONITORING_V2':
            return Feature.CREDIT_MONITORING_V2;
        case 352:
        case 'CTA_STATUS_UPDATED_PN':
            return Feature.CTA_STATUS_UPDATED_PN;
        case 353:
        case 'BILL_PAY_M1_1':
            return Feature.BILL_PAY_M1_1;
        case 354:
        case 'SERVER_SIDE_LEARN_MORE':
            return Feature.SERVER_SIDE_LEARN_MORE;
        case 355:
        case 'CREDIT_HEALTH_BUILD_CREDIT_PROGRESS':
            return Feature.CREDIT_HEALTH_BUILD_CREDIT_PROGRESS;
        case 356:
        case 'BORROW_APPLICATION_DD':
            return Feature.BORROW_APPLICATION_DD;
        case 357:
        case 'DIRECT_DEPOSIT_UPDATES_M1':
            return Feature.DIRECT_DEPOSIT_UPDATES_M1;
        case 358:
        case 'MY_DIRECT_DEPOSIT':
            return Feature.MY_DIRECT_DEPOSIT;
        case 359:
        case 'HIDE_BASIC_INTRO_IN_SB_FLOW':
            return Feature.HIDE_BASIC_INTRO_IN_SB_FLOW;
        case 360:
        case 'ONBOARDING_STEP_BLACK':
            return Feature.ONBOARDING_STEP_BLACK;
        case 362:
        case 'EMPLOYMENT_SURVEY':
            return Feature.EMPLOYMENT_SURVEY;
        case 363:
        case 'SARDINE_FRAUD_CHECK':
            return Feature.SARDINE_FRAUD_CHECK;
        case 364:
        case 'CHECK_DEPOSIT_V2':
            return Feature.CHECK_DEPOSIT_V2;
        case 365:
        case 'MARKETPLACE_HELPER_CARD':
            return Feature.MARKETPLACE_HELPER_CARD;
        case 366:
        case 'TOP_MERCHANTS_ON_CARDS_SCREEN':
            return Feature.TOP_MERCHANTS_ON_CARDS_SCREEN;
        case 367:
        case 'MOVE_MONEY_V2':
            return Feature.MOVE_MONEY_V2;
        case 368:
        case 'BORROW_APPLICATION_DD_BYPASS':
            return Feature.BORROW_APPLICATION_DD_BYPASS;
        case 369:
        case 'SHARE_SCREENSHOT_BUTTON':
            return Feature.SHARE_SCREENSHOT_BUTTON;
        case 370:
        case 'DIRECT_DEPOSIT_IN_PROGRESS_LIST':
            return Feature.DIRECT_DEPOSIT_IN_PROGRESS_LIST;
        case 371:
        case 'BILL_PAY_IN_PROGRESS_LIST':
            return Feature.BILL_PAY_IN_PROGRESS_LIST;
        case 372:
        case 'BIRTHDAY_18_OFFER':
            return Feature.BIRTHDAY_18_OFFER;
        case 373:
        case 'POT_PAY_IN_ONE':
            return Feature.POT_PAY_IN_ONE;
        case 374:
        case 'POT_CONFIGURABLE_APR':
            return Feature.POT_CONFIGURABLE_APR;
        case 375:
        case 'POT_LATE_FEE':
            return Feature.POT_LATE_FEE;
        case 376:
        case 'ACHIEVEMENTS':
            return Feature.ACHIEVEMENTS;
        case 377:
        case 'CREDIT_LEADERBOARD':
            return Feature.CREDIT_LEADERBOARD;
        case 378:
        case 'SOLO_ADULT_DIRECT_DEPOSIT_TO_ORDER_CARD':
            return Feature.SOLO_ADULT_DIRECT_DEPOSIT_TO_ORDER_CARD;
        case 379:
        case 'DESIGN_SYSTEM_TEXT_STYLES':
            return Feature.DESIGN_SYSTEM_TEXT_STYLES;
        case 380:
        case 'DESIGN_SYSTEM_COLORS':
            return Feature.DESIGN_SYSTEM_COLORS;
        case 381:
        case 'DESIGN_SYSTEM_SPACING':
            return Feature.DESIGN_SYSTEM_SPACING;
        case 382:
        case 'BRAZE_CREDIT_SCORE_CHANGED':
            return Feature.BRAZE_CREDIT_SCORE_CHANGED;
        case 383:
        case 'BORROW_REGION_BYPASS':
            return Feature.BORROW_REGION_BYPASS;
        case 384:
        case 'BORROW_APPLICATION_QUESTIONS':
            return Feature.BORROW_APPLICATION_QUESTIONS;
        case 385:
        case 'DD_TRACKER_ON_STEP_BLACK_SCREEN':
            return Feature.DD_TRACKER_ON_STEP_BLACK_SCREEN;
        case 386:
        case 'FRIENDS_TRIVIA_LEADERBOARD':
            return Feature.FRIENDS_TRIVIA_LEADERBOARD;
        case 387:
        case 'CLOSE_ACCOUNT_FLOW':
            return Feature.CLOSE_ACCOUNT_FLOW;
        case 388:
        case 'SPIN_THE_WHEEL':
            return Feature.SPIN_THE_WHEEL;
        case 389:
        case 'BORROW_APPLICATION_DD_CTAS':
            return Feature.BORROW_APPLICATION_DD_CTAS;
        case 390:
        case 'GIGS_MOBILE':
            return Feature.GIGS_MOBILE;
        case 415:
        case 'MOBILE_PLANS':
            return Feature.MOBILE_PLANS;
        case 391:
        case 'DIRECT_DEPOSIT_UPDATES_M1_V2':
            return Feature.DIRECT_DEPOSIT_UPDATES_M1_V2;
        case 392:
        case 'ACH_AUTO_DECLINE':
            return Feature.ACH_AUTO_DECLINE;
        case 393:
        case 'BRIDGE_MONEY':
            return Feature.BRIDGE_MONEY;
        case 394:
        case 'RANDOMIZED_INTEREST_SURVEY':
            return Feature.RANDOMIZED_INTEREST_SURVEY;
        case 395:
        case 'INTEREST_BASED_AP_M3':
            return Feature.INTEREST_BASED_AP_M3;
        case 396:
        case 'TAX_FILING':
            return Feature.TAX_FILING;
        case 397:
        case 'APP_START_NATIVE_LOGGING':
            return Feature.APP_START_NATIVE_LOGGING;
        case 398:
        case 'VIRTUAL_DEBIT_CARDS_M1':
            return Feature.VIRTUAL_DEBIT_CARDS_M1;
        case 399:
        case 'EXTERNAL_ACCOUNT_NICKNAME':
            return Feature.EXTERNAL_ACCOUNT_NICKNAME;
        case 400:
        case 'SCAN_EXTERNAL_ACCOUNT':
            return Feature.SCAN_EXTERNAL_ACCOUNT;
        case 401:
        case 'ONBOARDING_INTENT_TRIVIA_LEADERBOARD':
            return Feature.ONBOARDING_INTENT_TRIVIA_LEADERBOARD;
        case 402:
        case 'ONBOARDING_INTENT_CREDIT_LEADERBOARD':
            return Feature.ONBOARDING_INTENT_CREDIT_LEADERBOARD;
        case 403:
        case 'BUDGETING':
            return Feature.BUDGETING;
        case 404:
        case 'SOLO_ADULT_UNCONDITIONAL_PHYSICAL_CARD_ORDER':
            return Feature.SOLO_ADULT_UNCONDITIONAL_PHYSICAL_CARD_ORDER;
        case 405:
        case 'POT_PAY_IN_ONE_V2':
            return Feature.POT_PAY_IN_ONE_V2;
        case 406:
        case 'EARN_WITH_STEP':
            return Feature.EARN_WITH_STEP;
        case 407:
        case 'POT_PAY_IN_ONE_CREDIT_REPORTING':
            return Feature.POT_PAY_IN_ONE_CREDIT_REPORTING;
        case 408:
        case 'ADD_CARD_POPUP':
            return Feature.ADD_CARD_POPUP;
        case 410:
        case 'AP_POPUP_CONTINUOUS':
            return Feature.AP_POPUP_CONTINUOUS;
        case 411:
        case 'STEP_BLACK_UPSELL_MODAL':
            return Feature.STEP_BLACK_UPSELL_MODAL;
        case 412:
        case 'DISABLE_KYC_PREFILL':
            return Feature.DISABLE_KYC_PREFILL;
        case 413:
        case 'DISPUTE_VROL_FLOW':
            return Feature.DISPUTE_VROL_FLOW;
        case 414:
        case 'STEP_BLACK_AUTO_ENROLL':
            return Feature.STEP_BLACK_AUTO_ENROLL;
        case 416:
        case 'LIMIT_LEVEL_SET':
            return Feature.LIMIT_LEVEL_SET;
        case 417:
        case 'BRAZE_SB_FAILED_COMMS':
            return Feature.BRAZE_SB_FAILED_COMMS;
        case 10001:
        case '_TEST_USER':
            return Feature._TEST_USER;
        case 10002:
        case '_TEST_FAMILY':
            return Feature._TEST_FAMILY;
        case 10003:
        case '_TEST_FAMILY_INVITE':
            return Feature._TEST_FAMILY_INVITE;
        case 10004:
        case '_TEST_PERCENTAGE':
            return Feature._TEST_PERCENTAGE;
        case 10005:
        case '_TEST_REQUIRED_APP_VERSION':
            return Feature._TEST_REQUIRED_APP_VERSION;
        case 10006:
        case '_TEST_REFERRAL':
            return Feature._TEST_REFERRAL;
        case 10007:
        case '_TEST_VARIANT':
            return Feature._TEST_VARIANT;
        case 10008:
        case '_TEST_ANOTHER_VARIANT':
            return Feature._TEST_ANOTHER_VARIANT;
        case 10010:
        case '_TEST_USER_CREATED_AFTER_DATE':
            return Feature._TEST_USER_CREATED_AFTER_DATE;
        case 10011:
        case '_TEST_ROLLED_OUT_FEATURE':
            return Feature._TEST_ROLLED_OUT_FEATURE;
        case 10012:
        case '_TEST_VARIANT_WITH_REQUIRED_VERSION':
            return Feature._TEST_VARIANT_WITH_REQUIRED_VERSION;
        case 10013:
        case '_TEST_UNAUTHENTICATED_FEATURE':
            return Feature._TEST_UNAUTHENTICATED_FEATURE;
        case 10014:
        case '_TEST_ALWAYS_APPLICABLE_FEATURE':
            return Feature._TEST_ALWAYS_APPLICABLE_FEATURE;
        case 1015:
        case '_TEST_UNAUTHENTICATED_WITH_PERCENTAGE':
            return Feature._TEST_UNAUTHENTICATED_WITH_PERCENTAGE;
        case 10016:
        case '_TEST_UNAUTHENTICATED_WITH_VARIANT':
            return Feature._TEST_UNAUTHENTICATED_WITH_VARIANT;
        case 10017:
        case '_TEST_UNAUTHENTICATED_WITH_REQUIRED_APP_VERSION':
            return Feature._TEST_UNAUTHENTICATED_WITH_REQUIRED_APP_VERSION;
        case 10018:
        case '_TEST_SERVER_FEATURE':
            return Feature._TEST_SERVER_FEATURE;
        case 10019:
        case '_TEST_ROLLED_OUT_SERVER_FEATURE':
            return Feature._TEST_ROLLED_OUT_SERVER_FEATURE;
        case 10020:
        case '_TEST_SERVER_WITH_PERCENTAGE':
            return Feature._TEST_SERVER_WITH_PERCENTAGE;
        case 10021:
        case '_TEST_SERVER_WITH_VARIANT':
            return Feature._TEST_SERVER_WITH_VARIANT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Feature.UNRECOGNIZED;
    }
}
exports.featureFromJSON = featureFromJSON;
function featureToJSON(object) {
    switch (object) {
        case Feature.INVALID_FEATURE:
            return 'INVALID_FEATURE';
        case Feature.GET_A_CARD:
            return 'GET_A_CARD';
        case Feature.REPORT_MERCHANT_LOCATION:
            return 'REPORT_MERCHANT_LOCATION';
        case Feature.ACCOUNT_STATEMENTS:
            return 'ACCOUNT_STATEMENTS';
        case Feature.COACHING_MODALS:
            return 'COACHING_MODALS';
        case Feature.PERSONALIZED_COLOR:
            return 'PERSONALIZED_COLOR';
        case Feature.DARK_MODE:
            return 'DARK_MODE';
        case Feature.ACH_ACCOUNT:
            return 'ACH_ACCOUNT';
        case Feature.CARD_DESIGN:
            return 'CARD_DESIGN';
        case Feature.TEEN_LINK_DEBIT_CARD:
            return 'TEEN_LINK_DEBIT_CARD';
        case Feature.SPONSORSHIP_REQUEST_INCENTIVE:
            return 'SPONSORSHIP_REQUEST_INCENTIVE';
        case Feature.REFERRALS:
            return 'REFERRALS';
        case Feature.PERSONA_DOCUMENT_VERIFICATION:
            return 'PERSONA_DOCUMENT_VERIFICATION';
        case Feature.RECURRING_TRANSFERS:
            return 'RECURRING_TRANSFERS';
        case Feature.LINK_ACH_ACCOUNT:
            return 'LINK_ACH_ACCOUNT';
        case Feature.DEVELOPER_UX:
            return 'DEVELOPER_UX';
        case Feature.STEP_SQUAD:
            return 'STEP_SQUAD';
        case Feature.STEP_SQUAD_MEMBER:
            return 'STEP_SQUAD_MEMBER';
        case Feature.APP_RATING:
            return 'APP_RATING';
        case Feature.CUSTOM_PROFILE_PICTURE:
            return 'CUSTOM_PROFILE_PICTURE';
        case Feature.SHOW_DECLINES:
            return 'SHOW_DECLINES';
        case Feature.ATM:
            return 'ATM';
        case Feature.SHOW_RECURRING_PAYMENTS_MORE_OFTEN:
            return 'SHOW_RECURRING_PAYMENTS_MORE_OFTEN';
        case Feature.SSN_LAST_4_DIGITS:
            return 'SSN_LAST_4_DIGITS';
        case Feature.DELAYED_REFERRAL_REDEMPTION:
            return 'DELAYED_REFERRAL_REDEMPTION';
        case Feature.REVERSE_CARD_COLORS:
            return 'REVERSE_CARD_COLORS';
        case Feature.VALIDATE_SHIPPING_ADDRESS:
            return 'VALIDATE_SHIPPING_ADDRESS';
        case Feature.EMAIL_BASED_RECOVERY:
            return 'EMAIL_BASED_RECOVERY';
        case Feature.VIRTUAL_CARD:
            return 'VIRTUAL_CARD';
        case Feature.RETRYABLE_KYC:
            return 'RETRYABLE_KYC';
        case Feature.SSO:
            return 'SSO';
        case Feature.SSO_V2:
            return 'SSO_V2';
        case Feature.EXPERIMENTAL:
            return 'EXPERIMENTAL';
        case Feature.POST_SIGNUP_SSO:
            return 'POST_SIGNUP_SSO';
        case Feature.EDITABLE_PROFILE:
            return 'EDITABLE_PROFILE';
        case Feature.REPLACE_CARD_NAME_CHANGE:
            return 'REPLACE_CARD_NAME_CHANGE';
        case Feature.WARNING_SMS_OTP_MESSAGE:
            return 'WARNING_SMS_OTP_MESSAGE';
        case Feature.DEBIT_CARD_SCANNER:
            return 'DEBIT_CARD_SCANNER';
        case Feature.CONTENT_CARDS_ONBOARDING:
            return 'CONTENT_CARDS_ONBOARDING';
        case Feature.SYNC_CONTACTS:
            return 'SYNC_CONTACTS';
        case Feature.PARENT_HOMESCREEN:
            return 'PARENT_HOMESCREEN';
        case Feature.AUTOMATED_TRANSACTION_DISPUTES:
            return 'AUTOMATED_TRANSACTION_DISPUTES';
        case Feature.PLAID_LINK_OAUTH:
            return 'PLAID_LINK_OAUTH';
        case Feature.GET_STARTED_COPY:
            return 'GET_STARTED_COPY';
        case Feature.CASH_DEPOSIT:
            return 'CASH_DEPOSIT';
        case Feature.IOS_APP_TRACKING:
            return 'IOS_APP_TRACKING';
        case Feature.REFERRAL_CODE_MANUAL_ENTRY:
            return 'REFERRAL_CODE_MANUAL_ENTRY';
        case Feature.MONITOR_APP_NOT_RESPONDING:
            return 'MONITOR_APP_NOT_RESPONDING';
        case Feature.ATM_PIN_WITHOUT_OTP:
            return 'ATM_PIN_WITHOUT_OTP';
        case Feature.VOICE_OTP:
            return 'VOICE_OTP';
        case Feature.DYNAMIC_REFERRAL_CAMPAIGNS:
            return 'DYNAMIC_REFERRAL_CAMPAIGNS';
        case Feature.REIMBURSING_TRANSACTIONS:
            return 'REIMBURSING_TRANSACTIONS';
        case Feature.FAMILY_MANAGEMENT:
            return 'FAMILY_MANAGEMENT';
        case Feature.REFERRAL_CONTACT_PICKER:
            return 'REFERRAL_CONTACT_PICKER';
        case Feature.RECURRING_PAYMENTS_V2:
            return 'RECURRING_PAYMENTS_V2';
        case Feature.APP_DIAGNOSTICS_BUG_REPORT:
            return 'APP_DIAGNOSTICS_BUG_REPORT';
        case Feature.DATASTORE_LOAD_RANDOM_ERROR:
            return 'DATASTORE_LOAD_RANDOM_ERROR';
        case Feature.REFERRAL_TRACKING:
            return 'REFERRAL_TRACKING';
        case Feature.REFERRAL_CELL_TOP:
            return 'REFERRAL_CELL_TOP';
        case Feature.REFERRAL_FAMILY_CELL:
            return 'REFERRAL_FAMILY_CELL';
        case Feature.WEB_SPONSOR_APPROVAL:
            return 'WEB_SPONSOR_APPROVAL';
        case Feature.SPONSOR_FREE_FUNDING:
            return 'SPONSOR_FREE_FUNDING';
        case Feature.ATM_MAP_NATIVE:
            return 'ATM_MAP_NATIVE';
        case Feature.DIRECT_DEPOSIT_IMPROVED_SURFACING:
            return 'DIRECT_DEPOSIT_IMPROVED_SURFACING';
        case Feature.INVITES_WHEN_P2P:
            return 'INVITES_WHEN_P2P';
        case Feature.TRANSFERS_V2:
            return 'TRANSFERS_V2';
        case Feature.GESTURE_BUG_REPORTING:
            return 'GESTURE_BUG_REPORTING';
        case Feature.SILENT_BUG_REPORTING:
            return 'SILENT_BUG_REPORTING';
        case Feature.P2P_FOR_NON_STEP_USERS_REQUEST:
            return 'P2P_FOR_NON_STEP_USERS_REQUEST';
        case Feature.P2P_FOR_NON_STEP_USERS_SEND:
            return 'P2P_FOR_NON_STEP_USERS_SEND';
        case Feature.ADVANCED_REFERRAL_CODE_SHARING:
            return 'ADVANCED_REFERRAL_CODE_SHARING';
        case Feature.LIGHT_MODE_HEADERS:
            return 'LIGHT_MODE_HEADERS';
        case Feature.NATIVE_HELP_CENTER:
            return 'NATIVE_HELP_CENTER';
        case Feature.PAY_ME_PAGE:
            return 'PAY_ME_PAGE';
        case Feature.EARLY_DIRECT_DEPOSIT:
            return 'EARLY_DIRECT_DEPOSIT';
        case Feature.USER_RISK_EVALUATION:
            return 'USER_RISK_EVALUATION';
        case Feature.CASH_DEPOSIT_MAP:
            return 'CASH_DEPOSIT_MAP';
        case Feature.SAVINGS:
            return 'SAVINGS';
        case Feature.MULTIPLE_SPONSOR_INVITES:
            return 'MULTIPLE_SPONSOR_INVITES';
        case Feature.IN_APP_LIMITS:
            return 'IN_APP_LIMITS';
        case Feature.ALLOW_MULTIPLE_COSPONSOR_INVITES:
            return 'ALLOW_MULTIPLE_COSPONSOR_INVITES';
        case Feature.SPLIT_SIGN_UP_AND_LOG_IN_FLOWS:
            return 'SPLIT_SIGN_UP_AND_LOG_IN_FLOWS';
        case Feature.ACCOUNT_DELETION_PAGE:
            return 'ACCOUNT_DELETION_PAGE';
        case Feature.P2P_FOR_NON_STEP_PERSONALIZED_UI:
            return 'P2P_FOR_NON_STEP_PERSONALIZED_UI';
        case Feature.P2P_FOR_NON_STEP_WEB_PAYMENT:
            return 'P2P_FOR_NON_STEP_WEB_PAYMENT';
        case Feature.CASH_DEPOSIT_FEE:
            return 'CASH_DEPOSIT_FEE';
        case Feature.BACKGROUND_TASK_MANAGER:
            return 'BACKGROUND_TASK_MANAGER';
        case Feature.FOOTER_DIVIDERS:
            return 'FOOTER_DIVIDERS';
        case Feature.STRIPE_ELEMENTS:
            return 'STRIPE_ELEMENTS';
        case Feature.SPONSOR_MANAGED_ACCOUNTS:
            return 'SPONSOR_MANAGED_ACCOUNTS';
        case Feature.PERSONALIZE_GEN_LINK_WITH_APPSFLYER:
            return 'PERSONALIZE_GEN_LINK_WITH_APPSFLYER';
        case Feature.PERSONALIZE_PARAMS_WITH_APPSFLYER:
            return 'PERSONALIZE_PARAMS_WITH_APPSFLYER';
        case Feature.SCHOOL_SELECTION:
            return 'SCHOOL_SELECTION';
        case Feature.SKIP_SPONSOR_REQUEST:
            return 'SKIP_SPONSOR_REQUEST';
        case Feature.REFERRAL_PROMPT:
            return 'REFERRAL_PROMPT';
        case Feature.REFERRAL_RECOMMENDATIONS:
            return 'REFERRAL_RECOMMENDATIONS';
        case Feature.P2P_PERSONALIZED_UI:
            return 'P2P_PERSONALIZED_UI';
        case Feature.ATM_FEE_REIMBURSEMENT_QUOTA:
            return 'ATM_FEE_REIMBURSEMENT_QUOTA';
        case Feature.FUNDING_SHORTCUT_40:
            return 'FUNDING_SHORTCUT_40';
        case Feature.CARD_FUNDING_MIN_5:
            return 'CARD_FUNDING_MIN_5';
        case Feature.CARD_FUNDING_MIN_10:
            return 'CARD_FUNDING_MIN_10';
        case Feature.THIN_FILE_SUPPORT:
            return 'THIN_FILE_SUPPORT';
        case Feature.LIMIT_LEVEL_2_POST_KYC_CONTROL:
            return 'LIMIT_LEVEL_2_POST_KYC_CONTROL';
        case Feature.LIMIT_LEVEL_2_POST_KYC_TREATMENT:
            return 'LIMIT_LEVEL_2_POST_KYC_TREATMENT';
        case Feature.SKIP_PAYFONE_VERIFICATION:
            return 'SKIP_PAYFONE_VERIFICATION';
        case Feature.POST_SPONSORSHIP_RECURRING_FUNDING_CTA:
            return 'POST_SPONSORSHIP_RECURRING_FUNDING_CTA';
        case Feature.ROUND_UP_TO_SAVINGS:
            return 'ROUND_UP_TO_SAVINGS';
        case Feature.SIGNUP_REFERRAL_PROMPT:
            return 'SIGNUP_REFERRAL_PROMPT';
        case Feature.POSITIVE_REFERRAL_PROMPT:
            return 'POSITIVE_REFERRAL_PROMPT';
        case Feature.PRE_SPONSORSHIP_PROFILE_PICTURE:
            return 'PRE_SPONSORSHIP_PROFILE_PICTURE';
        case Feature.SAVINGS_ROUND_UP:
            return 'SAVINGS_ROUND_UP';
        case Feature.PENDING_REFERRAL_BONUS:
            return 'PENDING_REFERRAL_BONUS';
        case Feature.CREDIT_REPORTING_ADULT:
            return 'CREDIT_REPORTING_ADULT';
        case Feature.RECOMMENDED_REFERRAL_INVITES:
            return 'RECOMMENDED_REFERRAL_INVITES';
        case Feature.POSITIVE_REFERRAL_PROMPT_V2:
            return 'POSITIVE_REFERRAL_PROMPT_V2';
        case Feature.SKIP_GET_CARD:
            return 'SKIP_GET_CARD';
        case Feature.SPONSORSHIP_SMS_COPY:
            return 'SPONSORSHIP_SMS_COPY';
        case Feature.SKIP_PHONE_CONFIRMATION_MODAL:
            return 'SKIP_PHONE_CONFIRMATION_MODAL';
        case Feature.SPONSORSHIP_PRIMER_COPY:
            return 'SPONSORSHIP_PRIMER_COPY';
        case Feature.ROLLING_BILLING:
            return 'ROLLING_BILLING';
        case Feature.OVERDRAFT_PROTECTION:
            return 'OVERDRAFT_PROTECTION';
        case Feature.SPONSOR_MANAGED_ACCOUNTS_GRADUATION:
            return 'SPONSOR_MANAGED_ACCOUNTS_GRADUATION';
        case Feature.LIMIT_LEVEL_2_RISK_SCORE:
            return 'LIMIT_LEVEL_2_RISK_SCORE';
        case Feature.EMANCIPATION:
            return 'EMANCIPATION';
        case Feature.BUY_NOW_PAY_LATER:
            return 'BUY_NOW_PAY_LATER';
        case Feature.CRYPTO_REWARDS:
            return 'CRYPTO_REWARDS';
        case Feature.OFFERS_VIEW:
            return 'OFFERS_VIEW';
        case Feature.SERVER_SIDE_SPONSORSHIP_INVITE:
            return 'SERVER_SIDE_SPONSORSHIP_INVITE';
        case Feature.SUGGESTED_FRIEND_INVITES:
            return 'SUGGESTED_FRIEND_INVITES';
        case Feature.SKIP_SHIPPING_ADDRESS_FOR_CARD:
            return 'SKIP_SHIPPING_ADDRESS_FOR_CARD';
        case Feature.CRYPTO_REWARDS_FOR_TEENS:
            return 'CRYPTO_REWARDS_FOR_TEENS';
        case Feature.ECBSV:
            return 'ECBSV';
        case Feature.SERVER_SIDE_REFERRAL_INVITE:
            return 'SERVER_SIDE_REFERRAL_INVITE';
        case Feature.ADDITIONAL_CREDIT_REPORTING_REQUIREMENTS:
            return 'ADDITIONAL_CREDIT_REPORTING_REQUIREMENTS';
        case Feature.CRYPTO_TRADING:
            return 'CRYPTO_TRADING';
        case Feature.REPLACE_DECISION_WITH_DOB:
            return 'REPLACE_DECISION_WITH_DOB';
        case Feature.HIDE_LINK_ACCOUNT_ITEM_SUBTITLE:
            return 'HIDE_LINK_ACCOUNT_ITEM_SUBTITLE';
        case Feature.REFERRAL_RECOMMENDATIONS_SERVER_RANK:
            return 'REFERRAL_RECOMMENDATIONS_SERVER_RANK';
        case Feature.CARD_REPLACEMENT_FEE:
            return 'CARD_REPLACEMENT_FEE';
        case Feature.CHECK_DEPOSIT:
            return 'CHECK_DEPOSIT';
        case Feature.CRYPTO_PARENTAL_CONTROLS:
            return 'CRYPTO_PARENTAL_CONTROLS';
        case Feature.HELPER_CARD_CAROUSEL:
            return 'HELPER_CARD_CAROUSEL';
        case Feature.APP_START_PERFORMANCE_LOGGING:
            return 'APP_START_PERFORMANCE_LOGGING';
        case Feature.CREDIT_MONITORING:
            return 'CREDIT_MONITORING';
        case Feature.STOCKS_TRADING:
            return 'STOCKS_TRADING';
        case Feature.OFFER_CRYPTOGIVEAWAY100OCT12:
            return 'OFFER_CRYPTOGIVEAWAY100OCT12';
        case Feature.SUBSCRIPTION_MANAGEMENT:
            return 'SUBSCRIPTION_MANAGEMENT';
        case Feature.INSTANT_CASHOUT:
            return 'INSTANT_CASHOUT';
        case Feature.BNPL_PARTIAL_PAYMENT:
            return 'BNPL_PARTIAL_PAYMENT';
        case Feature.MILESTONE_REPORTING:
            return 'MILESTONE_REPORTING';
        case Feature.FRACTIONAL_LIMITS:
            return 'FRACTIONAL_LIMITS';
        case Feature.ACCOUNT_SCREEN_WITH_SUGGESTED_FRIENDS:
            return 'ACCOUNT_SCREEN_WITH_SUGGESTED_FRIENDS';
        case Feature.SUGGESTED_FRIENDS_WITH_REFRESH:
            return 'SUGGESTED_FRIENDS_WITH_REFRESH';
        case Feature.SUGGESTED_FRIENDS_WITH_DISMISS:
            return 'SUGGESTED_FRIENDS_WITH_DISMISS';
        case Feature.STREAMLINED_TRANSFERS:
            return 'STREAMLINED_TRANSFERS';
        case Feature.CANCEL_MERCHANT_INFO:
            return 'CANCEL_MERCHANT_INFO';
        case Feature.UNSECURED_CARD:
            return 'UNSECURED_CARD';
        case Feature.USE_STRIPE_PAYMENT_INTENT:
            return 'USE_STRIPE_PAYMENT_INTENT';
        case Feature.REQUEST_3DS:
            return 'REQUEST_3DS';
        case Feature.MERCHANT_BLOCKING:
            return 'MERCHANT_BLOCKING';
        case Feature.CREDIT_MONITORING_GRAPH:
            return 'CREDIT_MONITORING_GRAPH';
        case Feature.TIPPING:
            return 'TIPPING';
        case Feature.PAY_OVER_TIME:
            return 'PAY_OVER_TIME';
        case Feature.STEP_EMPLOYEE:
            return 'STEP_EMPLOYEE';
        case Feature.BLOCK_FOREIGN_CHARGES:
            return 'BLOCK_FOREIGN_CHARGES';
        case Feature.ONBOARDING_FLOW_REFACTOR:
            return 'ONBOARDING_FLOW_REFACTOR';
        case Feature.WEB_SPONSORSHIP_PERSONALIZATION:
            return 'WEB_SPONSORSHIP_PERSONALIZATION';
        case Feature.WEB_SPONSORSHIP_FUNDING:
            return 'WEB_SPONSORSHIP_FUNDING';
        case Feature.CREDIT_MONITORING_ADVERSE_ACTION_CODES:
            return 'CREDIT_MONITORING_ADVERSE_ACTION_CODES';
        case Feature.STEP_BACK_ANNUAL:
            return 'STEP_BACK_ANNUAL';
        case Feature.REFEREE_REMINDER:
            return 'REFEREE_REMINDER';
        case Feature.WEB_SPONSORSHIP_VALUE_PROPS:
            return 'WEB_SPONSORSHIP_VALUE_PROPS';
        case Feature.WRONG_LOGIN_FLOW_SIGNUP:
            return 'WRONG_LOGIN_FLOW_SIGNUP';
        case Feature.AA_FAMILY:
            return 'AA_FAMILY';
        case Feature.AA_FAMILY_VARIANTS:
            return 'AA_FAMILY_VARIANTS';
        case Feature.AA_USER:
            return 'AA_USER';
        case Feature.AA_USER_VARIANTS:
            return 'AA_USER_VARIANTS';
        case Feature.OFFER_BUNDLES:
            return 'OFFER_BUNDLES';
        case Feature.STOCKS_TRADING_M2:
            return 'STOCKS_TRADING_M2';
        case Feature.HIDE_REFERRALS:
            return 'HIDE_REFERRALS';
        case Feature.WEB_SPONSORSHIP_FUNDING_SKIP:
            return 'WEB_SPONSORSHIP_FUNDING_SKIP';
        case Feature.STOCKS_SEARCH_WITHOUT_ENROLLMENT:
            return 'STOCKS_SEARCH_WITHOUT_ENROLLMENT';
        case Feature.POINTS:
            return 'POINTS';
        case Feature.CARD_FUNDING_ACTION_ORDER:
            return 'CARD_FUNDING_ACTION_ORDER';
        case Feature.SAVINGS_APY:
            return 'SAVINGS_APY';
        case Feature.TIERS:
            return 'TIERS';
        case Feature.SHOW_VIRTUAL_CARD_INTRO_VIDEO:
            return 'SHOW_VIRTUAL_CARD_INTRO_VIDEO';
        case Feature.ONBOARDING_QUIZ:
            return 'ONBOARDING_QUIZ';
        case Feature.INVESTING_ACTIONS_IN_HELPER_CARDS:
            return 'INVESTING_ACTIONS_IN_HELPER_CARDS';
        case Feature.CUSTOM_CHECK_SCANNING:
            return 'CUSTOM_CHECK_SCANNING';
        case Feature.DIRECT_DEPOSIT_SWITCH:
            return 'DIRECT_DEPOSIT_SWITCH';
        case Feature.ACCOUNT_PROGRESS:
            return 'ACCOUNT_PROGRESS';
        case Feature.LESS_STRICT_PAYME:
            return 'LESS_STRICT_PAYME';
        case Feature.SUGGESTED_FRIENDS_NO_PREVIEW_DISMISS:
            return 'SUGGESTED_FRIENDS_NO_PREVIEW_DISMISS';
        case Feature.QUIZ_SHARE_MESSAGE:
            return 'QUIZ_SHARE_MESSAGE';
        case Feature.WEB_HOME_TEEN_BANKING:
            return 'WEB_HOME_TEEN_BANKING';
        case Feature.WEB_SPONSORSHIP_PREVIEW_IMAGE:
            return 'WEB_SPONSORSHIP_PREVIEW_IMAGE';
        case Feature.CRYPTO_TAX_DOCUMENTS:
            return 'CRYPTO_TAX_DOCUMENTS';
        case Feature.STEP_BLACK_WAITLIST:
            return 'STEP_BLACK_WAITLIST';
        case Feature.STEP_BLACK_TIER:
            return 'STEP_BLACK_TIER';
        case Feature.CARD_MANAGEMENT_V2:
            return 'CARD_MANAGEMENT_V2';
        case Feature.POINTS_OFFERS:
            return 'POINTS_OFFERS';
        case Feature.NEW_APP_THEMES:
            return 'NEW_APP_THEMES';
        case Feature.STOCKS_GRADUATION:
            return 'STOCKS_GRADUATION';
        case Feature.SERVER_SIDE_ACCOUNT_PROGRESS:
            return 'SERVER_SIDE_ACCOUNT_PROGRESS';
        case Feature.CASH_BUNDLES:
            return 'CASH_BUNDLES';
        case Feature.STOCKS_DISCOVER:
            return 'STOCKS_DISCOVER';
        case Feature.PUBLIC_PAY_ME_LINK:
            return 'PUBLIC_PAY_ME_LINK';
        case Feature.POT_FIXED_APR:
            return 'POT_FIXED_APR';
        case Feature.AUTOCANCEL_STUCK_INSTANT_PAYOUTS:
            return 'AUTOCANCEL_STUCK_INSTANT_PAYOUTS';
        case Feature.HIDE_SUGGESTED_REFERRALS:
            return 'HIDE_SUGGESTED_REFERRALS';
        case Feature.CARD_FUNDING_RECEIPT_EMAIL:
            return 'CARD_FUNDING_RECEIPT_EMAIL';
        case Feature.REQUIRED_MIN_FUNDING_AMOUNT:
            return 'REQUIRED_MIN_FUNDING_AMOUNT';
        case Feature.POT_ESTIMATE_DATES:
            return 'POT_ESTIMATE_DATES';
        case Feature.APP_TAB_NAVIGATION:
            return 'APP_TAB_NAVIGATION';
        case Feature.PLATFORM_PAY_FUNDING:
            return 'PLATFORM_PAY_FUNDING';
        case Feature.SUGGESTED_TRANSFER_AMOUNT:
            return 'SUGGESTED_TRANSFER_AMOUNT';
        case Feature.PHONE_NUMBER_TAKEOVER:
            return 'PHONE_NUMBER_TAKEOVER';
        case Feature.SOLO_VS_PARENT_DECISION_AGE:
            return 'SOLO_VS_PARENT_DECISION_AGE';
        case Feature.NO_DESIGN_CARD_ONBOARDING:
            return 'NO_DESIGN_CARD_ONBOARDING';
        case Feature.LOGIN_SIGNUP_IMPROVEMENTS:
            return 'LOGIN_SIGNUP_IMPROVEMENTS';
        case Feature.PRIORITY_SHIPPING:
            return 'PRIORITY_SHIPPING';
        case Feature.STEP_BLACK_LANDING_PAGE_OPTIMIZED_LAYOUT:
            return 'STEP_BLACK_LANDING_PAGE_OPTIMIZED_LAYOUT';
        case Feature.CREDIT_PULL_CONSENT:
            return 'CREDIT_PULL_CONSENT';
        case Feature.POT_BORROW_CASH:
            return 'POT_BORROW_CASH';
        case Feature.WEB_SPONSORSHIP_ALLOWANCE:
            return 'WEB_SPONSORSHIP_ALLOWANCE';
        case Feature.WEB_SPONSORSHIP_FUNDING_WALLET_PAYMENTS:
            return 'WEB_SPONSORSHIP_FUNDING_WALLET_PAYMENTS';
        case Feature.WEB_SPONSORSHIP_FUNDING_RECOMMENDED_AMOUNT:
            return 'WEB_SPONSORSHIP_FUNDING_RECOMMENDED_AMOUNT';
        case Feature.INVESTING_PORTFOLIO_PERFORMANCE:
            return 'INVESTING_PORTFOLIO_PERFORMANCE';
        case Feature.TRANSFER_DIRECTLY_FROM_BANK:
            return 'TRANSFER_DIRECTLY_FROM_BANK';
        case Feature.WEB_UNAUTHED_WALLET_PAYMENTS:
            return 'WEB_UNAUTHED_WALLET_PAYMENTS';
        case Feature.CLOSED_CRYPTO_ACCOUNTS:
            return 'CLOSED_CRYPTO_ACCOUNTS';
        case Feature.CLOSED_STOCK_ACCOUNTS:
            return 'CLOSED_STOCK_ACCOUNTS';
        case Feature.CRYPTO_CHARTS:
            return 'CRYPTO_CHARTS';
        case Feature.ENHANCED_PARENT_SAVINGS:
            return 'ENHANCED_PARENT_SAVINGS';
        case Feature.WEB_SPONSORSHIP_FIXED_APPROVE_BUTTON:
            return 'WEB_SPONSORSHIP_FIXED_APPROVE_BUTTON';
        case Feature.CHECK_SCANNING_V2:
            return 'CHECK_SCANNING_V2';
        case Feature.VISA_SIGNATURE:
            return 'VISA_SIGNATURE';
        case Feature.INVESTING_ROUND_UPS:
            return 'INVESTING_ROUND_UPS';
        case Feature.IOS_ONLY_OFFER:
            return 'IOS_ONLY_OFFER';
        case Feature.DAILY_TRIVIA_LEADERBOARD:
            return 'DAILY_TRIVIA_LEADERBOARD';
        case Feature.CRYPTO_ROUND_UPS:
            return 'CRYPTO_ROUND_UPS';
        case Feature.BORROW_APPLICATION_FLOW:
            return 'BORROW_APPLICATION_FLOW';
        case Feature.USER_TIER_REFERRAL_CAMPAIGN:
            return 'USER_TIER_REFERRAL_CAMPAIGN';
        case Feature.AUTO_PERFORMANCE_LOGGING:
            return 'AUTO_PERFORMANCE_LOGGING';
        case Feature.LEGAL_ADDRESS_PO_BOX_VALIDATION:
            return 'LEGAL_ADDRESS_PO_BOX_VALIDATION';
        case Feature.FAIL_KYC_ON_IDV_REQUIRED:
            return 'FAIL_KYC_ON_IDV_REQUIRED';
        case Feature.UNLIMITED_REFERRALS:
            return 'UNLIMITED_REFERRALS';
        case Feature.POINTS_AS_DOLLARS_REFERRALS:
            return 'POINTS_AS_DOLLARS_REFERRALS';
        case Feature.GIFT_CARDS:
            return 'GIFT_CARDS';
        case Feature.DATASTORE_CACHE_FAMILY_MEMBERS:
            return 'DATASTORE_CACHE_FAMILY_MEMBERS';
        case Feature.ASYNC_PHYSICAL_CARD_ISSUING:
            return 'ASYNC_PHYSICAL_CARD_ISSUING';
        case Feature.SIGNUP_INTEREST_SURVEY:
            return 'SIGNUP_INTEREST_SURVEY';
        case Feature.DAILY_TRIVIA_REWARDS:
            return 'DAILY_TRIVIA_REWARDS';
        case Feature.SIGNUP_NEW_INTRO_SCREENS:
            return 'SIGNUP_NEW_INTRO_SCREENS';
        case Feature.SOLO_ADULT_PRE_KYC_PREMIER:
            return 'SOLO_ADULT_PRE_KYC_PREMIER';
        case Feature.HIGH_DPI_CARD_SIGNATURE:
            return 'HIGH_DPI_CARD_SIGNATURE';
        case Feature.BNPL_CHECK_MLA:
            return 'BNPL_CHECK_MLA';
        case Feature.NEW_NAVIGATION_HELPER_CARD:
            return 'NEW_NAVIGATION_HELPER_CARD';
        case Feature.ACCOUNT_PROGRESS_WITH_INCENTIVES:
            return 'ACCOUNT_PROGRESS_WITH_INCENTIVES';
        case Feature.RECURRING_PAYMENTS:
            return 'RECURRING_PAYMENTS';
        case Feature.PLATFORM_PAY_REQUIRE_ADDRESS:
            return 'PLATFORM_PAY_REQUIRE_ADDRESS';
        case Feature.DIRECT_DEPOSIT_IN_ONBOARDING:
            return 'DIRECT_DEPOSIT_IN_ONBOARDING';
        case Feature.NO_REFERRALS_ONBOARDING:
            return 'NO_REFERRALS_ONBOARDING';
        case Feature.AUTO_RELOAD:
            return 'AUTO_RELOAD';
        case Feature.PLOTLINE:
            return 'PLOTLINE';
        case Feature.CRYPTO_ENROLL_AND_BUY:
            return 'CRYPTO_ENROLL_AND_BUY';
        case Feature.CREDIT_REPORTING_BY_DEFAULT:
            return 'CREDIT_REPORTING_BY_DEFAULT';
        case Feature.APP_TAB_NAVIGATION_M2:
            return 'APP_TAB_NAVIGATION_M2';
        case Feature.STEP_BLACK_V2:
            return 'STEP_BLACK_V2';
        case Feature.PREMIUM_V2_FEES:
            return 'PREMIUM_V2_FEES';
        case Feature.SOLO_ADULT_CONDITIONAL_PHYSICAL_CARD:
            return 'SOLO_ADULT_CONDITIONAL_PHYSICAL_CARD';
        case Feature.COMBINED_BORROW_APPLICATION_FLOW:
            return 'COMBINED_BORROW_APPLICATION_FLOW';
        case Feature.NEW_LIMIT_LEVELS:
            return 'NEW_LIMIT_LEVELS';
        case Feature.LLM_CHAT:
            return 'LLM_CHAT';
        case Feature.BILL_PAY:
            return 'BILL_PAY';
        case Feature.ACTIVITY_FEED_V2:
            return 'ACTIVITY_FEED_V2';
        case Feature.UNLOCK_APP:
            return 'UNLOCK_APP';
        case Feature.MILESTONE_CTA_OVERRIDE:
            return 'MILESTONE_CTA_OVERRIDE';
        case Feature.EMAIL_MAGIC_LINK:
            return 'EMAIL_MAGIC_LINK';
        case Feature.BILL_PAY_M2:
            return 'BILL_PAY_M2';
        case Feature.NEW_NAV_M2_REFERRAL_ENTRY_POINTS:
            return 'NEW_NAV_M2_REFERRAL_ENTRY_POINTS';
        case Feature.SUSPICIOUS_TXN_SMS_CHALLENGE:
            return 'SUSPICIOUS_TXN_SMS_CHALLENGE';
        case Feature.ONBOARDING_SERVICE_ONBOARD_API:
            return 'ONBOARDING_SERVICE_ONBOARD_API';
        case Feature.UNLOCK_APP_DEFAULT_ON:
            return 'UNLOCK_APP_DEFAULT_ON';
        case Feature.ML_FOR_ACH_REVIEW:
            return 'ML_FOR_ACH_REVIEW';
        case Feature.FORCE_SMS_CHALLENGE:
            return 'FORCE_SMS_CHALLENGE';
        case Feature.NEW_DEVICE_LOGIN_NOTIFICATION:
            return 'NEW_DEVICE_LOGIN_NOTIFICATION';
        case Feature.ONBOARDING_JOURNEY_FLOW:
            return 'ONBOARDING_JOURNEY_FLOW';
        case Feature.ONBOARDING_FUNDING:
            return 'ONBOARDING_FUNDING';
        case Feature.SIGNUP_INTEREST_BASED_KYC_PRIMER:
            return 'SIGNUP_INTEREST_BASED_KYC_PRIMER';
        case Feature.PASSKEY_LOGIN:
            return 'PASSKEY_LOGIN';
        case Feature.ACCOUNT_PROGRESS_LANDING:
            return 'ACCOUNT_PROGRESS_LANDING';
        case Feature.CRITICAL_ONLY_MAIN_SCREEN:
            return 'CRITICAL_ONLY_MAIN_SCREEN';
        case Feature.ACCOUNT_PROGRESS_SERIES:
            return 'ACCOUNT_PROGRESS_SERIES';
        case Feature.ACCOUNT_PROGRESS_INTEREST_BASED:
            return 'ACCOUNT_PROGRESS_INTEREST_BASED';
        case Feature.DIRECT_DEPOSIT_FUNDING_RECOMMENDATION:
            return 'DIRECT_DEPOSIT_FUNDING_RECOMMENDATION';
        case Feature.FLEX_DUE_DATE:
            return 'FLEX_DUE_DATE';
        case Feature.DISPUTES_INTAKE_REVAMP:
            return 'DISPUTES_INTAKE_REVAMP';
        case Feature.STEP_BLACK_AS_DEFAULT_IN_AP:
            return 'STEP_BLACK_AS_DEFAULT_IN_AP';
        case Feature.ACCOUNT_PROGRESS_STATUS_ICON:
            return 'ACCOUNT_PROGRESS_STATUS_ICON';
        case Feature.PASSKEY_UPSELL_ON_LOGIN:
            return 'PASSKEY_UPSELL_ON_LOGIN';
        case Feature.LIFECYCLE_STORE_REFRESH_ON_LEDGER_UPDATE:
            return 'LIFECYCLE_STORE_REFRESH_ON_LEDGER_UPDATE';
        case Feature.CREDIT_MONITORING_V2:
            return 'CREDIT_MONITORING_V2';
        case Feature.CTA_STATUS_UPDATED_PN:
            return 'CTA_STATUS_UPDATED_PN';
        case Feature.BILL_PAY_M1_1:
            return 'BILL_PAY_M1_1';
        case Feature.SERVER_SIDE_LEARN_MORE:
            return 'SERVER_SIDE_LEARN_MORE';
        case Feature.CREDIT_HEALTH_BUILD_CREDIT_PROGRESS:
            return 'CREDIT_HEALTH_BUILD_CREDIT_PROGRESS';
        case Feature.BORROW_APPLICATION_DD:
            return 'BORROW_APPLICATION_DD';
        case Feature.DIRECT_DEPOSIT_UPDATES_M1:
            return 'DIRECT_DEPOSIT_UPDATES_M1';
        case Feature.MY_DIRECT_DEPOSIT:
            return 'MY_DIRECT_DEPOSIT';
        case Feature.HIDE_BASIC_INTRO_IN_SB_FLOW:
            return 'HIDE_BASIC_INTRO_IN_SB_FLOW';
        case Feature.ONBOARDING_STEP_BLACK:
            return 'ONBOARDING_STEP_BLACK';
        case Feature.EMPLOYMENT_SURVEY:
            return 'EMPLOYMENT_SURVEY';
        case Feature.SARDINE_FRAUD_CHECK:
            return 'SARDINE_FRAUD_CHECK';
        case Feature.CHECK_DEPOSIT_V2:
            return 'CHECK_DEPOSIT_V2';
        case Feature.MARKETPLACE_HELPER_CARD:
            return 'MARKETPLACE_HELPER_CARD';
        case Feature.TOP_MERCHANTS_ON_CARDS_SCREEN:
            return 'TOP_MERCHANTS_ON_CARDS_SCREEN';
        case Feature.MOVE_MONEY_V2:
            return 'MOVE_MONEY_V2';
        case Feature.BORROW_APPLICATION_DD_BYPASS:
            return 'BORROW_APPLICATION_DD_BYPASS';
        case Feature.SHARE_SCREENSHOT_BUTTON:
            return 'SHARE_SCREENSHOT_BUTTON';
        case Feature.DIRECT_DEPOSIT_IN_PROGRESS_LIST:
            return 'DIRECT_DEPOSIT_IN_PROGRESS_LIST';
        case Feature.BILL_PAY_IN_PROGRESS_LIST:
            return 'BILL_PAY_IN_PROGRESS_LIST';
        case Feature.BIRTHDAY_18_OFFER:
            return 'BIRTHDAY_18_OFFER';
        case Feature.POT_PAY_IN_ONE:
            return 'POT_PAY_IN_ONE';
        case Feature.POT_CONFIGURABLE_APR:
            return 'POT_CONFIGURABLE_APR';
        case Feature.POT_LATE_FEE:
            return 'POT_LATE_FEE';
        case Feature.ACHIEVEMENTS:
            return 'ACHIEVEMENTS';
        case Feature.CREDIT_LEADERBOARD:
            return 'CREDIT_LEADERBOARD';
        case Feature.SOLO_ADULT_DIRECT_DEPOSIT_TO_ORDER_CARD:
            return 'SOLO_ADULT_DIRECT_DEPOSIT_TO_ORDER_CARD';
        case Feature.DESIGN_SYSTEM_TEXT_STYLES:
            return 'DESIGN_SYSTEM_TEXT_STYLES';
        case Feature.DESIGN_SYSTEM_COLORS:
            return 'DESIGN_SYSTEM_COLORS';
        case Feature.DESIGN_SYSTEM_SPACING:
            return 'DESIGN_SYSTEM_SPACING';
        case Feature.BRAZE_CREDIT_SCORE_CHANGED:
            return 'BRAZE_CREDIT_SCORE_CHANGED';
        case Feature.BORROW_REGION_BYPASS:
            return 'BORROW_REGION_BYPASS';
        case Feature.BORROW_APPLICATION_QUESTIONS:
            return 'BORROW_APPLICATION_QUESTIONS';
        case Feature.DD_TRACKER_ON_STEP_BLACK_SCREEN:
            return 'DD_TRACKER_ON_STEP_BLACK_SCREEN';
        case Feature.FRIENDS_TRIVIA_LEADERBOARD:
            return 'FRIENDS_TRIVIA_LEADERBOARD';
        case Feature.CLOSE_ACCOUNT_FLOW:
            return 'CLOSE_ACCOUNT_FLOW';
        case Feature.SPIN_THE_WHEEL:
            return 'SPIN_THE_WHEEL';
        case Feature.BORROW_APPLICATION_DD_CTAS:
            return 'BORROW_APPLICATION_DD_CTAS';
        case Feature.GIGS_MOBILE:
            return 'GIGS_MOBILE';
        case Feature.MOBILE_PLANS:
            return 'MOBILE_PLANS';
        case Feature.DIRECT_DEPOSIT_UPDATES_M1_V2:
            return 'DIRECT_DEPOSIT_UPDATES_M1_V2';
        case Feature.ACH_AUTO_DECLINE:
            return 'ACH_AUTO_DECLINE';
        case Feature.BRIDGE_MONEY:
            return 'BRIDGE_MONEY';
        case Feature.RANDOMIZED_INTEREST_SURVEY:
            return 'RANDOMIZED_INTEREST_SURVEY';
        case Feature.INTEREST_BASED_AP_M3:
            return 'INTEREST_BASED_AP_M3';
        case Feature.TAX_FILING:
            return 'TAX_FILING';
        case Feature.APP_START_NATIVE_LOGGING:
            return 'APP_START_NATIVE_LOGGING';
        case Feature.VIRTUAL_DEBIT_CARDS_M1:
            return 'VIRTUAL_DEBIT_CARDS_M1';
        case Feature.EXTERNAL_ACCOUNT_NICKNAME:
            return 'EXTERNAL_ACCOUNT_NICKNAME';
        case Feature.SCAN_EXTERNAL_ACCOUNT:
            return 'SCAN_EXTERNAL_ACCOUNT';
        case Feature.ONBOARDING_INTENT_TRIVIA_LEADERBOARD:
            return 'ONBOARDING_INTENT_TRIVIA_LEADERBOARD';
        case Feature.ONBOARDING_INTENT_CREDIT_LEADERBOARD:
            return 'ONBOARDING_INTENT_CREDIT_LEADERBOARD';
        case Feature.BUDGETING:
            return 'BUDGETING';
        case Feature.SOLO_ADULT_UNCONDITIONAL_PHYSICAL_CARD_ORDER:
            return 'SOLO_ADULT_UNCONDITIONAL_PHYSICAL_CARD_ORDER';
        case Feature.POT_PAY_IN_ONE_V2:
            return 'POT_PAY_IN_ONE_V2';
        case Feature.EARN_WITH_STEP:
            return 'EARN_WITH_STEP';
        case Feature.POT_PAY_IN_ONE_CREDIT_REPORTING:
            return 'POT_PAY_IN_ONE_CREDIT_REPORTING';
        case Feature.ADD_CARD_POPUP:
            return 'ADD_CARD_POPUP';
        case Feature.AP_POPUP_CONTINUOUS:
            return 'AP_POPUP_CONTINUOUS';
        case Feature.STEP_BLACK_UPSELL_MODAL:
            return 'STEP_BLACK_UPSELL_MODAL';
        case Feature.DISABLE_KYC_PREFILL:
            return 'DISABLE_KYC_PREFILL';
        case Feature.DISPUTE_VROL_FLOW:
            return 'DISPUTE_VROL_FLOW';
        case Feature.STEP_BLACK_AUTO_ENROLL:
            return 'STEP_BLACK_AUTO_ENROLL';
        case Feature.LIMIT_LEVEL_SET:
            return 'LIMIT_LEVEL_SET';
        case Feature.BRAZE_SB_FAILED_COMMS:
            return 'BRAZE_SB_FAILED_COMMS';
        case Feature._TEST_USER:
            return '_TEST_USER';
        case Feature._TEST_FAMILY:
            return '_TEST_FAMILY';
        case Feature._TEST_FAMILY_INVITE:
            return '_TEST_FAMILY_INVITE';
        case Feature._TEST_PERCENTAGE:
            return '_TEST_PERCENTAGE';
        case Feature._TEST_REQUIRED_APP_VERSION:
            return '_TEST_REQUIRED_APP_VERSION';
        case Feature._TEST_REFERRAL:
            return '_TEST_REFERRAL';
        case Feature._TEST_VARIANT:
            return '_TEST_VARIANT';
        case Feature._TEST_ANOTHER_VARIANT:
            return '_TEST_ANOTHER_VARIANT';
        case Feature._TEST_USER_CREATED_AFTER_DATE:
            return '_TEST_USER_CREATED_AFTER_DATE';
        case Feature._TEST_ROLLED_OUT_FEATURE:
            return '_TEST_ROLLED_OUT_FEATURE';
        case Feature._TEST_VARIANT_WITH_REQUIRED_VERSION:
            return '_TEST_VARIANT_WITH_REQUIRED_VERSION';
        case Feature._TEST_UNAUTHENTICATED_FEATURE:
            return '_TEST_UNAUTHENTICATED_FEATURE';
        case Feature._TEST_ALWAYS_APPLICABLE_FEATURE:
            return '_TEST_ALWAYS_APPLICABLE_FEATURE';
        case Feature._TEST_UNAUTHENTICATED_WITH_PERCENTAGE:
            return '_TEST_UNAUTHENTICATED_WITH_PERCENTAGE';
        case Feature._TEST_UNAUTHENTICATED_WITH_VARIANT:
            return '_TEST_UNAUTHENTICATED_WITH_VARIANT';
        case Feature._TEST_UNAUTHENTICATED_WITH_REQUIRED_APP_VERSION:
            return '_TEST_UNAUTHENTICATED_WITH_REQUIRED_APP_VERSION';
        case Feature._TEST_SERVER_FEATURE:
            return '_TEST_SERVER_FEATURE';
        case Feature._TEST_ROLLED_OUT_SERVER_FEATURE:
            return '_TEST_ROLLED_OUT_SERVER_FEATURE';
        case Feature._TEST_SERVER_WITH_PERCENTAGE:
            return '_TEST_SERVER_WITH_PERCENTAGE';
        case Feature._TEST_SERVER_WITH_VARIANT:
            return '_TEST_SERVER_WITH_VARIANT';
        case Feature.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.featureToJSON = featureToJSON;
function featureApplicabilityFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_FEATURE_APPLICABILITY':
            return FeatureApplicability.INVALID_FEATURE_APPLICABILITY;
        case 1:
        case 'UNAUTHENTICATED_ONLY':
            return FeatureApplicability.UNAUTHENTICATED_ONLY;
        case 2:
        case 'ALWAYS':
            return FeatureApplicability.ALWAYS;
        case 3:
        case 'AUTHENTICATED_ONLY':
            return FeatureApplicability.AUTHENTICATED_ONLY;
        case 4:
        case 'SERVER_ONLY':
            return FeatureApplicability.SERVER_ONLY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return FeatureApplicability.UNRECOGNIZED;
    }
}
exports.featureApplicabilityFromJSON = featureApplicabilityFromJSON;
function featureApplicabilityToJSON(object) {
    switch (object) {
        case FeatureApplicability.INVALID_FEATURE_APPLICABILITY:
            return 'INVALID_FEATURE_APPLICABILITY';
        case FeatureApplicability.UNAUTHENTICATED_ONLY:
            return 'UNAUTHENTICATED_ONLY';
        case FeatureApplicability.ALWAYS:
            return 'ALWAYS';
        case FeatureApplicability.AUTHENTICATED_ONLY:
            return 'AUTHENTICATED_ONLY';
        case FeatureApplicability.SERVER_ONLY:
            return 'SERVER_ONLY';
        case FeatureApplicability.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.featureApplicabilityToJSON = featureApplicabilityToJSON;
function variantWebSponsorshipFundingSkipVariantBehaviorFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_WEB_FUNDING_BEHAVIOR':
            return VariantWebSponsorshipFundingSkipVariantBehavior.INVALID_WEB_FUNDING_BEHAVIOR;
        case 1:
        case 'WEB_FUNDING_ALLOW':
            return VariantWebSponsorshipFundingSkipVariantBehavior.WEB_FUNDING_ALLOW;
        case 2:
        case 'WEB_FUNDING_WARN':
            return VariantWebSponsorshipFundingSkipVariantBehavior.WEB_FUNDING_WARN;
        case 3:
        case 'WEB_FUNDING_DISALLOW':
            return VariantWebSponsorshipFundingSkipVariantBehavior.WEB_FUNDING_DISALLOW;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return VariantWebSponsorshipFundingSkipVariantBehavior.UNRECOGNIZED;
    }
}
exports.variantWebSponsorshipFundingSkipVariantBehaviorFromJSON = variantWebSponsorshipFundingSkipVariantBehaviorFromJSON;
function variantWebSponsorshipFundingSkipVariantBehaviorToJSON(object) {
    switch (object) {
        case VariantWebSponsorshipFundingSkipVariantBehavior.INVALID_WEB_FUNDING_BEHAVIOR:
            return 'INVALID_WEB_FUNDING_BEHAVIOR';
        case VariantWebSponsorshipFundingSkipVariantBehavior.WEB_FUNDING_ALLOW:
            return 'WEB_FUNDING_ALLOW';
        case VariantWebSponsorshipFundingSkipVariantBehavior.WEB_FUNDING_WARN:
            return 'WEB_FUNDING_WARN';
        case VariantWebSponsorshipFundingSkipVariantBehavior.WEB_FUNDING_DISALLOW:
            return 'WEB_FUNDING_DISALLOW';
        case VariantWebSponsorshipFundingSkipVariantBehavior.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.variantWebSponsorshipFundingSkipVariantBehaviorToJSON = variantWebSponsorshipFundingSkipVariantBehaviorToJSON;
function request3DSVariantFrequencyFromJSON(object) {
    switch (object) {
        case 0:
        case 'REQUEST_3DS_INVALID':
            return Request3DSVariantFrequency.REQUEST_3DS_INVALID;
        case 1:
        case 'REQUEST_3DS_NEVER':
            return Request3DSVariantFrequency.REQUEST_3DS_NEVER;
        case 2:
        case 'REQUEST_3DS_ALWAYS':
            return Request3DSVariantFrequency.REQUEST_3DS_ALWAYS;
        case 3:
        case 'REQUEST_3DS_RULE':
            return Request3DSVariantFrequency.REQUEST_3DS_RULE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Request3DSVariantFrequency.UNRECOGNIZED;
    }
}
exports.request3DSVariantFrequencyFromJSON = request3DSVariantFrequencyFromJSON;
function request3DSVariantFrequencyToJSON(object) {
    switch (object) {
        case Request3DSVariantFrequency.REQUEST_3DS_INVALID:
            return 'REQUEST_3DS_INVALID';
        case Request3DSVariantFrequency.REQUEST_3DS_NEVER:
            return 'REQUEST_3DS_NEVER';
        case Request3DSVariantFrequency.REQUEST_3DS_ALWAYS:
            return 'REQUEST_3DS_ALWAYS';
        case Request3DSVariantFrequency.REQUEST_3DS_RULE:
            return 'REQUEST_3DS_RULE';
        case Request3DSVariantFrequency.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.request3DSVariantFrequencyToJSON = request3DSVariantFrequencyToJSON;
function serverSideFullScreenModalVariantFullScreenModalTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_MODAL_TYPE':
            return ServerSideFullScreenModalVariantFullScreenModalType.INVALID_MODAL_TYPE;
        case 1:
        case 'ADD_FUNDS':
            return ServerSideFullScreenModalVariantFullScreenModalType.ADD_FUNDS;
        case 2:
        case 'ADD_FUNDS_SPONSORED_ACCOUNT':
            return ServerSideFullScreenModalVariantFullScreenModalType.ADD_FUNDS_SPONSORED_ACCOUNT;
        case 3:
        case 'LINK_ACCOUNT':
            return ServerSideFullScreenModalVariantFullScreenModalType.LINK_ACCOUNT;
        case 4:
        case 'FLEX_ALMOST_DUE_3':
            return ServerSideFullScreenModalVariantFullScreenModalType.FLEX_ALMOST_DUE_3;
        case 5:
        case 'FLEX_DUE':
            return ServerSideFullScreenModalVariantFullScreenModalType.FLEX_DUE;
        case 6:
        case 'FLEX_DUE_AUTO_PAY_FAILED':
            return ServerSideFullScreenModalVariantFullScreenModalType.FLEX_DUE_AUTO_PAY_FAILED;
        case 7:
        case 'FLEX_AUTO_PAY_FAILED':
            return ServerSideFullScreenModalVariantFullScreenModalType.FLEX_AUTO_PAY_FAILED;
        case 8:
        case 'FLEX_PAST_DUE':
            return ServerSideFullScreenModalVariantFullScreenModalType.FLEX_PAST_DUE;
        case 9:
        case 'FLEX_PAST_DUE_60':
            return ServerSideFullScreenModalVariantFullScreenModalType.FLEX_PAST_DUE_60;
        case 10:
        case 'ACCOUNT_PROGRESS_COMPLETED':
            return ServerSideFullScreenModalVariantFullScreenModalType.ACCOUNT_PROGRESS_COMPLETED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ServerSideFullScreenModalVariantFullScreenModalType.UNRECOGNIZED;
    }
}
exports.serverSideFullScreenModalVariantFullScreenModalTypeFromJSON = serverSideFullScreenModalVariantFullScreenModalTypeFromJSON;
function serverSideFullScreenModalVariantFullScreenModalTypeToJSON(object) {
    switch (object) {
        case ServerSideFullScreenModalVariantFullScreenModalType.INVALID_MODAL_TYPE:
            return 'INVALID_MODAL_TYPE';
        case ServerSideFullScreenModalVariantFullScreenModalType.ADD_FUNDS:
            return 'ADD_FUNDS';
        case ServerSideFullScreenModalVariantFullScreenModalType.ADD_FUNDS_SPONSORED_ACCOUNT:
            return 'ADD_FUNDS_SPONSORED_ACCOUNT';
        case ServerSideFullScreenModalVariantFullScreenModalType.LINK_ACCOUNT:
            return 'LINK_ACCOUNT';
        case ServerSideFullScreenModalVariantFullScreenModalType.FLEX_ALMOST_DUE_3:
            return 'FLEX_ALMOST_DUE_3';
        case ServerSideFullScreenModalVariantFullScreenModalType.FLEX_DUE:
            return 'FLEX_DUE';
        case ServerSideFullScreenModalVariantFullScreenModalType.FLEX_DUE_AUTO_PAY_FAILED:
            return 'FLEX_DUE_AUTO_PAY_FAILED';
        case ServerSideFullScreenModalVariantFullScreenModalType.FLEX_AUTO_PAY_FAILED:
            return 'FLEX_AUTO_PAY_FAILED';
        case ServerSideFullScreenModalVariantFullScreenModalType.FLEX_PAST_DUE:
            return 'FLEX_PAST_DUE';
        case ServerSideFullScreenModalVariantFullScreenModalType.FLEX_PAST_DUE_60:
            return 'FLEX_PAST_DUE_60';
        case ServerSideFullScreenModalVariantFullScreenModalType.ACCOUNT_PROGRESS_COMPLETED:
            return 'ACCOUNT_PROGRESS_COMPLETED';
        case ServerSideFullScreenModalVariantFullScreenModalType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.serverSideFullScreenModalVariantFullScreenModalTypeToJSON = serverSideFullScreenModalVariantFullScreenModalTypeToJSON;
function onboardingStepBlackVariantOnboardingStepBlackModeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ONBOARDING_STEP_BLACK_MODE':
            return OnboardingStepBlackVariantOnboardingStepBlackMode.INVALID_ONBOARDING_STEP_BLACK_MODE;
        case 1:
        case 'ONBOARDING_STEP_BLACK_MODE_CONTROL':
            return OnboardingStepBlackVariantOnboardingStepBlackMode.ONBOARDING_STEP_BLACK_MODE_CONTROL;
        case 2:
        case 'ONBOARDING_STEP_BLACK_MODE_VIRTUAL_CARD':
            return OnboardingStepBlackVariantOnboardingStepBlackMode
                .ONBOARDING_STEP_BLACK_MODE_VIRTUAL_CARD;
        case 3:
        case 'ONBOARDING_STEP_BLACK_MODE_BILL_PAY':
            return OnboardingStepBlackVariantOnboardingStepBlackMode.ONBOARDING_STEP_BLACK_MODE_BILL_PAY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return OnboardingStepBlackVariantOnboardingStepBlackMode.UNRECOGNIZED;
    }
}
exports.onboardingStepBlackVariantOnboardingStepBlackModeFromJSON = onboardingStepBlackVariantOnboardingStepBlackModeFromJSON;
function onboardingStepBlackVariantOnboardingStepBlackModeToJSON(object) {
    switch (object) {
        case OnboardingStepBlackVariantOnboardingStepBlackMode.INVALID_ONBOARDING_STEP_BLACK_MODE:
            return 'INVALID_ONBOARDING_STEP_BLACK_MODE';
        case OnboardingStepBlackVariantOnboardingStepBlackMode.ONBOARDING_STEP_BLACK_MODE_CONTROL:
            return 'ONBOARDING_STEP_BLACK_MODE_CONTROL';
        case OnboardingStepBlackVariantOnboardingStepBlackMode.ONBOARDING_STEP_BLACK_MODE_VIRTUAL_CARD:
            return 'ONBOARDING_STEP_BLACK_MODE_VIRTUAL_CARD';
        case OnboardingStepBlackVariantOnboardingStepBlackMode.ONBOARDING_STEP_BLACK_MODE_BILL_PAY:
            return 'ONBOARDING_STEP_BLACK_MODE_BILL_PAY';
        case OnboardingStepBlackVariantOnboardingStepBlackMode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.onboardingStepBlackVariantOnboardingStepBlackModeToJSON = onboardingStepBlackVariantOnboardingStepBlackModeToJSON;
function birthday18OfferVariantEnrollmentTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ENROLLMENT_TYPE':
            return Birthday18OfferVariantEnrollmentType.INVALID_ENROLLMENT_TYPE;
        case 1:
        case 'ENROLLMENT_TYPE_CONTROL':
            return Birthday18OfferVariantEnrollmentType.ENROLLMENT_TYPE_CONTROL;
        case 2:
        case 'ENROLLMENT_TYPE_ACTIVE':
            return Birthday18OfferVariantEnrollmentType.ENROLLMENT_TYPE_ACTIVE;
        case 3:
        case 'ENROLLMENT_TYPE_PASSIVE':
            return Birthday18OfferVariantEnrollmentType.ENROLLMENT_TYPE_PASSIVE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Birthday18OfferVariantEnrollmentType.UNRECOGNIZED;
    }
}
exports.birthday18OfferVariantEnrollmentTypeFromJSON = birthday18OfferVariantEnrollmentTypeFromJSON;
function birthday18OfferVariantEnrollmentTypeToJSON(object) {
    switch (object) {
        case Birthday18OfferVariantEnrollmentType.INVALID_ENROLLMENT_TYPE:
            return 'INVALID_ENROLLMENT_TYPE';
        case Birthday18OfferVariantEnrollmentType.ENROLLMENT_TYPE_CONTROL:
            return 'ENROLLMENT_TYPE_CONTROL';
        case Birthday18OfferVariantEnrollmentType.ENROLLMENT_TYPE_ACTIVE:
            return 'ENROLLMENT_TYPE_ACTIVE';
        case Birthday18OfferVariantEnrollmentType.ENROLLMENT_TYPE_PASSIVE:
            return 'ENROLLMENT_TYPE_PASSIVE';
        case Birthday18OfferVariantEnrollmentType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.birthday18OfferVariantEnrollmentTypeToJSON = birthday18OfferVariantEnrollmentTypeToJSON;
function copyVariantCopyVariantGroupFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_COPY_VARIANT_GROUP':
            return CopyVariantCopyVariantGroup.INVALID_COPY_VARIANT_GROUP;
        case 1:
        case 'ALPHA':
            return CopyVariantCopyVariantGroup.ALPHA;
        case 2:
        case 'BETA':
            return CopyVariantCopyVariantGroup.BETA;
        case 3:
        case 'CONTROL':
            return CopyVariantCopyVariantGroup.CONTROL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CopyVariantCopyVariantGroup.UNRECOGNIZED;
    }
}
exports.copyVariantCopyVariantGroupFromJSON = copyVariantCopyVariantGroupFromJSON;
function copyVariantCopyVariantGroupToJSON(object) {
    switch (object) {
        case CopyVariantCopyVariantGroup.INVALID_COPY_VARIANT_GROUP:
            return 'INVALID_COPY_VARIANT_GROUP';
        case CopyVariantCopyVariantGroup.ALPHA:
            return 'ALPHA';
        case CopyVariantCopyVariantGroup.BETA:
            return 'BETA';
        case CopyVariantCopyVariantGroup.CONTROL:
            return 'CONTROL';
        case CopyVariantCopyVariantGroup.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.copyVariantCopyVariantGroupToJSON = copyVariantCopyVariantGroupToJSON;
function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=feature.js.map